export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Date: { input: any; output: any };
  DateTime: { input: string; output: string };
  Hex: { input: any; output: any };
  Json: { input: any; output: any };
  Long: { input: any; output: any };
  RGBAHue: { input: any; output: any };
  RGBATransparency: { input: any; output: any };
  RichTextAST: { input: any; output: any };
};

/** Model representing an internal voice actor prior to becoming an in-studio avatar. */
export type Actor = Entity &
  Node & {
    __typename?: 'Actor';
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<User>;
    displayName?: Maybe<Scalars['String']['output']>;
    /** Get the document in other stages */
    documentInStages: Array<Actor>;
    /** List of Actor versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    image?: Maybe<Asset>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<User>;
    scheduledIn: Array<ScheduledOperation>;
    /** System stage field */
    stage: Stage;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<User>;
    /** Auth0 User ID associated with this Actor object */
    userId: Scalars['String']['output'];
    variants: Array<ActorVariant>;
  };

/** Model representing an internal voice actor prior to becoming an in-studio avatar. */
export type ActorCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** Model representing an internal voice actor prior to becoming an in-studio avatar. */
export type ActorDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

/** Model representing an internal voice actor prior to becoming an in-studio avatar. */
export type ActorHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

/** Model representing an internal voice actor prior to becoming an in-studio avatar. */
export type ActorImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

/** Model representing an internal voice actor prior to becoming an in-studio avatar. */
export type ActorPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** Model representing an internal voice actor prior to becoming an in-studio avatar. */
export type ActorScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

/** Model representing an internal voice actor prior to becoming an in-studio avatar. */
export type ActorUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** Model representing an internal voice actor prior to becoming an in-studio avatar. */
export type ActorVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ActorVariantOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ActorVariantWhereInput>;
};

export type ActorConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ActorWhereUniqueInput;
};

/** A connection to a list of items. */
export type ActorConnection = {
  __typename?: 'ActorConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ActorEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ActorCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
  variants?: InputMaybe<ActorVariantCreateManyInlineInput>;
};

export type ActorCreateManyInlineInput = {
  /** Connect multiple existing Actor documents */
  connect?: InputMaybe<Array<ActorWhereUniqueInput>>;
  /** Create and connect multiple existing Actor documents */
  create?: InputMaybe<Array<ActorCreateInput>>;
};

export type ActorCreateOneInlineInput = {
  /** Connect one existing Actor document */
  connect?: InputMaybe<ActorWhereUniqueInput>;
  /** Create and connect one Actor document */
  create?: InputMaybe<ActorCreateInput>;
};

/** An edge in a connection. */
export type ActorEdge = {
  __typename?: 'ActorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Actor;
};

/** Identifies documents */
export type ActorManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ActorWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ActorWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ActorWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  createdBy?: InputMaybe<UserWhereInput>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  displayName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  displayName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  displayName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  displayName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  displayName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  displayName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  displayName_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  /** All values not starting with the given string. */
  displayName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  displayName_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<ActorWhereStageInput>;
  documentInStages_none?: InputMaybe<ActorWhereStageInput>;
  documentInStages_some?: InputMaybe<ActorWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  updatedBy?: InputMaybe<UserWhereInput>;
  userId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  userId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  userId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  userId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  userId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  userId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  userId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  userId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  userId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  userId_starts_with?: InputMaybe<Scalars['String']['input']>;
  variants_every?: InputMaybe<ActorVariantWhereInput>;
  variants_none?: InputMaybe<ActorVariantWhereInput>;
  variants_some?: InputMaybe<ActorVariantWhereInput>;
};

export enum ActorOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DisplayNameAsc = 'displayName_ASC',
  DisplayNameDesc = 'displayName_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  UserIdAsc = 'userId_ASC',
  UserIdDesc = 'userId_DESC',
}

export type ActorUpdateInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetUpdateOneInlineInput>;
  userId?: InputMaybe<Scalars['String']['input']>;
  variants?: InputMaybe<ActorVariantUpdateManyInlineInput>;
};

export type ActorUpdateManyInlineInput = {
  /** Connect multiple existing Actor documents */
  connect?: InputMaybe<Array<ActorConnectInput>>;
  /** Create and connect multiple Actor documents */
  create?: InputMaybe<Array<ActorCreateInput>>;
  /** Delete multiple Actor documents */
  delete?: InputMaybe<Array<ActorWhereUniqueInput>>;
  /** Disconnect multiple Actor documents */
  disconnect?: InputMaybe<Array<ActorWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Actor documents */
  set?: InputMaybe<Array<ActorWhereUniqueInput>>;
  /** Update multiple Actor documents */
  update?: InputMaybe<Array<ActorUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Actor documents */
  upsert?: InputMaybe<Array<ActorUpsertWithNestedWhereUniqueInput>>;
};

export type ActorUpdateManyInput = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ActorUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ActorUpdateManyInput;
  /** Document search */
  where: ActorWhereInput;
};

export type ActorUpdateOneInlineInput = {
  /** Connect existing Actor document */
  connect?: InputMaybe<ActorWhereUniqueInput>;
  /** Create and connect one Actor document */
  create?: InputMaybe<ActorCreateInput>;
  /** Delete currently connected Actor document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Actor document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Actor document */
  update?: InputMaybe<ActorUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Actor document */
  upsert?: InputMaybe<ActorUpsertWithNestedWhereUniqueInput>;
};

export type ActorUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ActorUpdateInput;
  /** Unique document search */
  where: ActorWhereUniqueInput;
};

export type ActorUpsertInput = {
  /** Create document if it didn't exist */
  create: ActorCreateInput;
  /** Update document if it exists */
  update: ActorUpdateInput;
};

export type ActorUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ActorUpsertInput;
  /** Unique document search */
  where: ActorWhereUniqueInput;
};

export type ActorVariant = Entity &
  Node & {
    __typename?: 'ActorVariant';
    actor?: Maybe<Actor>;
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<User>;
    /** Get the document in other stages */
    documentInStages: Array<ActorVariant>;
    /** List of ActorVariant versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    localeEnum?: Maybe<LocaleEnum>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<User>;
    scheduledIn: Array<ScheduledOperation>;
    /** System stage field */
    stage: Stage;
    style?: Maybe<AvatarVariantStyle>;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<User>;
  };

export type ActorVariantActorArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ActorVariantCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ActorVariantDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type ActorVariantHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type ActorVariantPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ActorVariantScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type ActorVariantStyleArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ActorVariantUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ActorVariantConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ActorVariantWhereUniqueInput;
};

/** A connection to a list of items. */
export type ActorVariantConnection = {
  __typename?: 'ActorVariantConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ActorVariantEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ActorVariantCreateInput = {
  actor?: InputMaybe<ActorCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  localeEnum?: InputMaybe<LocaleEnum>;
  style?: InputMaybe<AvatarVariantStyleCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ActorVariantCreateManyInlineInput = {
  /** Connect multiple existing ActorVariant documents */
  connect?: InputMaybe<Array<ActorVariantWhereUniqueInput>>;
  /** Create and connect multiple existing ActorVariant documents */
  create?: InputMaybe<Array<ActorVariantCreateInput>>;
};

export type ActorVariantCreateOneInlineInput = {
  /** Connect one existing ActorVariant document */
  connect?: InputMaybe<ActorVariantWhereUniqueInput>;
  /** Create and connect one ActorVariant document */
  create?: InputMaybe<ActorVariantCreateInput>;
};

/** An edge in a connection. */
export type ActorVariantEdge = {
  __typename?: 'ActorVariantEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ActorVariant;
};

/** Identifies documents */
export type ActorVariantManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ActorVariantWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ActorVariantWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ActorVariantWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  actor?: InputMaybe<ActorWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ActorVariantWhereStageInput>;
  documentInStages_none?: InputMaybe<ActorVariantWhereStageInput>;
  documentInStages_some?: InputMaybe<ActorVariantWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  localeEnum?: InputMaybe<LocaleEnum>;
  /** All values that are contained in given list. */
  localeEnum_in?: InputMaybe<Array<InputMaybe<LocaleEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  localeEnum_not?: InputMaybe<LocaleEnum>;
  /** All values that are not contained in given list. */
  localeEnum_not_in?: InputMaybe<Array<InputMaybe<LocaleEnum>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  style?: InputMaybe<AvatarVariantStyleWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ActorVariantOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LocaleEnumAsc = 'localeEnum_ASC',
  LocaleEnumDesc = 'localeEnum_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type ActorVariantUpdateInput = {
  actor?: InputMaybe<ActorUpdateOneInlineInput>;
  localeEnum?: InputMaybe<LocaleEnum>;
  style?: InputMaybe<AvatarVariantStyleUpdateOneInlineInput>;
};

export type ActorVariantUpdateManyInlineInput = {
  /** Connect multiple existing ActorVariant documents */
  connect?: InputMaybe<Array<ActorVariantConnectInput>>;
  /** Create and connect multiple ActorVariant documents */
  create?: InputMaybe<Array<ActorVariantCreateInput>>;
  /** Delete multiple ActorVariant documents */
  delete?: InputMaybe<Array<ActorVariantWhereUniqueInput>>;
  /** Disconnect multiple ActorVariant documents */
  disconnect?: InputMaybe<Array<ActorVariantWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ActorVariant documents */
  set?: InputMaybe<Array<ActorVariantWhereUniqueInput>>;
  /** Update multiple ActorVariant documents */
  update?: InputMaybe<Array<ActorVariantUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ActorVariant documents */
  upsert?: InputMaybe<Array<ActorVariantUpsertWithNestedWhereUniqueInput>>;
};

export type ActorVariantUpdateManyInput = {
  localeEnum?: InputMaybe<LocaleEnum>;
};

export type ActorVariantUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ActorVariantUpdateManyInput;
  /** Document search */
  where: ActorVariantWhereInput;
};

export type ActorVariantUpdateOneInlineInput = {
  /** Connect existing ActorVariant document */
  connect?: InputMaybe<ActorVariantWhereUniqueInput>;
  /** Create and connect one ActorVariant document */
  create?: InputMaybe<ActorVariantCreateInput>;
  /** Delete currently connected ActorVariant document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ActorVariant document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ActorVariant document */
  update?: InputMaybe<ActorVariantUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ActorVariant document */
  upsert?: InputMaybe<ActorVariantUpsertWithNestedWhereUniqueInput>;
};

export type ActorVariantUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ActorVariantUpdateInput;
  /** Unique document search */
  where: ActorVariantWhereUniqueInput;
};

export type ActorVariantUpsertInput = {
  /** Create document if it didn't exist */
  create: ActorVariantCreateInput;
  /** Update document if it exists */
  update: ActorVariantUpdateInput;
};

export type ActorVariantUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ActorVariantUpsertInput;
  /** Unique document search */
  where: ActorVariantWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ActorVariantWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ActorVariantWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ActorVariantWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ActorVariantWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ActorVariantWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  actor?: InputMaybe<ActorWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ActorVariantWhereStageInput>;
  documentInStages_none?: InputMaybe<ActorVariantWhereStageInput>;
  documentInStages_some?: InputMaybe<ActorVariantWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  localeEnum?: InputMaybe<LocaleEnum>;
  /** All values that are contained in given list. */
  localeEnum_in?: InputMaybe<Array<InputMaybe<LocaleEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  localeEnum_not?: InputMaybe<LocaleEnum>;
  /** All values that are not contained in given list. */
  localeEnum_not_in?: InputMaybe<Array<InputMaybe<LocaleEnum>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  style?: InputMaybe<AvatarVariantStyleWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ActorVariantWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ActorVariantWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ActorVariantWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ActorVariantWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ActorVariantWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ActorVariant record uniquely */
export type ActorVariantWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** This contains a set of filters that can be used to compare values internally */
export type ActorWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ActorWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ActorWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ActorWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ActorWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  createdBy?: InputMaybe<UserWhereInput>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  displayName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  displayName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  displayName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  displayName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  displayName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  displayName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  displayName_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  /** All values not starting with the given string. */
  displayName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  displayName_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<ActorWhereStageInput>;
  documentInStages_none?: InputMaybe<ActorWhereStageInput>;
  documentInStages_some?: InputMaybe<ActorWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  updatedBy?: InputMaybe<UserWhereInput>;
  userId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  userId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  userId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  userId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  userId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  userId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  userId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  userId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  userId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  userId_starts_with?: InputMaybe<Scalars['String']['input']>;
  variants_every?: InputMaybe<ActorVariantWhereInput>;
  variants_none?: InputMaybe<ActorVariantWhereInput>;
  variants_some?: InputMaybe<ActorVariantWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ActorWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ActorWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ActorWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ActorWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ActorWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Actor record uniquely */
export type ActorWhereUniqueInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Aggregate = {
  __typename?: 'Aggregate';
  count: Scalars['Int']['output'];
};

/** Create announcements for the user in the studio. */
export type Announcement = Entity &
  Node & {
    __typename?: 'Announcement';
    /** a range of start and end times in which the announcement is active. */
    announcementIntervals: Array<AnnouncementInterval>;
    /** The target audience of the announcement */
    audience: Array<SubscriptionType>;
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<User>;
    cta?: Maybe<AnnouncementCta>;
    /** whether or not a user can dismiss this message (default true) */
    dismissable: Scalars['Boolean']['output'];
    /** Get the document in other stages */
    documentInStages: Array<Announcement>;
    /** List of Announcement versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** A message to display to users */
    message: Scalars['String']['output'];
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<User>;
    scheduledIn: Array<ScheduledOperation>;
    /** System stage field */
    stage: Stage;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<User>;
  };

/** Create announcements for the user in the studio. */
export type AnnouncementAnnouncementIntervalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AnnouncementIntervalOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnnouncementIntervalWhereInput>;
};

/** Create announcements for the user in the studio. */
export type AnnouncementCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** Create announcements for the user in the studio. */
export type AnnouncementCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** Create announcements for the user in the studio. */
export type AnnouncementDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

/** Create announcements for the user in the studio. */
export type AnnouncementHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

/** Create announcements for the user in the studio. */
export type AnnouncementPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** Create announcements for the user in the studio. */
export type AnnouncementScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

/** Create announcements for the user in the studio. */
export type AnnouncementUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type AnnouncementConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AnnouncementWhereUniqueInput;
};

/** A connection to a list of items. */
export type AnnouncementConnection = {
  __typename?: 'AnnouncementConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AnnouncementEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AnnouncementCreateInput = {
  announcementIntervals?: InputMaybe<AnnouncementIntervalCreateManyInlineInput>;
  audience?: InputMaybe<Array<SubscriptionType>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  cta?: InputMaybe<AnnouncementCtaCreateOneInlineInput>;
  dismissable: Scalars['Boolean']['input'];
  message: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnnouncementCreateManyInlineInput = {
  /** Connect multiple existing Announcement documents */
  connect?: InputMaybe<Array<AnnouncementWhereUniqueInput>>;
  /** Create and connect multiple existing Announcement documents */
  create?: InputMaybe<Array<AnnouncementCreateInput>>;
};

export type AnnouncementCreateOneInlineInput = {
  /** Connect one existing Announcement document */
  connect?: InputMaybe<AnnouncementWhereUniqueInput>;
  /** Create and connect one Announcement document */
  create?: InputMaybe<AnnouncementCreateInput>;
};

export type AnnouncementCta = Entity & {
  __typename?: 'AnnouncementCta';
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
  text: Scalars['String']['output'];
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
};

export type AnnouncementCtaConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AnnouncementCtaWhereUniqueInput;
};

/** A connection to a list of items. */
export type AnnouncementCtaConnection = {
  __typename?: 'AnnouncementCtaConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AnnouncementCtaEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AnnouncementCtaCreateInput = {
  text: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
};

export type AnnouncementCtaCreateManyInlineInput = {
  /** Create and connect multiple existing AnnouncementCta documents */
  create?: InputMaybe<Array<AnnouncementCtaCreateInput>>;
};

export type AnnouncementCtaCreateOneInlineInput = {
  /** Create and connect one AnnouncementCta document */
  create?: InputMaybe<AnnouncementCtaCreateInput>;
};

export type AnnouncementCtaCreateWithPositionInput = {
  /** Document to create */
  data: AnnouncementCtaCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type AnnouncementCtaEdge = {
  __typename?: 'AnnouncementCtaEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AnnouncementCta;
};

/** Identifies documents */
export type AnnouncementCtaManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AnnouncementCtaWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AnnouncementCtaWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AnnouncementCtaWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  text_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  text_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  text_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  text_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  text_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  text_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  url?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum AnnouncementCtaOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC',
}

export type AnnouncementCtaParent = Announcement;

export type AnnouncementCtaParentConnectInput = {
  Announcement?: InputMaybe<AnnouncementConnectInput>;
};

export type AnnouncementCtaParentCreateInput = {
  Announcement?: InputMaybe<AnnouncementCreateInput>;
};

export type AnnouncementCtaParentCreateManyInlineInput = {
  /** Connect multiple existing AnnouncementCtaParent documents */
  connect?: InputMaybe<Array<AnnouncementCtaParentWhereUniqueInput>>;
  /** Create and connect multiple existing AnnouncementCtaParent documents */
  create?: InputMaybe<Array<AnnouncementCtaParentCreateInput>>;
};

export type AnnouncementCtaParentCreateOneInlineInput = {
  /** Connect one existing AnnouncementCtaParent document */
  connect?: InputMaybe<AnnouncementCtaParentWhereUniqueInput>;
  /** Create and connect one AnnouncementCtaParent document */
  create?: InputMaybe<AnnouncementCtaParentCreateInput>;
};

export type AnnouncementCtaParentUpdateInput = {
  Announcement?: InputMaybe<AnnouncementUpdateInput>;
};

export type AnnouncementCtaParentUpdateManyInlineInput = {
  /** Connect multiple existing AnnouncementCtaParent documents */
  connect?: InputMaybe<Array<AnnouncementCtaParentConnectInput>>;
  /** Create and connect multiple AnnouncementCtaParent documents */
  create?: InputMaybe<Array<AnnouncementCtaParentCreateInput>>;
  /** Delete multiple AnnouncementCtaParent documents */
  delete?: InputMaybe<Array<AnnouncementCtaParentWhereUniqueInput>>;
  /** Disconnect multiple AnnouncementCtaParent documents */
  disconnect?: InputMaybe<Array<AnnouncementCtaParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing AnnouncementCtaParent documents */
  set?: InputMaybe<Array<AnnouncementCtaParentWhereUniqueInput>>;
  /** Update multiple AnnouncementCtaParent documents */
  update?: InputMaybe<
    Array<AnnouncementCtaParentUpdateWithNestedWhereUniqueInput>
  >;
  /** Upsert multiple AnnouncementCtaParent documents */
  upsert?: InputMaybe<
    Array<AnnouncementCtaParentUpsertWithNestedWhereUniqueInput>
  >;
};

export type AnnouncementCtaParentUpdateManyWithNestedWhereInput = {
  Announcement?: InputMaybe<AnnouncementUpdateManyWithNestedWhereInput>;
};

export type AnnouncementCtaParentUpdateOneInlineInput = {
  /** Connect existing AnnouncementCtaParent document */
  connect?: InputMaybe<AnnouncementCtaParentWhereUniqueInput>;
  /** Create and connect one AnnouncementCtaParent document */
  create?: InputMaybe<AnnouncementCtaParentCreateInput>;
  /** Delete currently connected AnnouncementCtaParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected AnnouncementCtaParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single AnnouncementCtaParent document */
  update?: InputMaybe<AnnouncementCtaParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single AnnouncementCtaParent document */
  upsert?: InputMaybe<AnnouncementCtaParentUpsertWithNestedWhereUniqueInput>;
};

export type AnnouncementCtaParentUpdateWithNestedWhereUniqueInput = {
  Announcement?: InputMaybe<AnnouncementUpdateWithNestedWhereUniqueInput>;
};

export type AnnouncementCtaParentUpsertWithNestedWhereUniqueInput = {
  Announcement?: InputMaybe<AnnouncementUpsertWithNestedWhereUniqueInput>;
};

export type AnnouncementCtaParentWhereInput = {
  Announcement?: InputMaybe<AnnouncementWhereInput>;
};

export type AnnouncementCtaParentWhereUniqueInput = {
  Announcement?: InputMaybe<AnnouncementWhereUniqueInput>;
};

export type AnnouncementCtaUpdateInput = {
  text?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type AnnouncementCtaUpdateManyInlineInput = {
  /** Create and connect multiple AnnouncementCta component instances */
  create?: InputMaybe<Array<AnnouncementCtaCreateWithPositionInput>>;
  /** Delete multiple AnnouncementCta documents */
  delete?: InputMaybe<Array<AnnouncementCtaWhereUniqueInput>>;
  /** Update multiple AnnouncementCta component instances */
  update?: InputMaybe<
    Array<AnnouncementCtaUpdateWithNestedWhereUniqueAndPositionInput>
  >;
  /** Upsert multiple AnnouncementCta component instances */
  upsert?: InputMaybe<
    Array<AnnouncementCtaUpsertWithNestedWhereUniqueAndPositionInput>
  >;
};

export type AnnouncementCtaUpdateManyInput = {
  text?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type AnnouncementCtaUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AnnouncementCtaUpdateManyInput;
  /** Document search */
  where: AnnouncementCtaWhereInput;
};

export type AnnouncementCtaUpdateOneInlineInput = {
  /** Create and connect one AnnouncementCta document */
  create?: InputMaybe<AnnouncementCtaCreateInput>;
  /** Delete currently connected AnnouncementCta document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single AnnouncementCta document */
  update?: InputMaybe<AnnouncementCtaUpdateWithNestedWhereUniqueInput>;
  /** Upsert single AnnouncementCta document */
  upsert?: InputMaybe<AnnouncementCtaUpsertWithNestedWhereUniqueInput>;
};

export type AnnouncementCtaUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<AnnouncementCtaUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: AnnouncementCtaWhereUniqueInput;
};

export type AnnouncementCtaUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AnnouncementCtaUpdateInput;
  /** Unique document search */
  where: AnnouncementCtaWhereUniqueInput;
};

export type AnnouncementCtaUpsertInput = {
  /** Create document if it didn't exist */
  create: AnnouncementCtaCreateInput;
  /** Update document if it exists */
  update: AnnouncementCtaUpdateInput;
};

export type AnnouncementCtaUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<AnnouncementCtaUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: AnnouncementCtaWhereUniqueInput;
};

export type AnnouncementCtaUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AnnouncementCtaUpsertInput;
  /** Unique document search */
  where: AnnouncementCtaWhereUniqueInput;
};

/** Identifies documents */
export type AnnouncementCtaWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AnnouncementCtaWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AnnouncementCtaWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AnnouncementCtaWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  text_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  text_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  text_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  text_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  text_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  text_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  url?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References AnnouncementCta record uniquely */
export type AnnouncementCtaWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** An edge in a connection. */
export type AnnouncementEdge = {
  __typename?: 'AnnouncementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Announcement;
};

/** a range of dates */
export type AnnouncementInterval = Entity & {
  __typename?: 'AnnouncementInterval';
  /** the cutoff time for when an announcement should show */
  end: Scalars['DateTime']['output'];
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
  /** the start time of when an announcement should show */
  start: Scalars['DateTime']['output'];
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AnnouncementIntervalConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AnnouncementIntervalWhereUniqueInput;
};

/** A connection to a list of items. */
export type AnnouncementIntervalConnection = {
  __typename?: 'AnnouncementIntervalConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AnnouncementIntervalEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AnnouncementIntervalCreateInput = {
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnnouncementIntervalCreateManyInlineInput = {
  /** Create and connect multiple existing AnnouncementInterval documents */
  create?: InputMaybe<Array<AnnouncementIntervalCreateInput>>;
};

export type AnnouncementIntervalCreateOneInlineInput = {
  /** Create and connect one AnnouncementInterval document */
  create?: InputMaybe<AnnouncementIntervalCreateInput>;
};

export type AnnouncementIntervalCreateWithPositionInput = {
  /** Document to create */
  data: AnnouncementIntervalCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type AnnouncementIntervalEdge = {
  __typename?: 'AnnouncementIntervalEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AnnouncementInterval;
};

/** Identifies documents */
export type AnnouncementIntervalManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AnnouncementIntervalWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AnnouncementIntervalWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AnnouncementIntervalWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  end_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  end_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  end_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  end_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  end_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  end_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  end_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  start_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  start_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  start_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  start_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  start_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  start_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  start_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
};

export enum AnnouncementIntervalOrderByInput {
  EndAsc = 'end_ASC',
  EndDesc = 'end_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  StartAsc = 'start_ASC',
  StartDesc = 'start_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type AnnouncementIntervalParent = Announcement;

export type AnnouncementIntervalParentConnectInput = {
  Announcement?: InputMaybe<AnnouncementConnectInput>;
};

export type AnnouncementIntervalParentCreateInput = {
  Announcement?: InputMaybe<AnnouncementCreateInput>;
};

export type AnnouncementIntervalParentCreateManyInlineInput = {
  /** Connect multiple existing AnnouncementIntervalParent documents */
  connect?: InputMaybe<Array<AnnouncementIntervalParentWhereUniqueInput>>;
  /** Create and connect multiple existing AnnouncementIntervalParent documents */
  create?: InputMaybe<Array<AnnouncementIntervalParentCreateInput>>;
};

export type AnnouncementIntervalParentCreateOneInlineInput = {
  /** Connect one existing AnnouncementIntervalParent document */
  connect?: InputMaybe<AnnouncementIntervalParentWhereUniqueInput>;
  /** Create and connect one AnnouncementIntervalParent document */
  create?: InputMaybe<AnnouncementIntervalParentCreateInput>;
};

export type AnnouncementIntervalParentUpdateInput = {
  Announcement?: InputMaybe<AnnouncementUpdateInput>;
};

export type AnnouncementIntervalParentUpdateManyInlineInput = {
  /** Connect multiple existing AnnouncementIntervalParent documents */
  connect?: InputMaybe<Array<AnnouncementIntervalParentConnectInput>>;
  /** Create and connect multiple AnnouncementIntervalParent documents */
  create?: InputMaybe<Array<AnnouncementIntervalParentCreateInput>>;
  /** Delete multiple AnnouncementIntervalParent documents */
  delete?: InputMaybe<Array<AnnouncementIntervalParentWhereUniqueInput>>;
  /** Disconnect multiple AnnouncementIntervalParent documents */
  disconnect?: InputMaybe<Array<AnnouncementIntervalParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing AnnouncementIntervalParent documents */
  set?: InputMaybe<Array<AnnouncementIntervalParentWhereUniqueInput>>;
  /** Update multiple AnnouncementIntervalParent documents */
  update?: InputMaybe<
    Array<AnnouncementIntervalParentUpdateWithNestedWhereUniqueInput>
  >;
  /** Upsert multiple AnnouncementIntervalParent documents */
  upsert?: InputMaybe<
    Array<AnnouncementIntervalParentUpsertWithNestedWhereUniqueInput>
  >;
};

export type AnnouncementIntervalParentUpdateManyWithNestedWhereInput = {
  Announcement?: InputMaybe<AnnouncementUpdateManyWithNestedWhereInput>;
};

export type AnnouncementIntervalParentUpdateOneInlineInput = {
  /** Connect existing AnnouncementIntervalParent document */
  connect?: InputMaybe<AnnouncementIntervalParentWhereUniqueInput>;
  /** Create and connect one AnnouncementIntervalParent document */
  create?: InputMaybe<AnnouncementIntervalParentCreateInput>;
  /** Delete currently connected AnnouncementIntervalParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected AnnouncementIntervalParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single AnnouncementIntervalParent document */
  update?: InputMaybe<AnnouncementIntervalParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single AnnouncementIntervalParent document */
  upsert?: InputMaybe<AnnouncementIntervalParentUpsertWithNestedWhereUniqueInput>;
};

export type AnnouncementIntervalParentUpdateWithNestedWhereUniqueInput = {
  Announcement?: InputMaybe<AnnouncementUpdateWithNestedWhereUniqueInput>;
};

export type AnnouncementIntervalParentUpsertWithNestedWhereUniqueInput = {
  Announcement?: InputMaybe<AnnouncementUpsertWithNestedWhereUniqueInput>;
};

export type AnnouncementIntervalParentWhereInput = {
  Announcement?: InputMaybe<AnnouncementWhereInput>;
};

export type AnnouncementIntervalParentWhereUniqueInput = {
  Announcement?: InputMaybe<AnnouncementWhereUniqueInput>;
};

export type AnnouncementIntervalUpdateInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnnouncementIntervalUpdateManyInlineInput = {
  /** Create and connect multiple AnnouncementInterval component instances */
  create?: InputMaybe<Array<AnnouncementIntervalCreateWithPositionInput>>;
  /** Delete multiple AnnouncementInterval documents */
  delete?: InputMaybe<Array<AnnouncementIntervalWhereUniqueInput>>;
  /** Update multiple AnnouncementInterval component instances */
  update?: InputMaybe<
    Array<AnnouncementIntervalUpdateWithNestedWhereUniqueAndPositionInput>
  >;
  /** Upsert multiple AnnouncementInterval component instances */
  upsert?: InputMaybe<
    Array<AnnouncementIntervalUpsertWithNestedWhereUniqueAndPositionInput>
  >;
};

export type AnnouncementIntervalUpdateManyInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnnouncementIntervalUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AnnouncementIntervalUpdateManyInput;
  /** Document search */
  where: AnnouncementIntervalWhereInput;
};

export type AnnouncementIntervalUpdateOneInlineInput = {
  /** Create and connect one AnnouncementInterval document */
  create?: InputMaybe<AnnouncementIntervalCreateInput>;
  /** Delete currently connected AnnouncementInterval document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single AnnouncementInterval document */
  update?: InputMaybe<AnnouncementIntervalUpdateWithNestedWhereUniqueInput>;
  /** Upsert single AnnouncementInterval document */
  upsert?: InputMaybe<AnnouncementIntervalUpsertWithNestedWhereUniqueInput>;
};

export type AnnouncementIntervalUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<AnnouncementIntervalUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: AnnouncementIntervalWhereUniqueInput;
};

export type AnnouncementIntervalUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AnnouncementIntervalUpdateInput;
  /** Unique document search */
  where: AnnouncementIntervalWhereUniqueInput;
};

export type AnnouncementIntervalUpsertInput = {
  /** Create document if it didn't exist */
  create: AnnouncementIntervalCreateInput;
  /** Update document if it exists */
  update: AnnouncementIntervalUpdateInput;
};

export type AnnouncementIntervalUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<AnnouncementIntervalUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: AnnouncementIntervalWhereUniqueInput;
};

export type AnnouncementIntervalUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AnnouncementIntervalUpsertInput;
  /** Unique document search */
  where: AnnouncementIntervalWhereUniqueInput;
};

/** Identifies documents */
export type AnnouncementIntervalWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AnnouncementIntervalWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AnnouncementIntervalWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AnnouncementIntervalWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  end_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  end_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  end_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  end_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  end_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  end_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  end_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  start_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  start_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  start_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  start_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  start_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  start_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  start_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
};

/** References AnnouncementInterval record uniquely */
export type AnnouncementIntervalWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Identifies documents */
export type AnnouncementManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AnnouncementWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AnnouncementWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AnnouncementWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  announcementIntervals_every?: InputMaybe<AnnouncementIntervalWhereInput>;
  announcementIntervals_none?: InputMaybe<AnnouncementIntervalWhereInput>;
  announcementIntervals_some?: InputMaybe<AnnouncementIntervalWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  audience?: InputMaybe<Array<SubscriptionType>>;
  /** Matches if the field array contains *all* items provided to the filter */
  audience_contains_all?: InputMaybe<Array<SubscriptionType>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  audience_contains_none?: InputMaybe<Array<SubscriptionType>>;
  /** Matches if the field array contains at least one item provided to the filter */
  audience_contains_some?: InputMaybe<Array<SubscriptionType>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  audience_not?: InputMaybe<Array<SubscriptionType>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  createdBy?: InputMaybe<UserWhereInput>;
  cta?: InputMaybe<AnnouncementCtaWhereInput>;
  dismissable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  dismissable_not?: InputMaybe<Scalars['Boolean']['input']>;
  documentInStages_every?: InputMaybe<AnnouncementWhereStageInput>;
  documentInStages_none?: InputMaybe<AnnouncementWhereStageInput>;
  documentInStages_some?: InputMaybe<AnnouncementWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  message_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  message_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  message_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  message_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  message_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  message_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  message_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  message_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  message_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum AnnouncementOrderByInput {
  AudienceAsc = 'audience_ASC',
  AudienceDesc = 'audience_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DismissableAsc = 'dismissable_ASC',
  DismissableDesc = 'dismissable_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  MessageAsc = 'message_ASC',
  MessageDesc = 'message_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type AnnouncementUpdateInput = {
  announcementIntervals?: InputMaybe<AnnouncementIntervalUpdateManyInlineInput>;
  audience?: InputMaybe<Array<SubscriptionType>>;
  cta?: InputMaybe<AnnouncementCtaUpdateOneInlineInput>;
  dismissable?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type AnnouncementUpdateManyInlineInput = {
  /** Connect multiple existing Announcement documents */
  connect?: InputMaybe<Array<AnnouncementConnectInput>>;
  /** Create and connect multiple Announcement documents */
  create?: InputMaybe<Array<AnnouncementCreateInput>>;
  /** Delete multiple Announcement documents */
  delete?: InputMaybe<Array<AnnouncementWhereUniqueInput>>;
  /** Disconnect multiple Announcement documents */
  disconnect?: InputMaybe<Array<AnnouncementWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Announcement documents */
  set?: InputMaybe<Array<AnnouncementWhereUniqueInput>>;
  /** Update multiple Announcement documents */
  update?: InputMaybe<Array<AnnouncementUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Announcement documents */
  upsert?: InputMaybe<Array<AnnouncementUpsertWithNestedWhereUniqueInput>>;
};

export type AnnouncementUpdateManyInput = {
  audience?: InputMaybe<Array<SubscriptionType>>;
  dismissable?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type AnnouncementUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AnnouncementUpdateManyInput;
  /** Document search */
  where: AnnouncementWhereInput;
};

export type AnnouncementUpdateOneInlineInput = {
  /** Connect existing Announcement document */
  connect?: InputMaybe<AnnouncementWhereUniqueInput>;
  /** Create and connect one Announcement document */
  create?: InputMaybe<AnnouncementCreateInput>;
  /** Delete currently connected Announcement document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Announcement document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Announcement document */
  update?: InputMaybe<AnnouncementUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Announcement document */
  upsert?: InputMaybe<AnnouncementUpsertWithNestedWhereUniqueInput>;
};

export type AnnouncementUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AnnouncementUpdateInput;
  /** Unique document search */
  where: AnnouncementWhereUniqueInput;
};

export type AnnouncementUpsertInput = {
  /** Create document if it didn't exist */
  create: AnnouncementCreateInput;
  /** Update document if it exists */
  update: AnnouncementUpdateInput;
};

export type AnnouncementUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AnnouncementUpsertInput;
  /** Unique document search */
  where: AnnouncementWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AnnouncementWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type AnnouncementWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AnnouncementWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AnnouncementWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AnnouncementWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  announcementIntervals_every?: InputMaybe<AnnouncementIntervalWhereInput>;
  announcementIntervals_none?: InputMaybe<AnnouncementIntervalWhereInput>;
  announcementIntervals_some?: InputMaybe<AnnouncementIntervalWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  audience?: InputMaybe<Array<SubscriptionType>>;
  /** Matches if the field array contains *all* items provided to the filter */
  audience_contains_all?: InputMaybe<Array<SubscriptionType>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  audience_contains_none?: InputMaybe<Array<SubscriptionType>>;
  /** Matches if the field array contains at least one item provided to the filter */
  audience_contains_some?: InputMaybe<Array<SubscriptionType>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  audience_not?: InputMaybe<Array<SubscriptionType>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  createdBy?: InputMaybe<UserWhereInput>;
  cta?: InputMaybe<AnnouncementCtaWhereInput>;
  dismissable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  dismissable_not?: InputMaybe<Scalars['Boolean']['input']>;
  documentInStages_every?: InputMaybe<AnnouncementWhereStageInput>;
  documentInStages_none?: InputMaybe<AnnouncementWhereStageInput>;
  documentInStages_some?: InputMaybe<AnnouncementWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  message_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  message_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  message_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  message_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  message_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  message_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  message_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  message_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  message_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AnnouncementWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AnnouncementWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AnnouncementWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AnnouncementWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AnnouncementWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Announcement record uniquely */
export type AnnouncementWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Asset system model */
export type Asset = Entity &
  Node & {
    __typename?: 'Asset';
    audioFileContentTile: Array<ContentTile>;
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<User>;
    /** Get the document in other stages */
    documentInStages: Array<Asset>;
    /** The file name */
    fileName: Scalars['String']['output'];
    /** The file handle */
    handle: Scalars['String']['output'];
    /** The height of the file */
    height?: Maybe<Scalars['Float']['output']>;
    /** List of Asset versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    imageActor: Array<Actor>;
    imageAvatar: Array<Avatar>;
    imageContentTile: Array<ContentTile>;
    /** System Locale field */
    locale: Locale;
    /** Get the other localizations for this document */
    localizations: Array<Asset>;
    /** The mime type of the file */
    mimeType?: Maybe<Scalars['String']['output']>;
    previewAvatar: Array<Avatar>;
    previewVariant: Array<Variant>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<User>;
    scheduledIn: Array<ScheduledOperation>;
    /** The file size */
    size?: Maybe<Scalars['Float']['output']>;
    /** System stage field */
    stage: Stage;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<User>;
    /** Returns information you need to upload the asset. The type of upload is dependant on what you pass into asset creations as upload type. */
    upload?: Maybe<AssetUpload>;
    /** Get the url for the asset with provided transformations applied. */
    url: Scalars['String']['output'];
    /** The file width */
    width?: Maybe<Scalars['Float']['output']>;
  };

/** Asset system model */
export type AssetAudioFileContentTileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ContentTileOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentTileWhereInput>;
};

/** Asset system model */
export type AssetCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

/** Asset system model */
export type AssetCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** Asset system model */
export type AssetDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

/** Asset system model */
export type AssetHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

/** Asset system model */
export type AssetImageActorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ActorOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ActorWhereInput>;
};

/** Asset system model */
export type AssetImageAvatarArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AvatarOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AvatarWhereInput>;
};

/** Asset system model */
export type AssetImageContentTileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ContentTileOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentTileWhereInput>;
};

/** Asset system model */
export type AssetLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};

/** Asset system model */
export type AssetPreviewAvatarArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AvatarOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AvatarWhereInput>;
};

/** Asset system model */
export type AssetPreviewVariantArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<VariantOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VariantWhereInput>;
};

/** Asset system model */
export type AssetPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

/** Asset system model */
export type AssetPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** Asset system model */
export type AssetScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

/** Asset system model */
export type AssetUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

/** Asset system model */
export type AssetUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** Asset system model */
export type AssetUrlArgs = {
  transformation?: InputMaybe<AssetTransformationInput>;
};

export type AssetConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AssetWhereUniqueInput;
};

/** A connection to a list of items. */
export type AssetConnection = {
  __typename?: 'AssetConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AssetEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AssetCreateInput = {
  audioFileContentTile?: InputMaybe<ContentTileCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  imageActor?: InputMaybe<ActorCreateManyInlineInput>;
  imageAvatar?: InputMaybe<AvatarCreateManyInlineInput>;
  imageContentTile?: InputMaybe<ContentTileCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<AssetCreateLocalizationsInput>;
  previewAvatar?: InputMaybe<AvatarCreateManyInlineInput>;
  previewVariant?: InputMaybe<VariantCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AssetCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AssetCreateLocalizationInput = {
  /** Localization input */
  data: AssetCreateLocalizationDataInput;
  locale: Locale;
};

export type AssetCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<AssetCreateLocalizationInput>>;
};

export type AssetCreateManyInlineInput = {
  /** Connect multiple existing Asset documents */
  connect?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Create and connect multiple existing Asset documents */
  create?: InputMaybe<Array<AssetCreateInput>>;
};

export type AssetCreateOneInlineInput = {
  /** Connect one existing Asset document */
  connect?: InputMaybe<AssetWhereUniqueInput>;
  /** Create and connect one Asset document */
  create?: InputMaybe<AssetCreateInput>;
};

/** An edge in a connection. */
export type AssetEdge = {
  __typename?: 'AssetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Asset;
};

/** Identifies documents */
export type AssetManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  audioFileContentTile_every?: InputMaybe<ContentTileWhereInput>;
  audioFileContentTile_none?: InputMaybe<ContentTileWhereInput>;
  audioFileContentTile_some?: InputMaybe<ContentTileWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AssetWhereStageInput>;
  documentInStages_none?: InputMaybe<AssetWhereStageInput>;
  documentInStages_some?: InputMaybe<AssetWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageActor_every?: InputMaybe<ActorWhereInput>;
  imageActor_none?: InputMaybe<ActorWhereInput>;
  imageActor_some?: InputMaybe<ActorWhereInput>;
  imageAvatar_every?: InputMaybe<AvatarWhereInput>;
  imageAvatar_none?: InputMaybe<AvatarWhereInput>;
  imageAvatar_some?: InputMaybe<AvatarWhereInput>;
  imageContentTile_every?: InputMaybe<ContentTileWhereInput>;
  imageContentTile_none?: InputMaybe<ContentTileWhereInput>;
  imageContentTile_some?: InputMaybe<ContentTileWhereInput>;
  previewAvatar_every?: InputMaybe<AvatarWhereInput>;
  previewAvatar_none?: InputMaybe<AvatarWhereInput>;
  previewAvatar_some?: InputMaybe<AvatarWhereInput>;
  previewVariant_every?: InputMaybe<VariantWhereInput>;
  previewVariant_none?: InputMaybe<VariantWhereInput>;
  previewVariant_some?: InputMaybe<VariantWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  updatedBy?: InputMaybe<UserWhereInput>;
  upload?: InputMaybe<AssetUploadWhereInput>;
};

export enum AssetOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  FileNameAsc = 'fileName_ASC',
  FileNameDesc = 'fileName_DESC',
  HandleAsc = 'handle_ASC',
  HandleDesc = 'handle_DESC',
  HeightAsc = 'height_ASC',
  HeightDesc = 'height_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  MimeTypeAsc = 'mimeType_ASC',
  MimeTypeDesc = 'mimeType_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  WidthAsc = 'width_ASC',
  WidthDesc = 'width_DESC',
}

/** Identifies documents */
export type AssetSingleRelationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
  upload?: InputMaybe<AssetUploadWhereInput>;
};

/** Transformations for Assets */
export type AssetTransformationInput = {
  document?: InputMaybe<DocumentTransformationInput>;
  image?: InputMaybe<ImageTransformationInput>;
  /** Pass true if you want to validate the passed transformation parameters */
  validateOptions?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssetUpdateInput = {
  audioFileContentTile?: InputMaybe<ContentTileUpdateManyInlineInput>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  imageActor?: InputMaybe<ActorUpdateManyInlineInput>;
  imageAvatar?: InputMaybe<AvatarUpdateManyInlineInput>;
  imageContentTile?: InputMaybe<ContentTileUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<AssetUpdateLocalizationsInput>;
  previewAvatar?: InputMaybe<AvatarUpdateManyInlineInput>;
  previewVariant?: InputMaybe<VariantUpdateManyInlineInput>;
  /** Use this to define if its a reupload for the asset */
  reUpload?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AssetUpdateLocalizationDataInput = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** Use this to define if its a reupload for the asset */
  reUpload?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AssetUpdateLocalizationInput = {
  data: AssetUpdateLocalizationDataInput;
  locale: Locale;
};

export type AssetUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<AssetCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<AssetUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<AssetUpsertLocalizationInput>>;
};

export type AssetUpdateManyInlineInput = {
  /** Connect multiple existing Asset documents */
  connect?: InputMaybe<Array<AssetConnectInput>>;
  /** Create and connect multiple Asset documents */
  create?: InputMaybe<Array<AssetCreateInput>>;
  /** Delete multiple Asset documents */
  delete?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Disconnect multiple Asset documents */
  disconnect?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Asset documents */
  set?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Update multiple Asset documents */
  update?: InputMaybe<Array<AssetUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Asset documents */
  upsert?: InputMaybe<Array<AssetUpsertWithNestedWhereUniqueInput>>;
};

export type AssetUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']['input']>;
};

export type AssetUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AssetUpdateManyInput;
  /** Document search */
  where: AssetWhereInput;
};

export type AssetUpdateOneInlineInput = {
  /** Connect existing Asset document */
  connect?: InputMaybe<AssetWhereUniqueInput>;
  /** Create and connect one Asset document */
  create?: InputMaybe<AssetCreateInput>;
  /** Delete currently connected Asset document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Asset document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Asset document */
  update?: InputMaybe<AssetUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Asset document */
  upsert?: InputMaybe<AssetUpsertWithNestedWhereUniqueInput>;
};

export type AssetUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AssetUpdateInput;
  /** Unique document search */
  where: AssetWhereUniqueInput;
};

/** Asset Upload */
export type AssetUpload = {
  __typename?: 'AssetUpload';
  /** Asset Upload Error */
  error?: Maybe<AssetUploadError>;
  /** Expiry Timestamp */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Asset Request Data for upload */
  requestPostData?: Maybe<AssetUploadRequestPostData>;
  /** Asset Request Data for upload */
  status?: Maybe<AssetUploadStatus>;
};

/** Represents asset upload error */
export type AssetUploadError = {
  __typename?: 'AssetUploadError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** Asset Upload Request Post Data */
export type AssetUploadRequestPostData = {
  __typename?: 'AssetUploadRequestPostData';
  /** The algorithm to use in the form field. This value should be passed in the `X-Amz-Algorithm` form field. */
  algorithm: Scalars['String']['output'];
  /** The credential to use in the form field. This value should be passed in the `X-Amz-Credential` form field. */
  credential: Scalars['String']['output'];
  /** The date the request was signed, formatted as YYYYMMDDTHHMMSSZ. This value should be passed in the `X-Amz-Date` header. */
  date: Scalars['String']['output'];
  /** The key to use in the form field. This value should be passed in the `Key` form field. */
  key: Scalars['String']['output'];
  /** The policy to use in the form field. This value should be passed in the `Policy` form field. */
  policy: Scalars['String']['output'];
  /** The security token to use in the form field. This field is optional only pass it if its not null. This value should be passed in the `X-Amz-Security-Token` form field if not null. */
  securityToken?: Maybe<Scalars['String']['output']>;
  /** The signature to use in the form field. This value should be passed in the `X-Amz-Signature` form field. */
  signature: Scalars['String']['output'];
  /** The URL to which the file should be uploaded with a POST request. */
  url: Scalars['String']['output'];
};

/** System Asset Upload Status */
export enum AssetUploadStatus {
  AssetCreatePending = 'ASSET_CREATE_PENDING',
  AssetErrorUpload = 'ASSET_ERROR_UPLOAD',
  AssetUpdatePending = 'ASSET_UPDATE_PENDING',
  AssetUploadComplete = 'ASSET_UPLOAD_COMPLETE',
}

/** Identifies documents */
export type AssetUploadWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetUploadWhereInput>>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  expiresAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  expiresAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  expiresAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  expiresAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  expiresAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  expiresAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  expiresAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  status?: InputMaybe<AssetUploadStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<AssetUploadStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
};

/** Identifies documents */
export type AssetUploadWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetUploadWhereInput>>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  expiresAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  expiresAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  expiresAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  expiresAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  expiresAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  expiresAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  expiresAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  status?: InputMaybe<AssetUploadStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<AssetUploadStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
};

export type AssetUpsertInput = {
  /** Create document if it didn't exist */
  create: AssetCreateInput;
  /** Update document if it exists */
  update: AssetUpdateInput;
};

export type AssetUpsertLocalizationInput = {
  create: AssetCreateLocalizationDataInput;
  locale: Locale;
  update: AssetUpdateLocalizationDataInput;
};

export type AssetUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AssetUpsertInput;
  /** Unique document search */
  where: AssetWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AssetWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type AssetWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  audioFileContentTile_every?: InputMaybe<ContentTileWhereInput>;
  audioFileContentTile_none?: InputMaybe<ContentTileWhereInput>;
  audioFileContentTile_some?: InputMaybe<ContentTileWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AssetWhereStageInput>;
  documentInStages_none?: InputMaybe<AssetWhereStageInput>;
  documentInStages_some?: InputMaybe<AssetWhereStageInput>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fileName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fileName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fileName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fileName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fileName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fileName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fileName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fileName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fileName_starts_with?: InputMaybe<Scalars['String']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  handle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  handle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  handle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  handle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  handle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  handle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  handle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  handle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  handle_starts_with?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  height_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  height_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  height_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  height_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  height_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageActor_every?: InputMaybe<ActorWhereInput>;
  imageActor_none?: InputMaybe<ActorWhereInput>;
  imageActor_some?: InputMaybe<ActorWhereInput>;
  imageAvatar_every?: InputMaybe<AvatarWhereInput>;
  imageAvatar_none?: InputMaybe<AvatarWhereInput>;
  imageAvatar_some?: InputMaybe<AvatarWhereInput>;
  imageContentTile_every?: InputMaybe<ContentTileWhereInput>;
  imageContentTile_none?: InputMaybe<ContentTileWhereInput>;
  imageContentTile_some?: InputMaybe<ContentTileWhereInput>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  mimeType_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  mimeType_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  mimeType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  mimeType_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  mimeType_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  mimeType_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  mimeType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  mimeType_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  mimeType_starts_with?: InputMaybe<Scalars['String']['input']>;
  previewAvatar_every?: InputMaybe<AvatarWhereInput>;
  previewAvatar_none?: InputMaybe<AvatarWhereInput>;
  previewAvatar_some?: InputMaybe<AvatarWhereInput>;
  previewVariant_every?: InputMaybe<VariantWhereInput>;
  previewVariant_none?: InputMaybe<VariantWhereInput>;
  previewVariant_some?: InputMaybe<VariantWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  size?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  size_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  size_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  size_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  size_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  size_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  updatedBy?: InputMaybe<UserWhereInput>;
  upload?: InputMaybe<AssetUploadWhereInput>;
  width?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  width_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  width_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  width_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  width_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  width_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  width_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  width_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AssetWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AssetWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Asset record uniquely */
export type AssetWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** User Auth0 Roles */
export type Auth0Role = Entity &
  Node & {
    __typename?: 'Auth0Role';
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<User>;
    description?: Maybe<Scalars['String']['output']>;
    /** Get the document in other stages */
    documentInStages: Array<Auth0Role>;
    /** List of Auth0Role versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    name?: Maybe<Scalars['String']['output']>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<User>;
    /** role id from auth0 */
    roleId: Scalars['String']['output'];
    scheduledIn: Array<ScheduledOperation>;
    /** System stage field */
    stage: Stage;
    tenant: Auth0Tenant;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<User>;
  };

/** User Auth0 Roles */
export type Auth0RoleCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** User Auth0 Roles */
export type Auth0RoleDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

/** User Auth0 Roles */
export type Auth0RoleHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

/** User Auth0 Roles */
export type Auth0RolePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** User Auth0 Roles */
export type Auth0RoleScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

/** User Auth0 Roles */
export type Auth0RoleUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type Auth0RoleConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: Auth0RoleWhereUniqueInput;
};

/** A connection to a list of items. */
export type Auth0RoleConnection = {
  __typename?: 'Auth0RoleConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<Auth0RoleEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type Auth0RoleCreateInput = {
  cl6qkp2lc35vu01ujbigjblht?: InputMaybe<AvatarCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  roleId: Scalars['String']['input'];
  tenant: Auth0Tenant;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Auth0RoleCreateManyInlineInput = {
  /** Connect multiple existing Auth0Role documents */
  connect?: InputMaybe<Array<Auth0RoleWhereUniqueInput>>;
  /** Create and connect multiple existing Auth0Role documents */
  create?: InputMaybe<Array<Auth0RoleCreateInput>>;
};

export type Auth0RoleCreateOneInlineInput = {
  /** Connect one existing Auth0Role document */
  connect?: InputMaybe<Auth0RoleWhereUniqueInput>;
  /** Create and connect one Auth0Role document */
  create?: InputMaybe<Auth0RoleCreateInput>;
};

/** An edge in a connection. */
export type Auth0RoleEdge = {
  __typename?: 'Auth0RoleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Auth0Role;
};

/** Identifies documents */
export type Auth0RoleManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<Auth0RoleWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<Auth0RoleWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<Auth0RoleWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<Auth0RoleWhereStageInput>;
  documentInStages_none?: InputMaybe<Auth0RoleWhereStageInput>;
  documentInStages_some?: InputMaybe<Auth0RoleWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  publishedBy?: InputMaybe<UserWhereInput>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  roleId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  roleId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  roleId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  roleId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  roleId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  roleId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  roleId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  roleId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  roleId_starts_with?: InputMaybe<Scalars['String']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  tenant?: InputMaybe<Auth0Tenant>;
  /** All values that are contained in given list. */
  tenant_in?: InputMaybe<Array<InputMaybe<Auth0Tenant>>>;
  /** Any other value that exists and is not equal to the given value. */
  tenant_not?: InputMaybe<Auth0Tenant>;
  /** All values that are not contained in given list. */
  tenant_not_in?: InputMaybe<Array<InputMaybe<Auth0Tenant>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum Auth0RoleOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  RoleIdAsc = 'roleId_ASC',
  RoleIdDesc = 'roleId_DESC',
  TenantAsc = 'tenant_ASC',
  TenantDesc = 'tenant_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type Auth0RoleUpdateInput = {
  cl6qkp2lc35vu01ujbigjblht?: InputMaybe<AvatarUpdateManyInlineInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Auth0Tenant>;
};

export type Auth0RoleUpdateManyInlineInput = {
  /** Connect multiple existing Auth0Role documents */
  connect?: InputMaybe<Array<Auth0RoleConnectInput>>;
  /** Create and connect multiple Auth0Role documents */
  create?: InputMaybe<Array<Auth0RoleCreateInput>>;
  /** Delete multiple Auth0Role documents */
  delete?: InputMaybe<Array<Auth0RoleWhereUniqueInput>>;
  /** Disconnect multiple Auth0Role documents */
  disconnect?: InputMaybe<Array<Auth0RoleWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Auth0Role documents */
  set?: InputMaybe<Array<Auth0RoleWhereUniqueInput>>;
  /** Update multiple Auth0Role documents */
  update?: InputMaybe<Array<Auth0RoleUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Auth0Role documents */
  upsert?: InputMaybe<Array<Auth0RoleUpsertWithNestedWhereUniqueInput>>;
};

export type Auth0RoleUpdateManyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Auth0Tenant>;
};

export type Auth0RoleUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: Auth0RoleUpdateManyInput;
  /** Document search */
  where: Auth0RoleWhereInput;
};

export type Auth0RoleUpdateOneInlineInput = {
  /** Connect existing Auth0Role document */
  connect?: InputMaybe<Auth0RoleWhereUniqueInput>;
  /** Create and connect one Auth0Role document */
  create?: InputMaybe<Auth0RoleCreateInput>;
  /** Delete currently connected Auth0Role document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Auth0Role document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Auth0Role document */
  update?: InputMaybe<Auth0RoleUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Auth0Role document */
  upsert?: InputMaybe<Auth0RoleUpsertWithNestedWhereUniqueInput>;
};

export type Auth0RoleUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: Auth0RoleUpdateInput;
  /** Unique document search */
  where: Auth0RoleWhereUniqueInput;
};

export type Auth0RoleUpsertInput = {
  /** Create document if it didn't exist */
  create: Auth0RoleCreateInput;
  /** Update document if it exists */
  update: Auth0RoleUpdateInput;
};

export type Auth0RoleUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: Auth0RoleUpsertInput;
  /** Unique document search */
  where: Auth0RoleWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type Auth0RoleWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type Auth0RoleWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<Auth0RoleWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<Auth0RoleWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<Auth0RoleWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<Auth0RoleWhereStageInput>;
  documentInStages_none?: InputMaybe<Auth0RoleWhereStageInput>;
  documentInStages_some?: InputMaybe<Auth0RoleWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  publishedBy?: InputMaybe<UserWhereInput>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  roleId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  roleId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  roleId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  roleId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  roleId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  roleId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  roleId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  roleId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  roleId_starts_with?: InputMaybe<Scalars['String']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  tenant?: InputMaybe<Auth0Tenant>;
  /** All values that are contained in given list. */
  tenant_in?: InputMaybe<Array<InputMaybe<Auth0Tenant>>>;
  /** Any other value that exists and is not equal to the given value. */
  tenant_not?: InputMaybe<Auth0Tenant>;
  /** All values that are not contained in given list. */
  tenant_not_in?: InputMaybe<Array<InputMaybe<Auth0Tenant>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type Auth0RoleWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<Auth0RoleWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<Auth0RoleWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<Auth0RoleWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<Auth0RoleWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Auth0Role record uniquely */
export type Auth0RoleWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
};

/** Different auth0 environments */
export enum Auth0Tenant {
  Production = 'production',
  Staging = 'staging',
}

/** A representation of a voice actor. */
export type Avatar = Entity &
  Node & {
    __typename?: 'Avatar';
    auth0Roles: Array<Auth0Role>;
    /** A unique identifier to identify the avatar - (a temporary addition) */
    avatarId: Scalars['Int']['output'];
    avatarPools: Array<AvatarPool>;
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<User>;
    /** initials for avatar */
    displayInitials?: Maybe<Scalars['String']['output']>;
    /** The first name of our voice actor avatar. */
    displayName: Scalars['String']['output'];
    /** Get the document in other stages */
    documentInStages: Array<Avatar>;
    /** Gender of the avatar */
    gender?: Maybe<AvatarGender>;
    /** List of Avatar versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** Image for our avatar to display in studio */
    image: Asset;
    /** A true/false value if this actor is archived (currently unavailable in app) */
    isArchived: Scalars['Boolean']['output'];
    /** A true/false value if the actor is custom or not. */
    isCustom: Scalars['Boolean']['output'];
    /** Base Sample (audio) */
    preview?: Maybe<Asset>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<User>;
    scheduledIn: Array<ScheduledOperation>;
    /** denotes avatar rendering capability source */
    source?: Maybe<AvatarSource>;
    /** System stage field */
    stage: Stage;
    /** Tags associated with the avatar */
    tags: Array<AvatarTaggingAttribute>;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<User>;
    /**
     * The variants of an avatar (IE avatar + locale + style)
     *
     * IE: Ramona J Narration US
     */
    variants: Array<Variant>;
  };

/** A representation of a voice actor. */
export type AvatarAuth0RolesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<Auth0RoleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Auth0RoleWhereInput>;
};

/** A representation of a voice actor. */
export type AvatarAvatarPoolsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AvatarPoolOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AvatarPoolWhereInput>;
};

/** A representation of a voice actor. */
export type AvatarCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** A representation of a voice actor. */
export type AvatarDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

/** A representation of a voice actor. */
export type AvatarHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

/** A representation of a voice actor. */
export type AvatarImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

/** A representation of a voice actor. */
export type AvatarPreviewArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

/** A representation of a voice actor. */
export type AvatarPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** A representation of a voice actor. */
export type AvatarScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

/** A representation of a voice actor. */
export type AvatarTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AvatarTaggingAttributeOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AvatarTaggingAttributeWhereInput>;
};

/** A representation of a voice actor. */
export type AvatarUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** A representation of a voice actor. */
export type AvatarVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<VariantOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VariantWhereInput>;
};

export type AvatarConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AvatarWhereUniqueInput;
};

/** A connection to a list of items. */
export type AvatarConnection = {
  __typename?: 'AvatarConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AvatarEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AvatarCreateInput = {
  auth0Roles?: InputMaybe<Auth0RoleCreateManyInlineInput>;
  avatarId: Scalars['Int']['input'];
  avatarPools?: InputMaybe<AvatarPoolCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayInitials?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  gender?: InputMaybe<AvatarGender>;
  image: AssetCreateOneInlineInput;
  isArchived: Scalars['Boolean']['input'];
  isCustom: Scalars['Boolean']['input'];
  preview?: InputMaybe<AssetCreateOneInlineInput>;
  source?: InputMaybe<AvatarSource>;
  tags?: InputMaybe<AvatarTaggingAttributeCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  variants?: InputMaybe<VariantCreateManyInlineInput>;
};

export type AvatarCreateManyInlineInput = {
  /** Connect multiple existing Avatar documents */
  connect?: InputMaybe<Array<AvatarWhereUniqueInput>>;
  /** Create and connect multiple existing Avatar documents */
  create?: InputMaybe<Array<AvatarCreateInput>>;
};

export type AvatarCreateOneInlineInput = {
  /** Connect one existing Avatar document */
  connect?: InputMaybe<AvatarWhereUniqueInput>;
  /** Create and connect one Avatar document */
  create?: InputMaybe<AvatarCreateInput>;
};

/** An edge in a connection. */
export type AvatarEdge = {
  __typename?: 'AvatarEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Avatar;
};

export enum AvatarGender {
  Female = 'female',
  Male = 'male',
  Nonbinary = 'nonbinary',
}

/** Identifies documents */
export type AvatarManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AvatarWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AvatarWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AvatarWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  auth0Roles_every?: InputMaybe<Auth0RoleWhereInput>;
  auth0Roles_none?: InputMaybe<Auth0RoleWhereInput>;
  auth0Roles_some?: InputMaybe<Auth0RoleWhereInput>;
  avatarId?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  avatarId_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  avatarId_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  avatarId_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  avatarId_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  avatarId_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  avatarId_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  avatarId_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  avatarPools_every?: InputMaybe<AvatarPoolWhereInput>;
  avatarPools_none?: InputMaybe<AvatarPoolWhereInput>;
  avatarPools_some?: InputMaybe<AvatarPoolWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  createdBy?: InputMaybe<UserWhereInput>;
  displayInitials?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  displayInitials_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  displayInitials_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  displayInitials_in?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  /** Any other value that exists and is not equal to the given value. */
  displayInitials_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  displayInitials_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  displayInitials_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  displayInitials_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  /** All values not starting with the given string. */
  displayInitials_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  displayInitials_starts_with?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  displayName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  displayName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  displayName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  displayName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  displayName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  displayName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  displayName_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  /** All values not starting with the given string. */
  displayName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  displayName_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<AvatarWhereStageInput>;
  documentInStages_none?: InputMaybe<AvatarWhereStageInput>;
  documentInStages_some?: InputMaybe<AvatarWhereStageInput>;
  gender?: InputMaybe<AvatarGender>;
  /** All values that are contained in given list. */
  gender_in?: InputMaybe<Array<InputMaybe<AvatarGender>>>;
  /** Any other value that exists and is not equal to the given value. */
  gender_not?: InputMaybe<AvatarGender>;
  /** All values that are not contained in given list. */
  gender_not_in?: InputMaybe<Array<InputMaybe<AvatarGender>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isArchived_not?: InputMaybe<Scalars['Boolean']['input']>;
  isCustom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isCustom_not?: InputMaybe<Scalars['Boolean']['input']>;
  preview?: InputMaybe<AssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  source?: InputMaybe<AvatarSource>;
  /** All values that are contained in given list. */
  source_in?: InputMaybe<Array<InputMaybe<AvatarSource>>>;
  /** Any other value that exists and is not equal to the given value. */
  source_not?: InputMaybe<AvatarSource>;
  /** All values that are not contained in given list. */
  source_not_in?: InputMaybe<Array<InputMaybe<AvatarSource>>>;
  tags_every?: InputMaybe<AvatarTaggingAttributeWhereInput>;
  tags_none?: InputMaybe<AvatarTaggingAttributeWhereInput>;
  tags_some?: InputMaybe<AvatarTaggingAttributeWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  updatedBy?: InputMaybe<UserWhereInput>;
  variants_every?: InputMaybe<VariantWhereInput>;
  variants_none?: InputMaybe<VariantWhereInput>;
  variants_some?: InputMaybe<VariantWhereInput>;
};

export enum AvatarOrderByInput {
  AvatarIdAsc = 'avatarId_ASC',
  AvatarIdDesc = 'avatarId_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DisplayInitialsAsc = 'displayInitials_ASC',
  DisplayInitialsDesc = 'displayInitials_DESC',
  DisplayNameAsc = 'displayName_ASC',
  DisplayNameDesc = 'displayName_DESC',
  GenderAsc = 'gender_ASC',
  GenderDesc = 'gender_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsArchivedAsc = 'isArchived_ASC',
  IsArchivedDesc = 'isArchived_DESC',
  IsCustomAsc = 'isCustom_ASC',
  IsCustomDesc = 'isCustom_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SourceAsc = 'source_ASC',
  SourceDesc = 'source_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type AvatarPool = Entity &
  Node & {
    __typename?: 'AvatarPool';
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<User>;
    /** describes the access level in a human readable format */
    description: Scalars['String']['output'];
    /** Get the document in other stages */
    documentInStages: Array<AvatarPool>;
    /** List of AvatarPool versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** A human readable label of the pool identity */
    name: Scalars['String']['output'];
    /** pool identity which intersects with a users feature pool identites */
    poolId: Scalars['String']['output'];
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<User>;
    scheduledIn: Array<ScheduledOperation>;
    /** System stage field */
    stage: Stage;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<User>;
  };

export type AvatarPoolCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type AvatarPoolDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type AvatarPoolHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type AvatarPoolPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type AvatarPoolScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type AvatarPoolUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type AvatarPoolConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AvatarPoolWhereUniqueInput;
};

/** A connection to a list of items. */
export type AvatarPoolConnection = {
  __typename?: 'AvatarPoolConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AvatarPoolEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AvatarPoolCreateInput = {
  cm393bl6u05vb07n7cat1782a?: InputMaybe<AvatarCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  poolId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AvatarPoolCreateManyInlineInput = {
  /** Connect multiple existing AvatarPool documents */
  connect?: InputMaybe<Array<AvatarPoolWhereUniqueInput>>;
  /** Create and connect multiple existing AvatarPool documents */
  create?: InputMaybe<Array<AvatarPoolCreateInput>>;
};

export type AvatarPoolCreateOneInlineInput = {
  /** Connect one existing AvatarPool document */
  connect?: InputMaybe<AvatarPoolWhereUniqueInput>;
  /** Create and connect one AvatarPool document */
  create?: InputMaybe<AvatarPoolCreateInput>;
};

/** An edge in a connection. */
export type AvatarPoolEdge = {
  __typename?: 'AvatarPoolEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AvatarPool;
};

/** Identifies documents */
export type AvatarPoolManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AvatarPoolWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AvatarPoolWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AvatarPoolWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<AvatarPoolWhereStageInput>;
  documentInStages_none?: InputMaybe<AvatarPoolWhereStageInput>;
  documentInStages_some?: InputMaybe<AvatarPoolWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  poolId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  poolId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  poolId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  poolId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  poolId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  poolId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  poolId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  poolId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  poolId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  poolId_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum AvatarPoolOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PoolIdAsc = 'poolId_ASC',
  PoolIdDesc = 'poolId_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type AvatarPoolUpdateInput = {
  cm393bl6u05vb07n7cat1782a?: InputMaybe<AvatarUpdateManyInlineInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  poolId?: InputMaybe<Scalars['String']['input']>;
};

export type AvatarPoolUpdateManyInlineInput = {
  /** Connect multiple existing AvatarPool documents */
  connect?: InputMaybe<Array<AvatarPoolConnectInput>>;
  /** Create and connect multiple AvatarPool documents */
  create?: InputMaybe<Array<AvatarPoolCreateInput>>;
  /** Delete multiple AvatarPool documents */
  delete?: InputMaybe<Array<AvatarPoolWhereUniqueInput>>;
  /** Disconnect multiple AvatarPool documents */
  disconnect?: InputMaybe<Array<AvatarPoolWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing AvatarPool documents */
  set?: InputMaybe<Array<AvatarPoolWhereUniqueInput>>;
  /** Update multiple AvatarPool documents */
  update?: InputMaybe<Array<AvatarPoolUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple AvatarPool documents */
  upsert?: InputMaybe<Array<AvatarPoolUpsertWithNestedWhereUniqueInput>>;
};

export type AvatarPoolUpdateManyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AvatarPoolUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AvatarPoolUpdateManyInput;
  /** Document search */
  where: AvatarPoolWhereInput;
};

export type AvatarPoolUpdateOneInlineInput = {
  /** Connect existing AvatarPool document */
  connect?: InputMaybe<AvatarPoolWhereUniqueInput>;
  /** Create and connect one AvatarPool document */
  create?: InputMaybe<AvatarPoolCreateInput>;
  /** Delete currently connected AvatarPool document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected AvatarPool document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single AvatarPool document */
  update?: InputMaybe<AvatarPoolUpdateWithNestedWhereUniqueInput>;
  /** Upsert single AvatarPool document */
  upsert?: InputMaybe<AvatarPoolUpsertWithNestedWhereUniqueInput>;
};

export type AvatarPoolUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AvatarPoolUpdateInput;
  /** Unique document search */
  where: AvatarPoolWhereUniqueInput;
};

export type AvatarPoolUpsertInput = {
  /** Create document if it didn't exist */
  create: AvatarPoolCreateInput;
  /** Update document if it exists */
  update: AvatarPoolUpdateInput;
};

export type AvatarPoolUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AvatarPoolUpsertInput;
  /** Unique document search */
  where: AvatarPoolWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AvatarPoolWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type AvatarPoolWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AvatarPoolWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AvatarPoolWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AvatarPoolWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<AvatarPoolWhereStageInput>;
  documentInStages_none?: InputMaybe<AvatarPoolWhereStageInput>;
  documentInStages_some?: InputMaybe<AvatarPoolWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  poolId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  poolId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  poolId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  poolId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  poolId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  poolId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  poolId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  poolId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  poolId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  poolId_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AvatarPoolWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AvatarPoolWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AvatarPoolWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AvatarPoolWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AvatarPoolWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References AvatarPool record uniquely */
export type AvatarPoolWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  poolId?: InputMaybe<Scalars['String']['input']>;
};

export enum AvatarReleaseVersion {
  Beta = 'beta',
  Latest = 'latest',
  Preview = 'preview',
  Previous = 'previous',
}

/** Property which denotes avatar text to speech rendering source */
export enum AvatarSource {
  Azure = 'azure',
  Wellsaid = 'wellsaid',
}

/** Object representing a single tag for an avatar or avatar variant */
export type AvatarTaggingAttribute = Entity &
  Node & {
    __typename?: 'AvatarTaggingAttribute';
    /** Value of avatar tag */
    attribute: Scalars['String']['output'];
    /** Section of Voice Attributes modal that tag will be added to */
    category: AvatarTaggingAttributeCategoryEnum;
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<User>;
    /** Get the document in other stages */
    documentInStages: Array<AvatarTaggingAttribute>;
    /** List of AvatarTaggingAttribute versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** Whether or not the tag is for internal use only (i.e. not displayed to customers) */
    internalTag: Scalars['Boolean']['output'];
    /** System Locale field */
    locale: Locale;
    /** Get the other localizations for this document */
    localizations: Array<AvatarTaggingAttribute>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<User>;
    scheduledIn: Array<ScheduledOperation>;
    /** System stage field */
    stage: Stage;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<User>;
  };

/** Object representing a single tag for an avatar or avatar variant */
export type AvatarTaggingAttributeCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

/** Object representing a single tag for an avatar or avatar variant */
export type AvatarTaggingAttributeCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** Object representing a single tag for an avatar or avatar variant */
export type AvatarTaggingAttributeDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

/** Object representing a single tag for an avatar or avatar variant */
export type AvatarTaggingAttributeHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

/** Object representing a single tag for an avatar or avatar variant */
export type AvatarTaggingAttributeLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};

/** Object representing a single tag for an avatar or avatar variant */
export type AvatarTaggingAttributePublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

/** Object representing a single tag for an avatar or avatar variant */
export type AvatarTaggingAttributePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** Object representing a single tag for an avatar or avatar variant */
export type AvatarTaggingAttributeScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

/** Object representing a single tag for an avatar or avatar variant */
export type AvatarTaggingAttributeUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

/** Object representing a single tag for an avatar or avatar variant */
export type AvatarTaggingAttributeUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** Categories which avatar tags belong to */
export enum AvatarTaggingAttributeCategoryEnum {
  Age = 'AGE',
  Beta = 'BETA',
  Custom = 'CUSTOM',
  Featured = 'FEATURED',
  Gender = 'GENDER',
  New = 'NEW',
  Recommended = 'RECOMMENDED',
  RegionalAccents = 'REGIONAL_ACCENTS',
  Testing = 'TESTING',
  VoiceCharacteristics = 'VOICE_CHARACTERISTICS',
}

export type AvatarTaggingAttributeConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AvatarTaggingAttributeWhereUniqueInput;
};

/** A connection to a list of items. */
export type AvatarTaggingAttributeConnection = {
  __typename?: 'AvatarTaggingAttributeConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AvatarTaggingAttributeEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AvatarTaggingAttributeCreateInput = {
  /** attribute input for default locale (en) */
  attribute: Scalars['String']['input'];
  category: AvatarTaggingAttributeCategoryEnum;
  cleyglghy09up01t7735l4o7i?: InputMaybe<AvatarCreateManyInlineInput>;
  cleygn2c30a9i01ug0tow27x0?: InputMaybe<VariantCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  internalTag: Scalars['Boolean']['input'];
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<AvatarTaggingAttributeCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AvatarTaggingAttributeCreateLocalizationDataInput = {
  attribute: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AvatarTaggingAttributeCreateLocalizationInput = {
  /** Localization input */
  data: AvatarTaggingAttributeCreateLocalizationDataInput;
  locale: Locale;
};

export type AvatarTaggingAttributeCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<AvatarTaggingAttributeCreateLocalizationInput>>;
};

export type AvatarTaggingAttributeCreateManyInlineInput = {
  /** Connect multiple existing AvatarTaggingAttribute documents */
  connect?: InputMaybe<Array<AvatarTaggingAttributeWhereUniqueInput>>;
  /** Create and connect multiple existing AvatarTaggingAttribute documents */
  create?: InputMaybe<Array<AvatarTaggingAttributeCreateInput>>;
};

export type AvatarTaggingAttributeCreateOneInlineInput = {
  /** Connect one existing AvatarTaggingAttribute document */
  connect?: InputMaybe<AvatarTaggingAttributeWhereUniqueInput>;
  /** Create and connect one AvatarTaggingAttribute document */
  create?: InputMaybe<AvatarTaggingAttributeCreateInput>;
};

/** An edge in a connection. */
export type AvatarTaggingAttributeEdge = {
  __typename?: 'AvatarTaggingAttributeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AvatarTaggingAttribute;
};

/** Identifies documents */
export type AvatarTaggingAttributeManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AvatarTaggingAttributeWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AvatarTaggingAttributeWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AvatarTaggingAttributeWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<AvatarTaggingAttributeCategoryEnum>;
  /** All values that are contained in given list. */
  category_in?: InputMaybe<
    Array<InputMaybe<AvatarTaggingAttributeCategoryEnum>>
  >;
  /** Any other value that exists and is not equal to the given value. */
  category_not?: InputMaybe<AvatarTaggingAttributeCategoryEnum>;
  /** All values that are not contained in given list. */
  category_not_in?: InputMaybe<
    Array<InputMaybe<AvatarTaggingAttributeCategoryEnum>>
  >;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AvatarTaggingAttributeWhereStageInput>;
  documentInStages_none?: InputMaybe<AvatarTaggingAttributeWhereStageInput>;
  documentInStages_some?: InputMaybe<AvatarTaggingAttributeWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalTag?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  internalTag_not?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum AvatarTaggingAttributeOrderByInput {
  AttributeAsc = 'attribute_ASC',
  AttributeDesc = 'attribute_DESC',
  CategoryAsc = 'category_ASC',
  CategoryDesc = 'category_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalTagAsc = 'internalTag_ASC',
  InternalTagDesc = 'internalTag_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type AvatarTaggingAttributeUpdateInput = {
  /** attribute input for default locale (en) */
  attribute?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<AvatarTaggingAttributeCategoryEnum>;
  cleyglghy09up01t7735l4o7i?: InputMaybe<AvatarUpdateManyInlineInput>;
  cleygn2c30a9i01ug0tow27x0?: InputMaybe<VariantUpdateManyInlineInput>;
  internalTag?: InputMaybe<Scalars['Boolean']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<AvatarTaggingAttributeUpdateLocalizationsInput>;
};

export type AvatarTaggingAttributeUpdateLocalizationDataInput = {
  attribute?: InputMaybe<Scalars['String']['input']>;
};

export type AvatarTaggingAttributeUpdateLocalizationInput = {
  data: AvatarTaggingAttributeUpdateLocalizationDataInput;
  locale: Locale;
};

export type AvatarTaggingAttributeUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<AvatarTaggingAttributeCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<AvatarTaggingAttributeUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<AvatarTaggingAttributeUpsertLocalizationInput>>;
};

export type AvatarTaggingAttributeUpdateManyInlineInput = {
  /** Connect multiple existing AvatarTaggingAttribute documents */
  connect?: InputMaybe<Array<AvatarTaggingAttributeConnectInput>>;
  /** Create and connect multiple AvatarTaggingAttribute documents */
  create?: InputMaybe<Array<AvatarTaggingAttributeCreateInput>>;
  /** Delete multiple AvatarTaggingAttribute documents */
  delete?: InputMaybe<Array<AvatarTaggingAttributeWhereUniqueInput>>;
  /** Disconnect multiple AvatarTaggingAttribute documents */
  disconnect?: InputMaybe<Array<AvatarTaggingAttributeWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing AvatarTaggingAttribute documents */
  set?: InputMaybe<Array<AvatarTaggingAttributeWhereUniqueInput>>;
  /** Update multiple AvatarTaggingAttribute documents */
  update?: InputMaybe<
    Array<AvatarTaggingAttributeUpdateWithNestedWhereUniqueInput>
  >;
  /** Upsert multiple AvatarTaggingAttribute documents */
  upsert?: InputMaybe<
    Array<AvatarTaggingAttributeUpsertWithNestedWhereUniqueInput>
  >;
};

export type AvatarTaggingAttributeUpdateManyInput = {
  /** attribute input for default locale (en) */
  attribute?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<AvatarTaggingAttributeCategoryEnum>;
  internalTag?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<AvatarTaggingAttributeUpdateManyLocalizationsInput>;
};

export type AvatarTaggingAttributeUpdateManyLocalizationDataInput = {
  attribute?: InputMaybe<Scalars['String']['input']>;
};

export type AvatarTaggingAttributeUpdateManyLocalizationInput = {
  data: AvatarTaggingAttributeUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type AvatarTaggingAttributeUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<AvatarTaggingAttributeUpdateManyLocalizationInput>>;
};

export type AvatarTaggingAttributeUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AvatarTaggingAttributeUpdateManyInput;
  /** Document search */
  where: AvatarTaggingAttributeWhereInput;
};

export type AvatarTaggingAttributeUpdateOneInlineInput = {
  /** Connect existing AvatarTaggingAttribute document */
  connect?: InputMaybe<AvatarTaggingAttributeWhereUniqueInput>;
  /** Create and connect one AvatarTaggingAttribute document */
  create?: InputMaybe<AvatarTaggingAttributeCreateInput>;
  /** Delete currently connected AvatarTaggingAttribute document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected AvatarTaggingAttribute document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single AvatarTaggingAttribute document */
  update?: InputMaybe<AvatarTaggingAttributeUpdateWithNestedWhereUniqueInput>;
  /** Upsert single AvatarTaggingAttribute document */
  upsert?: InputMaybe<AvatarTaggingAttributeUpsertWithNestedWhereUniqueInput>;
};

export type AvatarTaggingAttributeUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AvatarTaggingAttributeUpdateInput;
  /** Unique document search */
  where: AvatarTaggingAttributeWhereUniqueInput;
};

export type AvatarTaggingAttributeUpsertInput = {
  /** Create document if it didn't exist */
  create: AvatarTaggingAttributeCreateInput;
  /** Update document if it exists */
  update: AvatarTaggingAttributeUpdateInput;
};

export type AvatarTaggingAttributeUpsertLocalizationInput = {
  create: AvatarTaggingAttributeCreateLocalizationDataInput;
  locale: Locale;
  update: AvatarTaggingAttributeUpdateLocalizationDataInput;
};

export type AvatarTaggingAttributeUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AvatarTaggingAttributeUpsertInput;
  /** Unique document search */
  where: AvatarTaggingAttributeWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AvatarTaggingAttributeWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type AvatarTaggingAttributeWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AvatarTaggingAttributeWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AvatarTaggingAttributeWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AvatarTaggingAttributeWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  attribute?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  attribute_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  attribute_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  attribute_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  attribute_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  attribute_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  attribute_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  attribute_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  attribute_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  attribute_starts_with?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<AvatarTaggingAttributeCategoryEnum>;
  /** All values that are contained in given list. */
  category_in?: InputMaybe<
    Array<InputMaybe<AvatarTaggingAttributeCategoryEnum>>
  >;
  /** Any other value that exists and is not equal to the given value. */
  category_not?: InputMaybe<AvatarTaggingAttributeCategoryEnum>;
  /** All values that are not contained in given list. */
  category_not_in?: InputMaybe<
    Array<InputMaybe<AvatarTaggingAttributeCategoryEnum>>
  >;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AvatarTaggingAttributeWhereStageInput>;
  documentInStages_none?: InputMaybe<AvatarTaggingAttributeWhereStageInput>;
  documentInStages_some?: InputMaybe<AvatarTaggingAttributeWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalTag?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  internalTag_not?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AvatarTaggingAttributeWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AvatarTaggingAttributeWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AvatarTaggingAttributeWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AvatarTaggingAttributeWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AvatarTaggingAttributeWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References AvatarTaggingAttribute record uniquely */
export type AvatarTaggingAttributeWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type AvatarUpdateInput = {
  auth0Roles?: InputMaybe<Auth0RoleUpdateManyInlineInput>;
  avatarId?: InputMaybe<Scalars['Int']['input']>;
  avatarPools?: InputMaybe<AvatarPoolUpdateManyInlineInput>;
  displayInitials?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<AvatarGender>;
  image?: InputMaybe<AssetUpdateOneInlineInput>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isCustom?: InputMaybe<Scalars['Boolean']['input']>;
  preview?: InputMaybe<AssetUpdateOneInlineInput>;
  source?: InputMaybe<AvatarSource>;
  tags?: InputMaybe<AvatarTaggingAttributeUpdateManyInlineInput>;
  variants?: InputMaybe<VariantUpdateManyInlineInput>;
};

export type AvatarUpdateManyInlineInput = {
  /** Connect multiple existing Avatar documents */
  connect?: InputMaybe<Array<AvatarConnectInput>>;
  /** Create and connect multiple Avatar documents */
  create?: InputMaybe<Array<AvatarCreateInput>>;
  /** Delete multiple Avatar documents */
  delete?: InputMaybe<Array<AvatarWhereUniqueInput>>;
  /** Disconnect multiple Avatar documents */
  disconnect?: InputMaybe<Array<AvatarWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Avatar documents */
  set?: InputMaybe<Array<AvatarWhereUniqueInput>>;
  /** Update multiple Avatar documents */
  update?: InputMaybe<Array<AvatarUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Avatar documents */
  upsert?: InputMaybe<Array<AvatarUpsertWithNestedWhereUniqueInput>>;
};

export type AvatarUpdateManyInput = {
  displayInitials?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<AvatarGender>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isCustom?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<AvatarSource>;
};

export type AvatarUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AvatarUpdateManyInput;
  /** Document search */
  where: AvatarWhereInput;
};

export type AvatarUpdateOneInlineInput = {
  /** Connect existing Avatar document */
  connect?: InputMaybe<AvatarWhereUniqueInput>;
  /** Create and connect one Avatar document */
  create?: InputMaybe<AvatarCreateInput>;
  /** Delete currently connected Avatar document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Avatar document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Avatar document */
  update?: InputMaybe<AvatarUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Avatar document */
  upsert?: InputMaybe<AvatarUpsertWithNestedWhereUniqueInput>;
};

export type AvatarUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AvatarUpdateInput;
  /** Unique document search */
  where: AvatarWhereUniqueInput;
};

export type AvatarUpsertInput = {
  /** Create document if it didn't exist */
  create: AvatarCreateInput;
  /** Update document if it exists */
  update: AvatarUpdateInput;
};

export type AvatarUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AvatarUpsertInput;
  /** Unique document search */
  where: AvatarWhereUniqueInput;
};

export type AvatarVariantStyle = Entity &
  Node & {
    __typename?: 'AvatarVariantStyle';
    avatarVariantStyleId: Scalars['String']['output'];
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<User>;
    description: Scalars['String']['output'];
    /** Get the document in other stages */
    documentInStages: Array<AvatarVariantStyle>;
    /** List of AvatarVariantStyle versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    label: Scalars['String']['output'];
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<User>;
    scheduledIn: Array<ScheduledOperation>;
    /** System stage field */
    stage: Stage;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<User>;
  };

export type AvatarVariantStyleCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type AvatarVariantStyleDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type AvatarVariantStyleHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type AvatarVariantStylePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type AvatarVariantStyleScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type AvatarVariantStyleUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type AvatarVariantStyleConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AvatarVariantStyleWhereUniqueInput;
};

/** A connection to a list of items. */
export type AvatarVariantStyleConnection = {
  __typename?: 'AvatarVariantStyleConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AvatarVariantStyleEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AvatarVariantStyleCreateInput = {
  avatarVariantStyleId: Scalars['String']['input'];
  cl6v68tq732bk01uq444y3rhl?: InputMaybe<VariantCreateManyInlineInput>;
  cl6y9071s0u7e01te44eh8p80?: InputMaybe<ActorVariantCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  label: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AvatarVariantStyleCreateManyInlineInput = {
  /** Connect multiple existing AvatarVariantStyle documents */
  connect?: InputMaybe<Array<AvatarVariantStyleWhereUniqueInput>>;
  /** Create and connect multiple existing AvatarVariantStyle documents */
  create?: InputMaybe<Array<AvatarVariantStyleCreateInput>>;
};

export type AvatarVariantStyleCreateOneInlineInput = {
  /** Connect one existing AvatarVariantStyle document */
  connect?: InputMaybe<AvatarVariantStyleWhereUniqueInput>;
  /** Create and connect one AvatarVariantStyle document */
  create?: InputMaybe<AvatarVariantStyleCreateInput>;
};

/** An edge in a connection. */
export type AvatarVariantStyleEdge = {
  __typename?: 'AvatarVariantStyleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AvatarVariantStyle;
};

/** Identifies documents */
export type AvatarVariantStyleManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AvatarVariantStyleWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AvatarVariantStyleWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AvatarVariantStyleWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  avatarVariantStyleId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  avatarVariantStyleId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  avatarVariantStyleId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  avatarVariantStyleId_in?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  /** Any other value that exists and is not equal to the given value. */
  avatarVariantStyleId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  avatarVariantStyleId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  avatarVariantStyleId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  avatarVariantStyleId_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  /** All values not starting with the given string. */
  avatarVariantStyleId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  avatarVariantStyleId_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<AvatarVariantStyleWhereStageInput>;
  documentInStages_none?: InputMaybe<AvatarVariantStyleWhereStageInput>;
  documentInStages_some?: InputMaybe<AvatarVariantStyleWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum AvatarVariantStyleOrderByInput {
  AvatarVariantStyleIdAsc = 'avatarVariantStyleId_ASC',
  AvatarVariantStyleIdDesc = 'avatarVariantStyleId_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type AvatarVariantStyleUpdateInput = {
  avatarVariantStyleId?: InputMaybe<Scalars['String']['input']>;
  cl6v68tq732bk01uq444y3rhl?: InputMaybe<VariantUpdateManyInlineInput>;
  cl6y9071s0u7e01te44eh8p80?: InputMaybe<ActorVariantUpdateManyInlineInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type AvatarVariantStyleUpdateManyInlineInput = {
  /** Connect multiple existing AvatarVariantStyle documents */
  connect?: InputMaybe<Array<AvatarVariantStyleConnectInput>>;
  /** Create and connect multiple AvatarVariantStyle documents */
  create?: InputMaybe<Array<AvatarVariantStyleCreateInput>>;
  /** Delete multiple AvatarVariantStyle documents */
  delete?: InputMaybe<Array<AvatarVariantStyleWhereUniqueInput>>;
  /** Disconnect multiple AvatarVariantStyle documents */
  disconnect?: InputMaybe<Array<AvatarVariantStyleWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing AvatarVariantStyle documents */
  set?: InputMaybe<Array<AvatarVariantStyleWhereUniqueInput>>;
  /** Update multiple AvatarVariantStyle documents */
  update?: InputMaybe<
    Array<AvatarVariantStyleUpdateWithNestedWhereUniqueInput>
  >;
  /** Upsert multiple AvatarVariantStyle documents */
  upsert?: InputMaybe<
    Array<AvatarVariantStyleUpsertWithNestedWhereUniqueInput>
  >;
};

export type AvatarVariantStyleUpdateManyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type AvatarVariantStyleUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AvatarVariantStyleUpdateManyInput;
  /** Document search */
  where: AvatarVariantStyleWhereInput;
};

export type AvatarVariantStyleUpdateOneInlineInput = {
  /** Connect existing AvatarVariantStyle document */
  connect?: InputMaybe<AvatarVariantStyleWhereUniqueInput>;
  /** Create and connect one AvatarVariantStyle document */
  create?: InputMaybe<AvatarVariantStyleCreateInput>;
  /** Delete currently connected AvatarVariantStyle document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected AvatarVariantStyle document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single AvatarVariantStyle document */
  update?: InputMaybe<AvatarVariantStyleUpdateWithNestedWhereUniqueInput>;
  /** Upsert single AvatarVariantStyle document */
  upsert?: InputMaybe<AvatarVariantStyleUpsertWithNestedWhereUniqueInput>;
};

export type AvatarVariantStyleUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AvatarVariantStyleUpdateInput;
  /** Unique document search */
  where: AvatarVariantStyleWhereUniqueInput;
};

export type AvatarVariantStyleUpsertInput = {
  /** Create document if it didn't exist */
  create: AvatarVariantStyleCreateInput;
  /** Update document if it exists */
  update: AvatarVariantStyleUpdateInput;
};

export type AvatarVariantStyleUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AvatarVariantStyleUpsertInput;
  /** Unique document search */
  where: AvatarVariantStyleWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AvatarVariantStyleWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type AvatarVariantStyleWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AvatarVariantStyleWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AvatarVariantStyleWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AvatarVariantStyleWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  avatarVariantStyleId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  avatarVariantStyleId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  avatarVariantStyleId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  avatarVariantStyleId_in?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  /** Any other value that exists and is not equal to the given value. */
  avatarVariantStyleId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  avatarVariantStyleId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  avatarVariantStyleId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  avatarVariantStyleId_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  /** All values not starting with the given string. */
  avatarVariantStyleId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  avatarVariantStyleId_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<AvatarVariantStyleWhereStageInput>;
  documentInStages_none?: InputMaybe<AvatarVariantStyleWhereStageInput>;
  documentInStages_some?: InputMaybe<AvatarVariantStyleWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AvatarVariantStyleWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AvatarVariantStyleWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AvatarVariantStyleWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AvatarVariantStyleWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AvatarVariantStyleWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References AvatarVariantStyle record uniquely */
export type AvatarVariantStyleWhereUniqueInput = {
  avatarVariantStyleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** This contains a set of filters that can be used to compare values internally */
export type AvatarWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type AvatarWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AvatarWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AvatarWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AvatarWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  auth0Roles_every?: InputMaybe<Auth0RoleWhereInput>;
  auth0Roles_none?: InputMaybe<Auth0RoleWhereInput>;
  auth0Roles_some?: InputMaybe<Auth0RoleWhereInput>;
  avatarId?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  avatarId_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  avatarId_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  avatarId_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  avatarId_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  avatarId_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  avatarId_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  avatarId_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  avatarPools_every?: InputMaybe<AvatarPoolWhereInput>;
  avatarPools_none?: InputMaybe<AvatarPoolWhereInput>;
  avatarPools_some?: InputMaybe<AvatarPoolWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  createdBy?: InputMaybe<UserWhereInput>;
  displayInitials?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  displayInitials_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  displayInitials_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  displayInitials_in?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  /** Any other value that exists and is not equal to the given value. */
  displayInitials_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  displayInitials_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  displayInitials_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  displayInitials_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  /** All values not starting with the given string. */
  displayInitials_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  displayInitials_starts_with?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  displayName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  displayName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  displayName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  displayName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  displayName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  displayName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  displayName_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  /** All values not starting with the given string. */
  displayName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  displayName_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<AvatarWhereStageInput>;
  documentInStages_none?: InputMaybe<AvatarWhereStageInput>;
  documentInStages_some?: InputMaybe<AvatarWhereStageInput>;
  gender?: InputMaybe<AvatarGender>;
  /** All values that are contained in given list. */
  gender_in?: InputMaybe<Array<InputMaybe<AvatarGender>>>;
  /** Any other value that exists and is not equal to the given value. */
  gender_not?: InputMaybe<AvatarGender>;
  /** All values that are not contained in given list. */
  gender_not_in?: InputMaybe<Array<InputMaybe<AvatarGender>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isArchived_not?: InputMaybe<Scalars['Boolean']['input']>;
  isCustom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isCustom_not?: InputMaybe<Scalars['Boolean']['input']>;
  preview?: InputMaybe<AssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  source?: InputMaybe<AvatarSource>;
  /** All values that are contained in given list. */
  source_in?: InputMaybe<Array<InputMaybe<AvatarSource>>>;
  /** Any other value that exists and is not equal to the given value. */
  source_not?: InputMaybe<AvatarSource>;
  /** All values that are not contained in given list. */
  source_not_in?: InputMaybe<Array<InputMaybe<AvatarSource>>>;
  tags_every?: InputMaybe<AvatarTaggingAttributeWhereInput>;
  tags_none?: InputMaybe<AvatarTaggingAttributeWhereInput>;
  tags_some?: InputMaybe<AvatarTaggingAttributeWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  updatedBy?: InputMaybe<UserWhereInput>;
  variants_every?: InputMaybe<VariantWhereInput>;
  variants_none?: InputMaybe<VariantWhereInput>;
  variants_some?: InputMaybe<VariantWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AvatarWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AvatarWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AvatarWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AvatarWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AvatarWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Avatar record uniquely */
export type AvatarWhereUniqueInput = {
  avatarId?: InputMaybe<Scalars['Int']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type BatchPayload = {
  __typename?: 'BatchPayload';
  /** The number of nodes that have been affected by the Batch operation. */
  count: Scalars['Long']['output'];
};

/** Representing a color value comprising of HEX, RGBA and css color values */
export type Color = {
  __typename?: 'Color';
  css: Scalars['String']['output'];
  hex: Scalars['Hex']['output'];
  rgba: Rgba;
};

/** Accepts either HEX or RGBA color value. At least one of hex or rgba value should be passed. If both are passed RGBA is used. */
export type ColorInput = {
  hex?: InputMaybe<Scalars['Hex']['input']>;
  rgba?: InputMaybe<RgbaInput>;
};

export type ConnectPositionInput = {
  /** Connect document after specified document */
  after?: InputMaybe<Scalars['ID']['input']>;
  /** Connect document before specified document */
  before?: InputMaybe<Scalars['ID']['input']>;
  /** Connect document at last position */
  end?: InputMaybe<Scalars['Boolean']['input']>;
  /** Connect document at first position */
  start?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentTile = Entity &
  Node & {
    __typename?: 'ContentTile';
    audioFile?: Maybe<Asset>;
    badge?: Maybe<Scalars['String']['output']>;
    body: Scalars['String']['output'];
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<User>;
    cta: ContentTileCta;
    /** Get the document in other stages */
    documentInStages: Array<ContentTile>;
    heading: Scalars['String']['output'];
    /** List of ContentTile versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    image?: Maybe<Asset>;
    location: ContentTileLocation;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<User>;
    scheduledIn: Array<ScheduledOperation>;
    /** System stage field */
    stage: Stage;
    type: ContentTileType;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<User>;
  };

export type ContentTileAudioFileArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type ContentTileCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ContentTileCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ContentTileDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type ContentTileHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type ContentTileImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type ContentTilePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ContentTileScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type ContentTileUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ContentTileConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ContentTileWhereUniqueInput;
};

/** A connection to a list of items. */
export type ContentTileConnection = {
  __typename?: 'ContentTileConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ContentTileEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ContentTileCreateInput = {
  audioFile?: InputMaybe<AssetCreateOneInlineInput>;
  badge?: InputMaybe<Scalars['String']['input']>;
  body: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  cta: ContentTileCtaCreateOneInlineInput;
  heading: Scalars['String']['input'];
  image?: InputMaybe<AssetCreateOneInlineInput>;
  location: ContentTileLocation;
  type: ContentTileType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ContentTileCreateManyInlineInput = {
  /** Connect multiple existing ContentTile documents */
  connect?: InputMaybe<Array<ContentTileWhereUniqueInput>>;
  /** Create and connect multiple existing ContentTile documents */
  create?: InputMaybe<Array<ContentTileCreateInput>>;
};

export type ContentTileCreateOneInlineInput = {
  /** Connect one existing ContentTile document */
  connect?: InputMaybe<ContentTileWhereUniqueInput>;
  /** Create and connect one ContentTile document */
  create?: InputMaybe<ContentTileCreateInput>;
};

export type ContentTileCta = Entity & {
  __typename?: 'ContentTileCta';
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
  text: Scalars['String']['output'];
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
};

export type ContentTileCtaConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ContentTileCtaWhereUniqueInput;
};

/** A connection to a list of items. */
export type ContentTileCtaConnection = {
  __typename?: 'ContentTileCtaConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ContentTileCtaEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ContentTileCtaCreateInput = {
  text: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
};

export type ContentTileCtaCreateManyInlineInput = {
  /** Create and connect multiple existing ContentTileCta documents */
  create?: InputMaybe<Array<ContentTileCtaCreateInput>>;
};

export type ContentTileCtaCreateOneInlineInput = {
  /** Create and connect one ContentTileCta document */
  create?: InputMaybe<ContentTileCtaCreateInput>;
};

export type ContentTileCtaCreateWithPositionInput = {
  /** Document to create */
  data: ContentTileCtaCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type ContentTileCtaEdge = {
  __typename?: 'ContentTileCtaEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ContentTileCta;
};

/** Identifies documents */
export type ContentTileCtaManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentTileCtaWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentTileCtaWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentTileCtaWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  text_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  text_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  text_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  text_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  text_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  text_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  url?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum ContentTileCtaOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC',
}

export type ContentTileCtaParent = ContentTile;

export type ContentTileCtaParentConnectInput = {
  ContentTile?: InputMaybe<ContentTileConnectInput>;
};

export type ContentTileCtaParentCreateInput = {
  ContentTile?: InputMaybe<ContentTileCreateInput>;
};

export type ContentTileCtaParentCreateManyInlineInput = {
  /** Connect multiple existing ContentTileCtaParent documents */
  connect?: InputMaybe<Array<ContentTileCtaParentWhereUniqueInput>>;
  /** Create and connect multiple existing ContentTileCtaParent documents */
  create?: InputMaybe<Array<ContentTileCtaParentCreateInput>>;
};

export type ContentTileCtaParentCreateOneInlineInput = {
  /** Connect one existing ContentTileCtaParent document */
  connect?: InputMaybe<ContentTileCtaParentWhereUniqueInput>;
  /** Create and connect one ContentTileCtaParent document */
  create?: InputMaybe<ContentTileCtaParentCreateInput>;
};

export type ContentTileCtaParentUpdateInput = {
  ContentTile?: InputMaybe<ContentTileUpdateInput>;
};

export type ContentTileCtaParentUpdateManyInlineInput = {
  /** Connect multiple existing ContentTileCtaParent documents */
  connect?: InputMaybe<Array<ContentTileCtaParentConnectInput>>;
  /** Create and connect multiple ContentTileCtaParent documents */
  create?: InputMaybe<Array<ContentTileCtaParentCreateInput>>;
  /** Delete multiple ContentTileCtaParent documents */
  delete?: InputMaybe<Array<ContentTileCtaParentWhereUniqueInput>>;
  /** Disconnect multiple ContentTileCtaParent documents */
  disconnect?: InputMaybe<Array<ContentTileCtaParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ContentTileCtaParent documents */
  set?: InputMaybe<Array<ContentTileCtaParentWhereUniqueInput>>;
  /** Update multiple ContentTileCtaParent documents */
  update?: InputMaybe<
    Array<ContentTileCtaParentUpdateWithNestedWhereUniqueInput>
  >;
  /** Upsert multiple ContentTileCtaParent documents */
  upsert?: InputMaybe<
    Array<ContentTileCtaParentUpsertWithNestedWhereUniqueInput>
  >;
};

export type ContentTileCtaParentUpdateManyWithNestedWhereInput = {
  ContentTile?: InputMaybe<ContentTileUpdateManyWithNestedWhereInput>;
};

export type ContentTileCtaParentUpdateOneInlineInput = {
  /** Connect existing ContentTileCtaParent document */
  connect?: InputMaybe<ContentTileCtaParentWhereUniqueInput>;
  /** Create and connect one ContentTileCtaParent document */
  create?: InputMaybe<ContentTileCtaParentCreateInput>;
  /** Delete currently connected ContentTileCtaParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ContentTileCtaParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ContentTileCtaParent document */
  update?: InputMaybe<ContentTileCtaParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ContentTileCtaParent document */
  upsert?: InputMaybe<ContentTileCtaParentUpsertWithNestedWhereUniqueInput>;
};

export type ContentTileCtaParentUpdateWithNestedWhereUniqueInput = {
  ContentTile?: InputMaybe<ContentTileUpdateWithNestedWhereUniqueInput>;
};

export type ContentTileCtaParentUpsertWithNestedWhereUniqueInput = {
  ContentTile?: InputMaybe<ContentTileUpsertWithNestedWhereUniqueInput>;
};

export type ContentTileCtaParentWhereInput = {
  ContentTile?: InputMaybe<ContentTileWhereInput>;
};

export type ContentTileCtaParentWhereUniqueInput = {
  ContentTile?: InputMaybe<ContentTileWhereUniqueInput>;
};

export type ContentTileCtaUpdateInput = {
  text?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ContentTileCtaUpdateManyInlineInput = {
  /** Create and connect multiple ContentTileCta component instances */
  create?: InputMaybe<Array<ContentTileCtaCreateWithPositionInput>>;
  /** Delete multiple ContentTileCta documents */
  delete?: InputMaybe<Array<ContentTileCtaWhereUniqueInput>>;
  /** Update multiple ContentTileCta component instances */
  update?: InputMaybe<
    Array<ContentTileCtaUpdateWithNestedWhereUniqueAndPositionInput>
  >;
  /** Upsert multiple ContentTileCta component instances */
  upsert?: InputMaybe<
    Array<ContentTileCtaUpsertWithNestedWhereUniqueAndPositionInput>
  >;
};

export type ContentTileCtaUpdateManyInput = {
  text?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ContentTileCtaUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ContentTileCtaUpdateManyInput;
  /** Document search */
  where: ContentTileCtaWhereInput;
};

export type ContentTileCtaUpdateOneInlineInput = {
  /** Create and connect one ContentTileCta document */
  create?: InputMaybe<ContentTileCtaCreateInput>;
  /** Delete currently connected ContentTileCta document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ContentTileCta document */
  update?: InputMaybe<ContentTileCtaUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ContentTileCta document */
  upsert?: InputMaybe<ContentTileCtaUpsertWithNestedWhereUniqueInput>;
};

export type ContentTileCtaUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<ContentTileCtaUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ContentTileCtaWhereUniqueInput;
};

export type ContentTileCtaUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ContentTileCtaUpdateInput;
  /** Unique document search */
  where: ContentTileCtaWhereUniqueInput;
};

export type ContentTileCtaUpsertInput = {
  /** Create document if it didn't exist */
  create: ContentTileCtaCreateInput;
  /** Update document if it exists */
  update: ContentTileCtaUpdateInput;
};

export type ContentTileCtaUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<ContentTileCtaUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ContentTileCtaWhereUniqueInput;
};

export type ContentTileCtaUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ContentTileCtaUpsertInput;
  /** Unique document search */
  where: ContentTileCtaWhereUniqueInput;
};

/** Identifies documents */
export type ContentTileCtaWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentTileCtaWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentTileCtaWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentTileCtaWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  text_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  text_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  text_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  text_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  text_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  text_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  url?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References ContentTileCta record uniquely */
export type ContentTileCtaWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** An edge in a connection. */
export type ContentTileEdge = {
  __typename?: 'ContentTileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ContentTile;
};

export enum ContentTileLocation {
  LeftRail = 'leftRail',
  Resources = 'resources',
}

/** Identifies documents */
export type ContentTileManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentTileWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentTileWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentTileWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  audioFile?: InputMaybe<AssetWhereInput>;
  badge?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  badge_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  badge_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  badge_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  badge_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  badge_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  badge_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  badge_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  badge_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  badge_starts_with?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  body_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  body_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  body_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  body_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  body_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  body_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  body_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  body_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  createdBy?: InputMaybe<UserWhereInput>;
  cta?: InputMaybe<ContentTileCtaWhereInput>;
  documentInStages_every?: InputMaybe<ContentTileWhereStageInput>;
  documentInStages_none?: InputMaybe<ContentTileWhereStageInput>;
  documentInStages_some?: InputMaybe<ContentTileWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  location?: InputMaybe<ContentTileLocation>;
  /** All values that are contained in given list. */
  location_in?: InputMaybe<Array<InputMaybe<ContentTileLocation>>>;
  /** Any other value that exists and is not equal to the given value. */
  location_not?: InputMaybe<ContentTileLocation>;
  /** All values that are not contained in given list. */
  location_not_in?: InputMaybe<Array<InputMaybe<ContentTileLocation>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  type?: InputMaybe<ContentTileType>;
  /** All values that are contained in given list. */
  type_in?: InputMaybe<Array<InputMaybe<ContentTileType>>>;
  /** Any other value that exists and is not equal to the given value. */
  type_not?: InputMaybe<ContentTileType>;
  /** All values that are not contained in given list. */
  type_not_in?: InputMaybe<Array<InputMaybe<ContentTileType>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ContentTileOrderByInput {
  BadgeAsc = 'badge_ASC',
  BadgeDesc = 'badge_DESC',
  BodyAsc = 'body_ASC',
  BodyDesc = 'body_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export enum ContentTileType {
  Share = 'Share',
  Tip = 'Tip',
  Watch = 'Watch',
}

export type ContentTileUpdateInput = {
  audioFile?: InputMaybe<AssetUpdateOneInlineInput>;
  badge?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  cta?: InputMaybe<ContentTileCtaUpdateOneInlineInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetUpdateOneInlineInput>;
  location?: InputMaybe<ContentTileLocation>;
  type?: InputMaybe<ContentTileType>;
};

export type ContentTileUpdateManyInlineInput = {
  /** Connect multiple existing ContentTile documents */
  connect?: InputMaybe<Array<ContentTileConnectInput>>;
  /** Create and connect multiple ContentTile documents */
  create?: InputMaybe<Array<ContentTileCreateInput>>;
  /** Delete multiple ContentTile documents */
  delete?: InputMaybe<Array<ContentTileWhereUniqueInput>>;
  /** Disconnect multiple ContentTile documents */
  disconnect?: InputMaybe<Array<ContentTileWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ContentTile documents */
  set?: InputMaybe<Array<ContentTileWhereUniqueInput>>;
  /** Update multiple ContentTile documents */
  update?: InputMaybe<Array<ContentTileUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ContentTile documents */
  upsert?: InputMaybe<Array<ContentTileUpsertWithNestedWhereUniqueInput>>;
};

export type ContentTileUpdateManyInput = {
  badge?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<ContentTileLocation>;
  type?: InputMaybe<ContentTileType>;
};

export type ContentTileUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ContentTileUpdateManyInput;
  /** Document search */
  where: ContentTileWhereInput;
};

export type ContentTileUpdateOneInlineInput = {
  /** Connect existing ContentTile document */
  connect?: InputMaybe<ContentTileWhereUniqueInput>;
  /** Create and connect one ContentTile document */
  create?: InputMaybe<ContentTileCreateInput>;
  /** Delete currently connected ContentTile document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ContentTile document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ContentTile document */
  update?: InputMaybe<ContentTileUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ContentTile document */
  upsert?: InputMaybe<ContentTileUpsertWithNestedWhereUniqueInput>;
};

export type ContentTileUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ContentTileUpdateInput;
  /** Unique document search */
  where: ContentTileWhereUniqueInput;
};

export type ContentTileUpsertInput = {
  /** Create document if it didn't exist */
  create: ContentTileCreateInput;
  /** Update document if it exists */
  update: ContentTileUpdateInput;
};

export type ContentTileUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ContentTileUpsertInput;
  /** Unique document search */
  where: ContentTileWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ContentTileWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ContentTileWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentTileWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentTileWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentTileWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  audioFile?: InputMaybe<AssetWhereInput>;
  badge?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  badge_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  badge_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  badge_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  badge_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  badge_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  badge_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  badge_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  badge_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  badge_starts_with?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  body_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  body_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  body_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  body_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  body_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  body_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  body_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  body_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  createdBy?: InputMaybe<UserWhereInput>;
  cta?: InputMaybe<ContentTileCtaWhereInput>;
  documentInStages_every?: InputMaybe<ContentTileWhereStageInput>;
  documentInStages_none?: InputMaybe<ContentTileWhereStageInput>;
  documentInStages_some?: InputMaybe<ContentTileWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  location?: InputMaybe<ContentTileLocation>;
  /** All values that are contained in given list. */
  location_in?: InputMaybe<Array<InputMaybe<ContentTileLocation>>>;
  /** Any other value that exists and is not equal to the given value. */
  location_not?: InputMaybe<ContentTileLocation>;
  /** All values that are not contained in given list. */
  location_not_in?: InputMaybe<Array<InputMaybe<ContentTileLocation>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  type?: InputMaybe<ContentTileType>;
  /** All values that are contained in given list. */
  type_in?: InputMaybe<Array<InputMaybe<ContentTileType>>>;
  /** Any other value that exists and is not equal to the given value. */
  type_not?: InputMaybe<ContentTileType>;
  /** All values that are not contained in given list. */
  type_not_in?: InputMaybe<Array<InputMaybe<ContentTileType>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ContentTileWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentTileWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentTileWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentTileWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ContentTileWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ContentTile record uniquely */
export type ContentTileWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum DocumentFileTypes {
  /** Automatically selects the best format for the image based on the browser's capabilities. */
  AutoImage = 'autoImage',
  Avif = 'avif',
  Bmp = 'bmp',
  Gif = 'gif',
  Heic = 'heic',
  Jpg = 'jpg',
  Png = 'png',
  Svg = 'svg',
  Tiff = 'tiff',
  Webp = 'webp',
}

export type DocumentOutputInput = {
  /**
   * Transforms a document into a desired file type.
   * See this matrix for format support:
   *
   * JPG:	autoImage, bmp, gif, jpg, png, webp, tiff
   * PNG:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * SVG:	autoImage, bmp, gif, jpg, png, webp, tiff
   * WEBP:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * GIF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * TIFF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * AVIF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * PDF: 	autoImage, gif, jpg, png, webp, tiff
   *
   */
  format?: InputMaybe<DocumentFileTypes>;
};

/** Transformations for Documents */
export type DocumentTransformationInput = {
  /** Changes the output for the file. */
  output?: InputMaybe<DocumentOutputInput>;
};

export type DocumentVersion = {
  __typename?: 'DocumentVersion';
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['Json']['output']>;
  id: Scalars['ID']['output'];
  revision: Scalars['Int']['output'];
  stage: Stage;
};

/** An object with an ID */
export type Entity = {
  /** The id of the object. */
  id: Scalars['ID']['output'];
  /** The Stage of an object */
  stage: Stage;
};

/** This enumeration holds all typenames that implement the Entity interface. Components and models implement the Entity interface. */
export enum EntityTypeName {
  /** Model representing an internal voice actor prior to becoming an in-studio avatar. */
  Actor = 'Actor',
  ActorVariant = 'ActorVariant',
  /** Create announcements for the user in the studio. */
  Announcement = 'Announcement',
  AnnouncementCta = 'AnnouncementCta',
  /** a range of dates */
  AnnouncementInterval = 'AnnouncementInterval',
  /** Asset system model */
  Asset = 'Asset',
  /** User Auth0 Roles */
  Auth0Role = 'Auth0Role',
  /** A representation of a voice actor. */
  Avatar = 'Avatar',
  AvatarPool = 'AvatarPool',
  /** Object representing a single tag for an avatar or avatar variant */
  AvatarTaggingAttribute = 'AvatarTaggingAttribute',
  AvatarVariantStyle = 'AvatarVariantStyle',
  ContentTile = 'ContentTile',
  ContentTileCta = 'ContentTileCta',
  /** Scheduled Operation system model */
  ScheduledOperation = 'ScheduledOperation',
  /** Scheduled Release system model */
  ScheduledRelease = 'ScheduledRelease',
  /** An identifier for a text to speech data model tagged with version name and description. */
  TtsModel = 'TTSModel',
  TtsModelFeature = 'TTSModelFeature',
  /** User system model */
  User = 'User',
  /**
   * The variants of an avatar (IE avatar + locale + style)
   *
   * IE: Ramona J Narration US
   */
  Variant = 'Variant',
  /** The releases associated with a variant: It is a composite of version, model, and variants associated (v9 beta, v8 latest) etc */
  VariantRelease = 'VariantRelease',
}

/** Allows to specify input to query models and components directly */
export type EntityWhereInput = {
  /** The ID of an object */
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Locale>;
  stage: Stage;
  /** The Type name of an object */
  typename: EntityTypeName;
};

export type ImageBlurInput = {
  /** The amount of blurring to apply to the image. The value must be an integer from 1 to 20. */
  amount: Scalars['Int']['input'];
};

/** Adds a border to the image. */
export type ImageBorderInput = {
  /** The background color of the border. The value must be a valid hex color code. Or one of the supported color names. */
  background: Scalars['String']['input'];
  /** The color of the border. The value must be a valid hex color code. Or one of the supported color names. */
  color: Scalars['String']['input'];
  /** The width of the border in pixels. The value must be an integer from 1 to 1000. */
  width: Scalars['Int']['input'];
};

export type ImageCompressInput = {
  /** Preserves the metadata of the image. */
  metadata: Scalars['Boolean']['input'];
};

/**
 * Crops the image to the specified dimensions.
 * The starting points for X and Y coordinates are [0,0], aligning with the top-left corner of the image.
 * The width and height parameters determine the size in pixels of the cropping rectangle.
 * The output will include only the portion of the image within the designated crop area.
 */
export type ImageCropInput = {
  /** The height in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  height: Scalars['Int']['input'];
  /** The width in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  width: Scalars['Int']['input'];
  /** The x coordinate of the image. The value must be an integer from 0 to 10000. */
  x: Scalars['Int']['input'];
  /** The y coordinate of the image. The value must be an integer from 0 to 10000. */
  y: Scalars['Int']['input'];
};

export enum ImageFit {
  /** Resizes the image to fit within the specified parameters without distorting, cropping, or changing the aspect ratio. */
  Clip = 'clip',
  /** Resizes the image to fit the specified parameters exactly by removing any parts of the image that don't fit within the boundaries. */
  Crop = 'crop',
  /** Resizes the image to fit within the parameters, but as opposed to 'fit:clip' will not scale the image if the image is smaller than the output size. */
  Max = 'max',
  /** Resizes the image to fit the specified parameters exactly by scaling the image to the desired size. The aspect ratio of the image is not respected and the image can be distorted using this method. */
  Scale = 'scale',
}

export type ImageQualityInput = {
  /** The quality of the image. The value must be an integer from 1 to 100. */
  value: Scalars['Int']['input'];
};

export type ImageResizeInput = {
  /** The default value for the fit parameter is fit:clip. */
  fit?: InputMaybe<ImageFit>;
  /** The height in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** The width in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type ImageSharpenInput = {
  /** The amount of sharpening to apply to the image. The value must be an integer from 1 to 20. */
  amount: Scalars['Int']['input'];
};

/** Transformations for Images */
export type ImageTransformationInput = {
  /** Blurs the image. */
  blur?: InputMaybe<ImageBlurInput>;
  /** Adds a border to the image. */
  border?: InputMaybe<ImageBorderInput>;
  /** Compresses the image. */
  compress?: InputMaybe<ImageCompressInput>;
  /** Crops the image to the specified dimensions. */
  crop?: InputMaybe<ImageCropInput>;
  /**
   * Changes the quality of the image. The value must be an integer from 1 to 100.
   * Only supported for the following formats jpeg, jpg, webp, gif, heif, tiff, avif.
   */
  quality?: InputMaybe<ImageQualityInput>;
  /** Resizes the image */
  resize?: InputMaybe<ImageResizeInput>;
  /** Sharpens the image. */
  sharpen?: InputMaybe<ImageSharpenInput>;
};

/** Locale system enumeration */
export enum Locale {
  /** System locale */
  En = 'en',
}

/** Where the locale of a voice is US, UK, etc. */
export enum LocaleEnum {
  Au = 'AU',
  Br = 'BR',
  Ca = 'CA',
  De = 'DE',
  Fr = 'FR',
  Gb = 'GB',
  Ie = 'IE',
  Mx = 'MX',
  Uk = 'UK',
  Us = 'US',
  Za = 'ZA',
}

/** Locale for voice standardized to include language */
export enum LocaleEnum_V2 {
  ArAe = 'ar_AE',
  ArBh = 'ar_BH',
  ArDz = 'ar_DZ',
  ArEg = 'ar_EG',
  ArIq = 'ar_IQ',
  ArJo = 'ar_JO',
  ArKw = 'ar_KW',
  ArLb = 'ar_LB',
  ArLy = 'ar_LY',
  ArMa = 'ar_MA',
  ArOm = 'ar_OM',
  ArQa = 'ar_QA',
  ArSa = 'ar_SA',
  ArSy = 'ar_SY',
  ArTn = 'ar_TN',
  ArYe = 'ar_YE',
  CsCz = 'cs_CZ',
  DaDk = 'da_DK',
  DeAt = 'de_AT',
  DeCh = 'de_CH',
  DeDe = 'de_DE',
  ElGr = 'el_GR',
  EnAu = 'en_AU',
  EnCa = 'en_CA',
  EnGb = 'en_GB',
  EnHi = 'en_HI',
  EnIe = 'en_IE',
  EnMx = 'en_MX',
  EnUk = 'en_UK',
  EnUs = 'en_US',
  EnZa = 'en_ZA',
  EsAr = 'es_AR',
  EsBo = 'es_BO',
  EsCl = 'es_CL',
  EsCo = 'es_CO',
  EsCr = 'es_CR',
  EsCu = 'es_CU',
  EsDo = 'es_DO',
  EsEc = 'es_EC',
  EsEs = 'es_ES',
  EsMx = 'es_MX',
  EsUs = 'es_US',
  FaIr = 'fa_IR',
  FrBe = 'fr_BE',
  FrCa = 'fr_CA',
  FrCh = 'fr_CH',
  FrFr = 'fr_FR',
  HeIl = 'he_IL',
  HiIn = 'hi_IN',
  ItIt = 'it_IT',
  JaJp = 'ja_JP',
  KoKr = 'ko_KR',
  NlBe = 'nl_BE',
  NlNl = 'nl_NL',
  PlPl = 'pl_PL',
  PtBr = 'pt_BR',
  PtPt = 'pt_PT',
  RuRu = 'ru_RU',
  SoSo = 'so_SO',
  SvSe = 'sv_SE',
  TrTr = 'tr_TR',
  YueCn = 'yue_CN',
  ZhCn = 'zh_CN',
  ZhHk = 'zh_HK',
  ZhTw = 'zh_TW',
}

/** Representing a geolocation point with latitude and longitude */
export type Location = {
  __typename?: 'Location';
  distance: Scalars['Float']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

/** Representing a geolocation point with latitude and longitude */
export type LocationDistanceArgs = {
  from: LocationInput;
};

/** Input for a geolocation point with latitude and longitude */
export type LocationInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Create one actor */
  createActor?: Maybe<Actor>;
  /** Create one actorVariant */
  createActorVariant?: Maybe<ActorVariant>;
  /** Create one announcement */
  createAnnouncement?: Maybe<Announcement>;
  /** Create an asset. Use the returned info to finish the creation process by uploading the asset. */
  createAsset?: Maybe<Asset>;
  /** Create one auth0Role */
  createAuth0Role?: Maybe<Auth0Role>;
  /** Create one avatar */
  createAvatar?: Maybe<Avatar>;
  /** Create one avatarPool */
  createAvatarPool?: Maybe<AvatarPool>;
  /** Create one avatarTaggingAttribute */
  createAvatarTaggingAttribute?: Maybe<AvatarTaggingAttribute>;
  /** Create one avatarVariantStyle */
  createAvatarVariantStyle?: Maybe<AvatarVariantStyle>;
  /** Create one contentTile */
  createContentTile?: Maybe<ContentTile>;
  /** Create one scheduledRelease */
  createScheduledRelease?: Maybe<ScheduledRelease>;
  /** Create one tTSModel */
  createTTSModel?: Maybe<TtsModel>;
  /** Create one tTSModelFeature */
  createTTSModelFeature?: Maybe<TtsModelFeature>;
  /** Create one variant */
  createVariant?: Maybe<Variant>;
  /** Create one variantRelease */
  createVariantRelease?: Maybe<VariantRelease>;
  /** Delete one actor from _all_ existing stages. Returns deleted document. */
  deleteActor?: Maybe<Actor>;
  /** Delete one actorVariant from _all_ existing stages. Returns deleted document. */
  deleteActorVariant?: Maybe<ActorVariant>;
  /** Delete one announcement from _all_ existing stages. Returns deleted document. */
  deleteAnnouncement?: Maybe<Announcement>;
  /** Delete one asset from _all_ existing stages. Returns deleted document. */
  deleteAsset?: Maybe<Asset>;
  /** Delete one auth0Role from _all_ existing stages. Returns deleted document. */
  deleteAuth0Role?: Maybe<Auth0Role>;
  /** Delete one avatar from _all_ existing stages. Returns deleted document. */
  deleteAvatar?: Maybe<Avatar>;
  /** Delete one avatarPool from _all_ existing stages. Returns deleted document. */
  deleteAvatarPool?: Maybe<AvatarPool>;
  /** Delete one avatarTaggingAttribute from _all_ existing stages. Returns deleted document. */
  deleteAvatarTaggingAttribute?: Maybe<AvatarTaggingAttribute>;
  /** Delete one avatarVariantStyle from _all_ existing stages. Returns deleted document. */
  deleteAvatarVariantStyle?: Maybe<AvatarVariantStyle>;
  /** Delete one contentTile from _all_ existing stages. Returns deleted document. */
  deleteContentTile?: Maybe<ContentTile>;
  /**
   * Delete many ActorVariant documents
   * @deprecated Please use the new paginated many mutation (deleteManyActorVariantsConnection)
   */
  deleteManyActorVariants: BatchPayload;
  /** Delete many ActorVariant documents, return deleted documents */
  deleteManyActorVariantsConnection: ActorVariantConnection;
  /**
   * Delete many Actor documents
   * @deprecated Please use the new paginated many mutation (deleteManyActorsConnection)
   */
  deleteManyActors: BatchPayload;
  /** Delete many Actor documents, return deleted documents */
  deleteManyActorsConnection: ActorConnection;
  /**
   * Delete many Announcement documents
   * @deprecated Please use the new paginated many mutation (deleteManyAnnouncementsConnection)
   */
  deleteManyAnnouncements: BatchPayload;
  /** Delete many Announcement documents, return deleted documents */
  deleteManyAnnouncementsConnection: AnnouncementConnection;
  /**
   * Delete many Asset documents
   * @deprecated Please use the new paginated many mutation (deleteManyAssetsConnection)
   */
  deleteManyAssets: BatchPayload;
  /** Delete many Asset documents, return deleted documents */
  deleteManyAssetsConnection: AssetConnection;
  /**
   * Delete many Auth0Role documents
   * @deprecated Please use the new paginated many mutation (deleteManyAuth0RolesConnection)
   */
  deleteManyAuth0Roles: BatchPayload;
  /** Delete many Auth0Role documents, return deleted documents */
  deleteManyAuth0RolesConnection: Auth0RoleConnection;
  /**
   * Delete many AvatarPool documents
   * @deprecated Please use the new paginated many mutation (deleteManyAvatarPoolsConnection)
   */
  deleteManyAvatarPools: BatchPayload;
  /** Delete many AvatarPool documents, return deleted documents */
  deleteManyAvatarPoolsConnection: AvatarPoolConnection;
  /**
   * Delete many AvatarTaggingAttribute documents
   * @deprecated Please use the new paginated many mutation (deleteManyAvatarTaggingAttributesConnection)
   */
  deleteManyAvatarTaggingAttributes: BatchPayload;
  /** Delete many AvatarTaggingAttribute documents, return deleted documents */
  deleteManyAvatarTaggingAttributesConnection: AvatarTaggingAttributeConnection;
  /**
   * Delete many AvatarVariantStyle documents
   * @deprecated Please use the new paginated many mutation (deleteManyAvatarVariantStylesConnection)
   */
  deleteManyAvatarVariantStyles: BatchPayload;
  /** Delete many AvatarVariantStyle documents, return deleted documents */
  deleteManyAvatarVariantStylesConnection: AvatarVariantStyleConnection;
  /**
   * Delete many Avatar documents
   * @deprecated Please use the new paginated many mutation (deleteManyAvatarsConnection)
   */
  deleteManyAvatars: BatchPayload;
  /** Delete many Avatar documents, return deleted documents */
  deleteManyAvatarsConnection: AvatarConnection;
  /**
   * Delete many ContentTile documents
   * @deprecated Please use the new paginated many mutation (deleteManyContentTilesConnection)
   */
  deleteManyContentTiles: BatchPayload;
  /** Delete many ContentTile documents, return deleted documents */
  deleteManyContentTilesConnection: ContentTileConnection;
  /**
   * Delete many TTSModelFeature documents
   * @deprecated Please use the new paginated many mutation (deleteManyTTSModelFeaturesConnection)
   */
  deleteManyTTSModelFeatures: BatchPayload;
  /** Delete many TTSModelFeature documents, return deleted documents */
  deleteManyTTSModelFeaturesConnection: TtsModelFeatureConnection;
  /**
   * Delete many TTSModel documents
   * @deprecated Please use the new paginated many mutation (deleteManyTTSModelsConnection)
   */
  deleteManyTTSModels: BatchPayload;
  /** Delete many TTSModel documents, return deleted documents */
  deleteManyTTSModelsConnection: TtsModelConnection;
  /**
   * Delete many VariantRelease documents
   * @deprecated Please use the new paginated many mutation (deleteManyVariantReleasesConnection)
   */
  deleteManyVariantReleases: BatchPayload;
  /** Delete many VariantRelease documents, return deleted documents */
  deleteManyVariantReleasesConnection: VariantReleaseConnection;
  /**
   * Delete many Variant documents
   * @deprecated Please use the new paginated many mutation (deleteManyVariantsConnection)
   */
  deleteManyVariants: BatchPayload;
  /** Delete many Variant documents, return deleted documents */
  deleteManyVariantsConnection: VariantConnection;
  /** Delete and return scheduled operation */
  deleteScheduledOperation?: Maybe<ScheduledOperation>;
  /** Delete one scheduledRelease from _all_ existing stages. Returns deleted document. */
  deleteScheduledRelease?: Maybe<ScheduledRelease>;
  /** Delete one tTSModel from _all_ existing stages. Returns deleted document. */
  deleteTTSModel?: Maybe<TtsModel>;
  /** Delete one tTSModelFeature from _all_ existing stages. Returns deleted document. */
  deleteTTSModelFeature?: Maybe<TtsModelFeature>;
  /** Delete one variant from _all_ existing stages. Returns deleted document. */
  deleteVariant?: Maybe<Variant>;
  /** Delete one variantRelease from _all_ existing stages. Returns deleted document. */
  deleteVariantRelease?: Maybe<VariantRelease>;
  /** Publish one actor */
  publishActor?: Maybe<Actor>;
  /** Publish one actorVariant */
  publishActorVariant?: Maybe<ActorVariant>;
  /** Publish one announcement */
  publishAnnouncement?: Maybe<Announcement>;
  /** Publish one asset */
  publishAsset?: Maybe<Asset>;
  /** Publish one auth0Role */
  publishAuth0Role?: Maybe<Auth0Role>;
  /** Publish one avatar */
  publishAvatar?: Maybe<Avatar>;
  /** Publish one avatarPool */
  publishAvatarPool?: Maybe<AvatarPool>;
  /** Publish one avatarTaggingAttribute */
  publishAvatarTaggingAttribute?: Maybe<AvatarTaggingAttribute>;
  /** Publish one avatarVariantStyle */
  publishAvatarVariantStyle?: Maybe<AvatarVariantStyle>;
  /** Publish one contentTile */
  publishContentTile?: Maybe<ContentTile>;
  /**
   * Publish many ActorVariant documents
   * @deprecated Please use the new paginated many mutation (publishManyActorVariantsConnection)
   */
  publishManyActorVariants: BatchPayload;
  /** Publish many ActorVariant documents */
  publishManyActorVariantsConnection: ActorVariantConnection;
  /**
   * Publish many Actor documents
   * @deprecated Please use the new paginated many mutation (publishManyActorsConnection)
   */
  publishManyActors: BatchPayload;
  /** Publish many Actor documents */
  publishManyActorsConnection: ActorConnection;
  /**
   * Publish many Announcement documents
   * @deprecated Please use the new paginated many mutation (publishManyAnnouncementsConnection)
   */
  publishManyAnnouncements: BatchPayload;
  /** Publish many Announcement documents */
  publishManyAnnouncementsConnection: AnnouncementConnection;
  /**
   * Publish many Asset documents
   * @deprecated Please use the new paginated many mutation (publishManyAssetsConnection)
   */
  publishManyAssets: BatchPayload;
  /** Publish many Asset documents */
  publishManyAssetsConnection: AssetConnection;
  /**
   * Publish many Auth0Role documents
   * @deprecated Please use the new paginated many mutation (publishManyAuth0RolesConnection)
   */
  publishManyAuth0Roles: BatchPayload;
  /** Publish many Auth0Role documents */
  publishManyAuth0RolesConnection: Auth0RoleConnection;
  /**
   * Publish many AvatarPool documents
   * @deprecated Please use the new paginated many mutation (publishManyAvatarPoolsConnection)
   */
  publishManyAvatarPools: BatchPayload;
  /** Publish many AvatarPool documents */
  publishManyAvatarPoolsConnection: AvatarPoolConnection;
  /**
   * Publish many AvatarTaggingAttribute documents
   * @deprecated Please use the new paginated many mutation (publishManyAvatarTaggingAttributesConnection)
   */
  publishManyAvatarTaggingAttributes: BatchPayload;
  /** Publish many AvatarTaggingAttribute documents */
  publishManyAvatarTaggingAttributesConnection: AvatarTaggingAttributeConnection;
  /**
   * Publish many AvatarVariantStyle documents
   * @deprecated Please use the new paginated many mutation (publishManyAvatarVariantStylesConnection)
   */
  publishManyAvatarVariantStyles: BatchPayload;
  /** Publish many AvatarVariantStyle documents */
  publishManyAvatarVariantStylesConnection: AvatarVariantStyleConnection;
  /**
   * Publish many Avatar documents
   * @deprecated Please use the new paginated many mutation (publishManyAvatarsConnection)
   */
  publishManyAvatars: BatchPayload;
  /** Publish many Avatar documents */
  publishManyAvatarsConnection: AvatarConnection;
  /**
   * Publish many ContentTile documents
   * @deprecated Please use the new paginated many mutation (publishManyContentTilesConnection)
   */
  publishManyContentTiles: BatchPayload;
  /** Publish many ContentTile documents */
  publishManyContentTilesConnection: ContentTileConnection;
  /**
   * Publish many TTSModelFeature documents
   * @deprecated Please use the new paginated many mutation (publishManyTTSModelFeaturesConnection)
   */
  publishManyTTSModelFeatures: BatchPayload;
  /** Publish many TTSModelFeature documents */
  publishManyTTSModelFeaturesConnection: TtsModelFeatureConnection;
  /**
   * Publish many TTSModel documents
   * @deprecated Please use the new paginated many mutation (publishManyTTSModelsConnection)
   */
  publishManyTTSModels: BatchPayload;
  /** Publish many TTSModel documents */
  publishManyTTSModelsConnection: TtsModelConnection;
  /**
   * Publish many VariantRelease documents
   * @deprecated Please use the new paginated many mutation (publishManyVariantReleasesConnection)
   */
  publishManyVariantReleases: BatchPayload;
  /** Publish many VariantRelease documents */
  publishManyVariantReleasesConnection: VariantReleaseConnection;
  /**
   * Publish many Variant documents
   * @deprecated Please use the new paginated many mutation (publishManyVariantsConnection)
   */
  publishManyVariants: BatchPayload;
  /** Publish many Variant documents */
  publishManyVariantsConnection: VariantConnection;
  /** Publish one tTSModel */
  publishTTSModel?: Maybe<TtsModel>;
  /** Publish one tTSModelFeature */
  publishTTSModelFeature?: Maybe<TtsModelFeature>;
  /** Publish one variant */
  publishVariant?: Maybe<Variant>;
  /** Publish one variantRelease */
  publishVariantRelease?: Maybe<VariantRelease>;
  /** Schedule to publish one actor */
  schedulePublishActor?: Maybe<Actor>;
  /** Schedule to publish one actorVariant */
  schedulePublishActorVariant?: Maybe<ActorVariant>;
  /** Schedule to publish one announcement */
  schedulePublishAnnouncement?: Maybe<Announcement>;
  /** Schedule to publish one asset */
  schedulePublishAsset?: Maybe<Asset>;
  /** Schedule to publish one auth0Role */
  schedulePublishAuth0Role?: Maybe<Auth0Role>;
  /** Schedule to publish one avatar */
  schedulePublishAvatar?: Maybe<Avatar>;
  /** Schedule to publish one avatarPool */
  schedulePublishAvatarPool?: Maybe<AvatarPool>;
  /** Schedule to publish one avatarTaggingAttribute */
  schedulePublishAvatarTaggingAttribute?: Maybe<AvatarTaggingAttribute>;
  /** Schedule to publish one avatarVariantStyle */
  schedulePublishAvatarVariantStyle?: Maybe<AvatarVariantStyle>;
  /** Schedule to publish one contentTile */
  schedulePublishContentTile?: Maybe<ContentTile>;
  /** Schedule to publish one tTSModel */
  schedulePublishTTSModel?: Maybe<TtsModel>;
  /** Schedule to publish one tTSModelFeature */
  schedulePublishTTSModelFeature?: Maybe<TtsModelFeature>;
  /** Schedule to publish one variant */
  schedulePublishVariant?: Maybe<Variant>;
  /** Schedule to publish one variantRelease */
  schedulePublishVariantRelease?: Maybe<VariantRelease>;
  /** Unpublish one actor from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishActor?: Maybe<Actor>;
  /** Unpublish one actorVariant from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishActorVariant?: Maybe<ActorVariant>;
  /** Unpublish one announcement from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAnnouncement?: Maybe<Announcement>;
  /** Unpublish one asset from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAsset?: Maybe<Asset>;
  /** Unpublish one auth0Role from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAuth0Role?: Maybe<Auth0Role>;
  /** Unpublish one avatar from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAvatar?: Maybe<Avatar>;
  /** Unpublish one avatarPool from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAvatarPool?: Maybe<AvatarPool>;
  /** Unpublish one avatarTaggingAttribute from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAvatarTaggingAttribute?: Maybe<AvatarTaggingAttribute>;
  /** Unpublish one avatarVariantStyle from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAvatarVariantStyle?: Maybe<AvatarVariantStyle>;
  /** Unpublish one contentTile from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishContentTile?: Maybe<ContentTile>;
  /** Unpublish one tTSModel from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishTTSModel?: Maybe<TtsModel>;
  /** Unpublish one tTSModelFeature from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishTTSModelFeature?: Maybe<TtsModelFeature>;
  /** Unpublish one variant from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishVariant?: Maybe<Variant>;
  /** Unpublish one variantRelease from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishVariantRelease?: Maybe<VariantRelease>;
  /** Unpublish one actor from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishActor?: Maybe<Actor>;
  /** Unpublish one actorVariant from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishActorVariant?: Maybe<ActorVariant>;
  /** Unpublish one announcement from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAnnouncement?: Maybe<Announcement>;
  /** Unpublish one asset from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAsset?: Maybe<Asset>;
  /** Unpublish one auth0Role from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAuth0Role?: Maybe<Auth0Role>;
  /** Unpublish one avatar from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAvatar?: Maybe<Avatar>;
  /** Unpublish one avatarPool from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAvatarPool?: Maybe<AvatarPool>;
  /** Unpublish one avatarTaggingAttribute from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAvatarTaggingAttribute?: Maybe<AvatarTaggingAttribute>;
  /** Unpublish one avatarVariantStyle from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAvatarVariantStyle?: Maybe<AvatarVariantStyle>;
  /** Unpublish one contentTile from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishContentTile?: Maybe<ContentTile>;
  /**
   * Unpublish many ActorVariant documents
   * @deprecated Please use the new paginated many mutation (unpublishManyActorVariantsConnection)
   */
  unpublishManyActorVariants: BatchPayload;
  /** Find many ActorVariant documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyActorVariantsConnection: ActorVariantConnection;
  /**
   * Unpublish many Actor documents
   * @deprecated Please use the new paginated many mutation (unpublishManyActorsConnection)
   */
  unpublishManyActors: BatchPayload;
  /** Find many Actor documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyActorsConnection: ActorConnection;
  /**
   * Unpublish many Announcement documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAnnouncementsConnection)
   */
  unpublishManyAnnouncements: BatchPayload;
  /** Find many Announcement documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAnnouncementsConnection: AnnouncementConnection;
  /**
   * Unpublish many Asset documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAssetsConnection)
   */
  unpublishManyAssets: BatchPayload;
  /** Find many Asset documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAssetsConnection: AssetConnection;
  /**
   * Unpublish many Auth0Role documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAuth0RolesConnection)
   */
  unpublishManyAuth0Roles: BatchPayload;
  /** Find many Auth0Role documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAuth0RolesConnection: Auth0RoleConnection;
  /**
   * Unpublish many AvatarPool documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAvatarPoolsConnection)
   */
  unpublishManyAvatarPools: BatchPayload;
  /** Find many AvatarPool documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAvatarPoolsConnection: AvatarPoolConnection;
  /**
   * Unpublish many AvatarTaggingAttribute documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAvatarTaggingAttributesConnection)
   */
  unpublishManyAvatarTaggingAttributes: BatchPayload;
  /** Find many AvatarTaggingAttribute documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAvatarTaggingAttributesConnection: AvatarTaggingAttributeConnection;
  /**
   * Unpublish many AvatarVariantStyle documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAvatarVariantStylesConnection)
   */
  unpublishManyAvatarVariantStyles: BatchPayload;
  /** Find many AvatarVariantStyle documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAvatarVariantStylesConnection: AvatarVariantStyleConnection;
  /**
   * Unpublish many Avatar documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAvatarsConnection)
   */
  unpublishManyAvatars: BatchPayload;
  /** Find many Avatar documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAvatarsConnection: AvatarConnection;
  /**
   * Unpublish many ContentTile documents
   * @deprecated Please use the new paginated many mutation (unpublishManyContentTilesConnection)
   */
  unpublishManyContentTiles: BatchPayload;
  /** Find many ContentTile documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyContentTilesConnection: ContentTileConnection;
  /**
   * Unpublish many TTSModelFeature documents
   * @deprecated Please use the new paginated many mutation (unpublishManyTTSModelFeaturesConnection)
   */
  unpublishManyTTSModelFeatures: BatchPayload;
  /** Find many TTSModelFeature documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyTTSModelFeaturesConnection: TtsModelFeatureConnection;
  /**
   * Unpublish many TTSModel documents
   * @deprecated Please use the new paginated many mutation (unpublishManyTTSModelsConnection)
   */
  unpublishManyTTSModels: BatchPayload;
  /** Find many TTSModel documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyTTSModelsConnection: TtsModelConnection;
  /**
   * Unpublish many VariantRelease documents
   * @deprecated Please use the new paginated many mutation (unpublishManyVariantReleasesConnection)
   */
  unpublishManyVariantReleases: BatchPayload;
  /** Find many VariantRelease documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyVariantReleasesConnection: VariantReleaseConnection;
  /**
   * Unpublish many Variant documents
   * @deprecated Please use the new paginated many mutation (unpublishManyVariantsConnection)
   */
  unpublishManyVariants: BatchPayload;
  /** Find many Variant documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyVariantsConnection: VariantConnection;
  /** Unpublish one tTSModel from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishTTSModel?: Maybe<TtsModel>;
  /** Unpublish one tTSModelFeature from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishTTSModelFeature?: Maybe<TtsModelFeature>;
  /** Unpublish one variant from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishVariant?: Maybe<Variant>;
  /** Unpublish one variantRelease from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishVariantRelease?: Maybe<VariantRelease>;
  /** Update one actor */
  updateActor?: Maybe<Actor>;
  /** Update one actorVariant */
  updateActorVariant?: Maybe<ActorVariant>;
  /** Update one announcement */
  updateAnnouncement?: Maybe<Announcement>;
  /** Update one asset */
  updateAsset?: Maybe<Asset>;
  /** Update one auth0Role */
  updateAuth0Role?: Maybe<Auth0Role>;
  /** Update one avatar */
  updateAvatar?: Maybe<Avatar>;
  /** Update one avatarPool */
  updateAvatarPool?: Maybe<AvatarPool>;
  /** Update one avatarTaggingAttribute */
  updateAvatarTaggingAttribute?: Maybe<AvatarTaggingAttribute>;
  /** Update one avatarVariantStyle */
  updateAvatarVariantStyle?: Maybe<AvatarVariantStyle>;
  /** Update one contentTile */
  updateContentTile?: Maybe<ContentTile>;
  /**
   * Update many actorVariants
   * @deprecated Please use the new paginated many mutation (updateManyActorVariantsConnection)
   */
  updateManyActorVariants: BatchPayload;
  /** Update many ActorVariant documents */
  updateManyActorVariantsConnection: ActorVariantConnection;
  /**
   * Update many actors
   * @deprecated Please use the new paginated many mutation (updateManyActorsConnection)
   */
  updateManyActors: BatchPayload;
  /** Update many Actor documents */
  updateManyActorsConnection: ActorConnection;
  /**
   * Update many announcements
   * @deprecated Please use the new paginated many mutation (updateManyAnnouncementsConnection)
   */
  updateManyAnnouncements: BatchPayload;
  /** Update many Announcement documents */
  updateManyAnnouncementsConnection: AnnouncementConnection;
  /**
   * Update many assets
   * @deprecated Please use the new paginated many mutation (updateManyAssetsConnection)
   */
  updateManyAssets: BatchPayload;
  /** Update many Asset documents */
  updateManyAssetsConnection: AssetConnection;
  /**
   * Update many auth0Roles
   * @deprecated Please use the new paginated many mutation (updateManyAuth0RolesConnection)
   */
  updateManyAuth0Roles: BatchPayload;
  /** Update many Auth0Role documents */
  updateManyAuth0RolesConnection: Auth0RoleConnection;
  /**
   * Update many avatarPools
   * @deprecated Please use the new paginated many mutation (updateManyAvatarPoolsConnection)
   */
  updateManyAvatarPools: BatchPayload;
  /** Update many AvatarPool documents */
  updateManyAvatarPoolsConnection: AvatarPoolConnection;
  /**
   * Update many avatarTaggingAttributes
   * @deprecated Please use the new paginated many mutation (updateManyAvatarTaggingAttributesConnection)
   */
  updateManyAvatarTaggingAttributes: BatchPayload;
  /** Update many AvatarTaggingAttribute documents */
  updateManyAvatarTaggingAttributesConnection: AvatarTaggingAttributeConnection;
  /**
   * Update many avatarVariantStyles
   * @deprecated Please use the new paginated many mutation (updateManyAvatarVariantStylesConnection)
   */
  updateManyAvatarVariantStyles: BatchPayload;
  /** Update many AvatarVariantStyle documents */
  updateManyAvatarVariantStylesConnection: AvatarVariantStyleConnection;
  /**
   * Update many avatars
   * @deprecated Please use the new paginated many mutation (updateManyAvatarsConnection)
   */
  updateManyAvatars: BatchPayload;
  /** Update many Avatar documents */
  updateManyAvatarsConnection: AvatarConnection;
  /**
   * Update many contentTiles
   * @deprecated Please use the new paginated many mutation (updateManyContentTilesConnection)
   */
  updateManyContentTiles: BatchPayload;
  /** Update many ContentTile documents */
  updateManyContentTilesConnection: ContentTileConnection;
  /**
   * Update many tTSModelFeatures
   * @deprecated Please use the new paginated many mutation (updateManyTTSModelFeaturesConnection)
   */
  updateManyTTSModelFeatures: BatchPayload;
  /** Update many TTSModelFeature documents */
  updateManyTTSModelFeaturesConnection: TtsModelFeatureConnection;
  /**
   * Update many tTSModels
   * @deprecated Please use the new paginated many mutation (updateManyTTSModelsConnection)
   */
  updateManyTTSModels: BatchPayload;
  /** Update many TTSModel documents */
  updateManyTTSModelsConnection: TtsModelConnection;
  /**
   * Update many variantReleases
   * @deprecated Please use the new paginated many mutation (updateManyVariantReleasesConnection)
   */
  updateManyVariantReleases: BatchPayload;
  /** Update many VariantRelease documents */
  updateManyVariantReleasesConnection: VariantReleaseConnection;
  /**
   * Update many variants
   * @deprecated Please use the new paginated many mutation (updateManyVariantsConnection)
   */
  updateManyVariants: BatchPayload;
  /** Update many Variant documents */
  updateManyVariantsConnection: VariantConnection;
  /** Update one scheduledRelease */
  updateScheduledRelease?: Maybe<ScheduledRelease>;
  /** Update one tTSModel */
  updateTTSModel?: Maybe<TtsModel>;
  /** Update one tTSModelFeature */
  updateTTSModelFeature?: Maybe<TtsModelFeature>;
  /** Update one variant */
  updateVariant?: Maybe<Variant>;
  /** Update one variantRelease */
  updateVariantRelease?: Maybe<VariantRelease>;
  /** Upsert one actor */
  upsertActor?: Maybe<Actor>;
  /** Upsert one actorVariant */
  upsertActorVariant?: Maybe<ActorVariant>;
  /** Upsert one announcement */
  upsertAnnouncement?: Maybe<Announcement>;
  /** Upsert one asset */
  upsertAsset?: Maybe<Asset>;
  /** Upsert one auth0Role */
  upsertAuth0Role?: Maybe<Auth0Role>;
  /** Upsert one avatar */
  upsertAvatar?: Maybe<Avatar>;
  /** Upsert one avatarPool */
  upsertAvatarPool?: Maybe<AvatarPool>;
  /** Upsert one avatarTaggingAttribute */
  upsertAvatarTaggingAttribute?: Maybe<AvatarTaggingAttribute>;
  /** Upsert one avatarVariantStyle */
  upsertAvatarVariantStyle?: Maybe<AvatarVariantStyle>;
  /** Upsert one contentTile */
  upsertContentTile?: Maybe<ContentTile>;
  /** Upsert one tTSModel */
  upsertTTSModel?: Maybe<TtsModel>;
  /** Upsert one tTSModelFeature */
  upsertTTSModelFeature?: Maybe<TtsModelFeature>;
  /** Upsert one variant */
  upsertVariant?: Maybe<Variant>;
  /** Upsert one variantRelease */
  upsertVariantRelease?: Maybe<VariantRelease>;
};

export type MutationCreateActorArgs = {
  data: ActorCreateInput;
};

export type MutationCreateActorVariantArgs = {
  data: ActorVariantCreateInput;
};

export type MutationCreateAnnouncementArgs = {
  data: AnnouncementCreateInput;
};

export type MutationCreateAssetArgs = {
  data: AssetCreateInput;
};

export type MutationCreateAuth0RoleArgs = {
  data: Auth0RoleCreateInput;
};

export type MutationCreateAvatarArgs = {
  data: AvatarCreateInput;
};

export type MutationCreateAvatarPoolArgs = {
  data: AvatarPoolCreateInput;
};

export type MutationCreateAvatarTaggingAttributeArgs = {
  data: AvatarTaggingAttributeCreateInput;
};

export type MutationCreateAvatarVariantStyleArgs = {
  data: AvatarVariantStyleCreateInput;
};

export type MutationCreateContentTileArgs = {
  data: ContentTileCreateInput;
};

export type MutationCreateScheduledReleaseArgs = {
  data: ScheduledReleaseCreateInput;
};

export type MutationCreateTtsModelArgs = {
  data: TtsModelCreateInput;
};

export type MutationCreateTtsModelFeatureArgs = {
  data: TtsModelFeatureCreateInput;
};

export type MutationCreateVariantArgs = {
  data: VariantCreateInput;
};

export type MutationCreateVariantReleaseArgs = {
  data: VariantReleaseCreateInput;
};

export type MutationDeleteActorArgs = {
  where: ActorWhereUniqueInput;
};

export type MutationDeleteActorVariantArgs = {
  where: ActorVariantWhereUniqueInput;
};

export type MutationDeleteAnnouncementArgs = {
  where: AnnouncementWhereUniqueInput;
};

export type MutationDeleteAssetArgs = {
  where: AssetWhereUniqueInput;
};

export type MutationDeleteAuth0RoleArgs = {
  where: Auth0RoleWhereUniqueInput;
};

export type MutationDeleteAvatarArgs = {
  where: AvatarWhereUniqueInput;
};

export type MutationDeleteAvatarPoolArgs = {
  where: AvatarPoolWhereUniqueInput;
};

export type MutationDeleteAvatarTaggingAttributeArgs = {
  where: AvatarTaggingAttributeWhereUniqueInput;
};

export type MutationDeleteAvatarVariantStyleArgs = {
  where: AvatarVariantStyleWhereUniqueInput;
};

export type MutationDeleteContentTileArgs = {
  where: ContentTileWhereUniqueInput;
};

export type MutationDeleteManyActorVariantsArgs = {
  where?: InputMaybe<ActorVariantManyWhereInput>;
};

export type MutationDeleteManyActorVariantsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ActorVariantManyWhereInput>;
};

export type MutationDeleteManyActorsArgs = {
  where?: InputMaybe<ActorManyWhereInput>;
};

export type MutationDeleteManyActorsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ActorManyWhereInput>;
};

export type MutationDeleteManyAnnouncementsArgs = {
  where?: InputMaybe<AnnouncementManyWhereInput>;
};

export type MutationDeleteManyAnnouncementsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnnouncementManyWhereInput>;
};

export type MutationDeleteManyAssetsArgs = {
  where?: InputMaybe<AssetManyWhereInput>;
};

export type MutationDeleteManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetManyWhereInput>;
};

export type MutationDeleteManyAuth0RolesArgs = {
  where?: InputMaybe<Auth0RoleManyWhereInput>;
};

export type MutationDeleteManyAuth0RolesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Auth0RoleManyWhereInput>;
};

export type MutationDeleteManyAvatarPoolsArgs = {
  where?: InputMaybe<AvatarPoolManyWhereInput>;
};

export type MutationDeleteManyAvatarPoolsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AvatarPoolManyWhereInput>;
};

export type MutationDeleteManyAvatarTaggingAttributesArgs = {
  where?: InputMaybe<AvatarTaggingAttributeManyWhereInput>;
};

export type MutationDeleteManyAvatarTaggingAttributesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AvatarTaggingAttributeManyWhereInput>;
};

export type MutationDeleteManyAvatarVariantStylesArgs = {
  where?: InputMaybe<AvatarVariantStyleManyWhereInput>;
};

export type MutationDeleteManyAvatarVariantStylesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AvatarVariantStyleManyWhereInput>;
};

export type MutationDeleteManyAvatarsArgs = {
  where?: InputMaybe<AvatarManyWhereInput>;
};

export type MutationDeleteManyAvatarsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AvatarManyWhereInput>;
};

export type MutationDeleteManyContentTilesArgs = {
  where?: InputMaybe<ContentTileManyWhereInput>;
};

export type MutationDeleteManyContentTilesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentTileManyWhereInput>;
};

export type MutationDeleteManyTtsModelFeaturesArgs = {
  where?: InputMaybe<TtsModelFeatureManyWhereInput>;
};

export type MutationDeleteManyTtsModelFeaturesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TtsModelFeatureManyWhereInput>;
};

export type MutationDeleteManyTtsModelsArgs = {
  where?: InputMaybe<TtsModelManyWhereInput>;
};

export type MutationDeleteManyTtsModelsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TtsModelManyWhereInput>;
};

export type MutationDeleteManyVariantReleasesArgs = {
  where?: InputMaybe<VariantReleaseManyWhereInput>;
};

export type MutationDeleteManyVariantReleasesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VariantReleaseManyWhereInput>;
};

export type MutationDeleteManyVariantsArgs = {
  where?: InputMaybe<VariantManyWhereInput>;
};

export type MutationDeleteManyVariantsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VariantManyWhereInput>;
};

export type MutationDeleteScheduledOperationArgs = {
  where: ScheduledOperationWhereUniqueInput;
};

export type MutationDeleteScheduledReleaseArgs = {
  where: ScheduledReleaseWhereUniqueInput;
};

export type MutationDeleteTtsModelArgs = {
  where: TtsModelWhereUniqueInput;
};

export type MutationDeleteTtsModelFeatureArgs = {
  where: TtsModelFeatureWhereUniqueInput;
};

export type MutationDeleteVariantArgs = {
  where: VariantWhereUniqueInput;
};

export type MutationDeleteVariantReleaseArgs = {
  where: VariantReleaseWhereUniqueInput;
};

export type MutationPublishActorArgs = {
  to?: Array<Stage>;
  where: ActorWhereUniqueInput;
};

export type MutationPublishActorVariantArgs = {
  to?: Array<Stage>;
  where: ActorVariantWhereUniqueInput;
};

export type MutationPublishAnnouncementArgs = {
  to?: Array<Stage>;
  where: AnnouncementWhereUniqueInput;
};

export type MutationPublishAssetArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: AssetWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationPublishAuth0RoleArgs = {
  to?: Array<Stage>;
  where: Auth0RoleWhereUniqueInput;
};

export type MutationPublishAvatarArgs = {
  to?: Array<Stage>;
  where: AvatarWhereUniqueInput;
};

export type MutationPublishAvatarPoolArgs = {
  to?: Array<Stage>;
  where: AvatarPoolWhereUniqueInput;
};

export type MutationPublishAvatarTaggingAttributeArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: AvatarTaggingAttributeWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationPublishAvatarVariantStyleArgs = {
  to?: Array<Stage>;
  where: AvatarVariantStyleWhereUniqueInput;
};

export type MutationPublishContentTileArgs = {
  to?: Array<Stage>;
  where: ContentTileWhereUniqueInput;
};

export type MutationPublishManyActorVariantsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<ActorVariantManyWhereInput>;
};

export type MutationPublishManyActorVariantsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ActorVariantManyWhereInput>;
};

export type MutationPublishManyActorsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<ActorManyWhereInput>;
};

export type MutationPublishManyActorsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ActorManyWhereInput>;
};

export type MutationPublishManyAnnouncementsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<AnnouncementManyWhereInput>;
};

export type MutationPublishManyAnnouncementsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AnnouncementManyWhereInput>;
};

export type MutationPublishManyAssetsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AssetManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationPublishManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AssetManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationPublishManyAuth0RolesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<Auth0RoleManyWhereInput>;
};

export type MutationPublishManyAuth0RolesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<Auth0RoleManyWhereInput>;
};

export type MutationPublishManyAvatarPoolsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<AvatarPoolManyWhereInput>;
};

export type MutationPublishManyAvatarPoolsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AvatarPoolManyWhereInput>;
};

export type MutationPublishManyAvatarTaggingAttributesArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AvatarTaggingAttributeManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationPublishManyAvatarTaggingAttributesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AvatarTaggingAttributeManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationPublishManyAvatarVariantStylesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<AvatarVariantStyleManyWhereInput>;
};

export type MutationPublishManyAvatarVariantStylesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AvatarVariantStyleManyWhereInput>;
};

export type MutationPublishManyAvatarsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<AvatarManyWhereInput>;
};

export type MutationPublishManyAvatarsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AvatarManyWhereInput>;
};

export type MutationPublishManyContentTilesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<ContentTileManyWhereInput>;
};

export type MutationPublishManyContentTilesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ContentTileManyWhereInput>;
};

export type MutationPublishManyTtsModelFeaturesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<TtsModelFeatureManyWhereInput>;
};

export type MutationPublishManyTtsModelFeaturesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<TtsModelFeatureManyWhereInput>;
};

export type MutationPublishManyTtsModelsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<TtsModelManyWhereInput>;
};

export type MutationPublishManyTtsModelsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<TtsModelManyWhereInput>;
};

export type MutationPublishManyVariantReleasesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<VariantReleaseManyWhereInput>;
};

export type MutationPublishManyVariantReleasesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<VariantReleaseManyWhereInput>;
};

export type MutationPublishManyVariantsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<VariantManyWhereInput>;
};

export type MutationPublishManyVariantsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<VariantManyWhereInput>;
};

export type MutationPublishTtsModelArgs = {
  to?: Array<Stage>;
  where: TtsModelWhereUniqueInput;
};

export type MutationPublishTtsModelFeatureArgs = {
  to?: Array<Stage>;
  where: TtsModelFeatureWhereUniqueInput;
};

export type MutationPublishVariantArgs = {
  to?: Array<Stage>;
  where: VariantWhereUniqueInput;
};

export type MutationPublishVariantReleaseArgs = {
  to?: Array<Stage>;
  where: VariantReleaseWhereUniqueInput;
};

export type MutationSchedulePublishActorArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ActorWhereUniqueInput;
};

export type MutationSchedulePublishActorVariantArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ActorVariantWhereUniqueInput;
};

export type MutationSchedulePublishAnnouncementArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: AnnouncementWhereUniqueInput;
};

export type MutationSchedulePublishAssetArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: AssetWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationSchedulePublishAuth0RoleArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: Auth0RoleWhereUniqueInput;
};

export type MutationSchedulePublishAvatarArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: AvatarWhereUniqueInput;
};

export type MutationSchedulePublishAvatarPoolArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: AvatarPoolWhereUniqueInput;
};

export type MutationSchedulePublishAvatarTaggingAttributeArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: AvatarTaggingAttributeWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationSchedulePublishAvatarVariantStyleArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: AvatarVariantStyleWhereUniqueInput;
};

export type MutationSchedulePublishContentTileArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ContentTileWhereUniqueInput;
};

export type MutationSchedulePublishTtsModelArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: TtsModelWhereUniqueInput;
};

export type MutationSchedulePublishTtsModelFeatureArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: TtsModelFeatureWhereUniqueInput;
};

export type MutationSchedulePublishVariantArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: VariantWhereUniqueInput;
};

export type MutationSchedulePublishVariantReleaseArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: VariantReleaseWhereUniqueInput;
};

export type MutationScheduleUnpublishActorArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: ActorWhereUniqueInput;
};

export type MutationScheduleUnpublishActorVariantArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: ActorVariantWhereUniqueInput;
};

export type MutationScheduleUnpublishAnnouncementArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: AnnouncementWhereUniqueInput;
};

export type MutationScheduleUnpublishAssetArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: AssetWhereUniqueInput;
};

export type MutationScheduleUnpublishAuth0RoleArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: Auth0RoleWhereUniqueInput;
};

export type MutationScheduleUnpublishAvatarArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: AvatarWhereUniqueInput;
};

export type MutationScheduleUnpublishAvatarPoolArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: AvatarPoolWhereUniqueInput;
};

export type MutationScheduleUnpublishAvatarTaggingAttributeArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: AvatarTaggingAttributeWhereUniqueInput;
};

export type MutationScheduleUnpublishAvatarVariantStyleArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: AvatarVariantStyleWhereUniqueInput;
};

export type MutationScheduleUnpublishContentTileArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: ContentTileWhereUniqueInput;
};

export type MutationScheduleUnpublishTtsModelArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: TtsModelWhereUniqueInput;
};

export type MutationScheduleUnpublishTtsModelFeatureArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: TtsModelFeatureWhereUniqueInput;
};

export type MutationScheduleUnpublishVariantArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: VariantWhereUniqueInput;
};

export type MutationScheduleUnpublishVariantReleaseArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: VariantReleaseWhereUniqueInput;
};

export type MutationUnpublishActorArgs = {
  from?: Array<Stage>;
  where: ActorWhereUniqueInput;
};

export type MutationUnpublishActorVariantArgs = {
  from?: Array<Stage>;
  where: ActorVariantWhereUniqueInput;
};

export type MutationUnpublishAnnouncementArgs = {
  from?: Array<Stage>;
  where: AnnouncementWhereUniqueInput;
};

export type MutationUnpublishAssetArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: AssetWhereUniqueInput;
};

export type MutationUnpublishAuth0RoleArgs = {
  from?: Array<Stage>;
  where: Auth0RoleWhereUniqueInput;
};

export type MutationUnpublishAvatarArgs = {
  from?: Array<Stage>;
  where: AvatarWhereUniqueInput;
};

export type MutationUnpublishAvatarPoolArgs = {
  from?: Array<Stage>;
  where: AvatarPoolWhereUniqueInput;
};

export type MutationUnpublishAvatarTaggingAttributeArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: AvatarTaggingAttributeWhereUniqueInput;
};

export type MutationUnpublishAvatarVariantStyleArgs = {
  from?: Array<Stage>;
  where: AvatarVariantStyleWhereUniqueInput;
};

export type MutationUnpublishContentTileArgs = {
  from?: Array<Stage>;
  where: ContentTileWhereUniqueInput;
};

export type MutationUnpublishManyActorVariantsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<ActorVariantManyWhereInput>;
};

export type MutationUnpublishManyActorVariantsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<ActorVariantManyWhereInput>;
};

export type MutationUnpublishManyActorsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<ActorManyWhereInput>;
};

export type MutationUnpublishManyActorsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<ActorManyWhereInput>;
};

export type MutationUnpublishManyAnnouncementsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<AnnouncementManyWhereInput>;
};

export type MutationUnpublishManyAnnouncementsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<AnnouncementManyWhereInput>;
};

export type MutationUnpublishManyAssetsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssetManyWhereInput>;
};

export type MutationUnpublishManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssetManyWhereInput>;
};

export type MutationUnpublishManyAuth0RolesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<Auth0RoleManyWhereInput>;
};

export type MutationUnpublishManyAuth0RolesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<Auth0RoleManyWhereInput>;
};

export type MutationUnpublishManyAvatarPoolsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<AvatarPoolManyWhereInput>;
};

export type MutationUnpublishManyAvatarPoolsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<AvatarPoolManyWhereInput>;
};

export type MutationUnpublishManyAvatarTaggingAttributesArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AvatarTaggingAttributeManyWhereInput>;
};

export type MutationUnpublishManyAvatarTaggingAttributesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AvatarTaggingAttributeManyWhereInput>;
};

export type MutationUnpublishManyAvatarVariantStylesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<AvatarVariantStyleManyWhereInput>;
};

export type MutationUnpublishManyAvatarVariantStylesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<AvatarVariantStyleManyWhereInput>;
};

export type MutationUnpublishManyAvatarsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<AvatarManyWhereInput>;
};

export type MutationUnpublishManyAvatarsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<AvatarManyWhereInput>;
};

export type MutationUnpublishManyContentTilesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<ContentTileManyWhereInput>;
};

export type MutationUnpublishManyContentTilesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<ContentTileManyWhereInput>;
};

export type MutationUnpublishManyTtsModelFeaturesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<TtsModelFeatureManyWhereInput>;
};

export type MutationUnpublishManyTtsModelFeaturesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<TtsModelFeatureManyWhereInput>;
};

export type MutationUnpublishManyTtsModelsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<TtsModelManyWhereInput>;
};

export type MutationUnpublishManyTtsModelsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<TtsModelManyWhereInput>;
};

export type MutationUnpublishManyVariantReleasesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<VariantReleaseManyWhereInput>;
};

export type MutationUnpublishManyVariantReleasesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<VariantReleaseManyWhereInput>;
};

export type MutationUnpublishManyVariantsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<VariantManyWhereInput>;
};

export type MutationUnpublishManyVariantsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<VariantManyWhereInput>;
};

export type MutationUnpublishTtsModelArgs = {
  from?: Array<Stage>;
  where: TtsModelWhereUniqueInput;
};

export type MutationUnpublishTtsModelFeatureArgs = {
  from?: Array<Stage>;
  where: TtsModelFeatureWhereUniqueInput;
};

export type MutationUnpublishVariantArgs = {
  from?: Array<Stage>;
  where: VariantWhereUniqueInput;
};

export type MutationUnpublishVariantReleaseArgs = {
  from?: Array<Stage>;
  where: VariantReleaseWhereUniqueInput;
};

export type MutationUpdateActorArgs = {
  data: ActorUpdateInput;
  where: ActorWhereUniqueInput;
};

export type MutationUpdateActorVariantArgs = {
  data: ActorVariantUpdateInput;
  where: ActorVariantWhereUniqueInput;
};

export type MutationUpdateAnnouncementArgs = {
  data: AnnouncementUpdateInput;
  where: AnnouncementWhereUniqueInput;
};

export type MutationUpdateAssetArgs = {
  data: AssetUpdateInput;
  where: AssetWhereUniqueInput;
};

export type MutationUpdateAuth0RoleArgs = {
  data: Auth0RoleUpdateInput;
  where: Auth0RoleWhereUniqueInput;
};

export type MutationUpdateAvatarArgs = {
  data: AvatarUpdateInput;
  where: AvatarWhereUniqueInput;
};

export type MutationUpdateAvatarPoolArgs = {
  data: AvatarPoolUpdateInput;
  where: AvatarPoolWhereUniqueInput;
};

export type MutationUpdateAvatarTaggingAttributeArgs = {
  data: AvatarTaggingAttributeUpdateInput;
  where: AvatarTaggingAttributeWhereUniqueInput;
};

export type MutationUpdateAvatarVariantStyleArgs = {
  data: AvatarVariantStyleUpdateInput;
  where: AvatarVariantStyleWhereUniqueInput;
};

export type MutationUpdateContentTileArgs = {
  data: ContentTileUpdateInput;
  where: ContentTileWhereUniqueInput;
};

export type MutationUpdateManyActorVariantsArgs = {
  data: ActorVariantUpdateManyInput;
  where?: InputMaybe<ActorVariantManyWhereInput>;
};

export type MutationUpdateManyActorVariantsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ActorVariantUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ActorVariantManyWhereInput>;
};

export type MutationUpdateManyActorsArgs = {
  data: ActorUpdateManyInput;
  where?: InputMaybe<ActorManyWhereInput>;
};

export type MutationUpdateManyActorsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ActorUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ActorManyWhereInput>;
};

export type MutationUpdateManyAnnouncementsArgs = {
  data: AnnouncementUpdateManyInput;
  where?: InputMaybe<AnnouncementManyWhereInput>;
};

export type MutationUpdateManyAnnouncementsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: AnnouncementUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnnouncementManyWhereInput>;
};

export type MutationUpdateManyAssetsArgs = {
  data: AssetUpdateManyInput;
  where?: InputMaybe<AssetManyWhereInput>;
};

export type MutationUpdateManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: AssetUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetManyWhereInput>;
};

export type MutationUpdateManyAuth0RolesArgs = {
  data: Auth0RoleUpdateManyInput;
  where?: InputMaybe<Auth0RoleManyWhereInput>;
};

export type MutationUpdateManyAuth0RolesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: Auth0RoleUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Auth0RoleManyWhereInput>;
};

export type MutationUpdateManyAvatarPoolsArgs = {
  data: AvatarPoolUpdateManyInput;
  where?: InputMaybe<AvatarPoolManyWhereInput>;
};

export type MutationUpdateManyAvatarPoolsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: AvatarPoolUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AvatarPoolManyWhereInput>;
};

export type MutationUpdateManyAvatarTaggingAttributesArgs = {
  data: AvatarTaggingAttributeUpdateManyInput;
  where?: InputMaybe<AvatarTaggingAttributeManyWhereInput>;
};

export type MutationUpdateManyAvatarTaggingAttributesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: AvatarTaggingAttributeUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AvatarTaggingAttributeManyWhereInput>;
};

export type MutationUpdateManyAvatarVariantStylesArgs = {
  data: AvatarVariantStyleUpdateManyInput;
  where?: InputMaybe<AvatarVariantStyleManyWhereInput>;
};

export type MutationUpdateManyAvatarVariantStylesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: AvatarVariantStyleUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AvatarVariantStyleManyWhereInput>;
};

export type MutationUpdateManyAvatarsArgs = {
  data: AvatarUpdateManyInput;
  where?: InputMaybe<AvatarManyWhereInput>;
};

export type MutationUpdateManyAvatarsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: AvatarUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AvatarManyWhereInput>;
};

export type MutationUpdateManyContentTilesArgs = {
  data: ContentTileUpdateManyInput;
  where?: InputMaybe<ContentTileManyWhereInput>;
};

export type MutationUpdateManyContentTilesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ContentTileUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentTileManyWhereInput>;
};

export type MutationUpdateManyTtsModelFeaturesArgs = {
  data: TtsModelFeatureUpdateManyInput;
  where?: InputMaybe<TtsModelFeatureManyWhereInput>;
};

export type MutationUpdateManyTtsModelFeaturesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: TtsModelFeatureUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TtsModelFeatureManyWhereInput>;
};

export type MutationUpdateManyTtsModelsArgs = {
  data: TtsModelUpdateManyInput;
  where?: InputMaybe<TtsModelManyWhereInput>;
};

export type MutationUpdateManyTtsModelsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: TtsModelUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TtsModelManyWhereInput>;
};

export type MutationUpdateManyVariantReleasesArgs = {
  data: VariantReleaseUpdateManyInput;
  where?: InputMaybe<VariantReleaseManyWhereInput>;
};

export type MutationUpdateManyVariantReleasesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: VariantReleaseUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VariantReleaseManyWhereInput>;
};

export type MutationUpdateManyVariantsArgs = {
  data: VariantUpdateManyInput;
  where?: InputMaybe<VariantManyWhereInput>;
};

export type MutationUpdateManyVariantsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: VariantUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VariantManyWhereInput>;
};

export type MutationUpdateScheduledReleaseArgs = {
  data: ScheduledReleaseUpdateInput;
  where: ScheduledReleaseWhereUniqueInput;
};

export type MutationUpdateTtsModelArgs = {
  data: TtsModelUpdateInput;
  where: TtsModelWhereUniqueInput;
};

export type MutationUpdateTtsModelFeatureArgs = {
  data: TtsModelFeatureUpdateInput;
  where: TtsModelFeatureWhereUniqueInput;
};

export type MutationUpdateVariantArgs = {
  data: VariantUpdateInput;
  where: VariantWhereUniqueInput;
};

export type MutationUpdateVariantReleaseArgs = {
  data: VariantReleaseUpdateInput;
  where: VariantReleaseWhereUniqueInput;
};

export type MutationUpsertActorArgs = {
  upsert: ActorUpsertInput;
  where: ActorWhereUniqueInput;
};

export type MutationUpsertActorVariantArgs = {
  upsert: ActorVariantUpsertInput;
  where: ActorVariantWhereUniqueInput;
};

export type MutationUpsertAnnouncementArgs = {
  upsert: AnnouncementUpsertInput;
  where: AnnouncementWhereUniqueInput;
};

export type MutationUpsertAssetArgs = {
  upsert: AssetUpsertInput;
  where: AssetWhereUniqueInput;
};

export type MutationUpsertAuth0RoleArgs = {
  upsert: Auth0RoleUpsertInput;
  where: Auth0RoleWhereUniqueInput;
};

export type MutationUpsertAvatarArgs = {
  upsert: AvatarUpsertInput;
  where: AvatarWhereUniqueInput;
};

export type MutationUpsertAvatarPoolArgs = {
  upsert: AvatarPoolUpsertInput;
  where: AvatarPoolWhereUniqueInput;
};

export type MutationUpsertAvatarTaggingAttributeArgs = {
  upsert: AvatarTaggingAttributeUpsertInput;
  where: AvatarTaggingAttributeWhereUniqueInput;
};

export type MutationUpsertAvatarVariantStyleArgs = {
  upsert: AvatarVariantStyleUpsertInput;
  where: AvatarVariantStyleWhereUniqueInput;
};

export type MutationUpsertContentTileArgs = {
  upsert: ContentTileUpsertInput;
  where: ContentTileWhereUniqueInput;
};

export type MutationUpsertTtsModelArgs = {
  upsert: TtsModelUpsertInput;
  where: TtsModelWhereUniqueInput;
};

export type MutationUpsertTtsModelFeatureArgs = {
  upsert: TtsModelFeatureUpsertInput;
  where: TtsModelFeatureWhereUniqueInput;
};

export type MutationUpsertVariantArgs = {
  upsert: VariantUpsertInput;
  where: VariantWhereUniqueInput;
};

export type MutationUpsertVariantReleaseArgs = {
  upsert: VariantReleaseUpsertInput;
  where: VariantReleaseWhereUniqueInput;
};

/** An object with an ID */
export type Node = {
  /** The id of the object. */
  id: Scalars['ID']['output'];
  /** The Stage of an object */
  stage: Stage;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Number of items in the current page. */
  pageSize?: Maybe<Scalars['Int']['output']>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** This enumeration is to be used by the API when determining which model to send requests to */
export enum PublicVersion {
  Caruso = 'caruso',
  Legacy = 'legacy',
  V9 = 'v9',
}

export type PublishLocaleInput = {
  /** Locales to publish */
  locale: Locale;
  /** Stages to publish selected locales to */
  stages: Array<Stage>;
};

export type Query = {
  __typename?: 'Query';
  /** Retrieve a single actor */
  actor?: Maybe<Actor>;
  /** Retrieve a single actorVariant */
  actorVariant?: Maybe<ActorVariant>;
  /** Retrieve document version */
  actorVariantVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple actorVariants */
  actorVariants: Array<ActorVariant>;
  /** Retrieve multiple actorVariants using the Relay connection interface */
  actorVariantsConnection: ActorVariantConnection;
  /** Retrieve document version */
  actorVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple actors */
  actors: Array<Actor>;
  /** Retrieve multiple actors using the Relay connection interface */
  actorsConnection: ActorConnection;
  /** Retrieve a single announcement */
  announcement?: Maybe<Announcement>;
  /** Retrieve document version */
  announcementVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple announcements */
  announcements: Array<Announcement>;
  /** Retrieve multiple announcements using the Relay connection interface */
  announcementsConnection: AnnouncementConnection;
  /** Retrieve a single asset */
  asset?: Maybe<Asset>;
  /** Retrieve document version */
  assetVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple assets */
  assets: Array<Asset>;
  /** Retrieve multiple assets using the Relay connection interface */
  assetsConnection: AssetConnection;
  /** Retrieve a single auth0Role */
  auth0Role?: Maybe<Auth0Role>;
  /** Retrieve document version */
  auth0RoleVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple auth0Roles */
  auth0Roles: Array<Auth0Role>;
  /** Retrieve multiple auth0Roles using the Relay connection interface */
  auth0RolesConnection: Auth0RoleConnection;
  /** Retrieve a single avatar */
  avatar?: Maybe<Avatar>;
  /** Retrieve a single avatarPool */
  avatarPool?: Maybe<AvatarPool>;
  /** Retrieve document version */
  avatarPoolVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple avatarPools */
  avatarPools: Array<AvatarPool>;
  /** Retrieve multiple avatarPools using the Relay connection interface */
  avatarPoolsConnection: AvatarPoolConnection;
  /** Retrieve a single avatarTaggingAttribute */
  avatarTaggingAttribute?: Maybe<AvatarTaggingAttribute>;
  /** Retrieve document version */
  avatarTaggingAttributeVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple avatarTaggingAttributes */
  avatarTaggingAttributes: Array<AvatarTaggingAttribute>;
  /** Retrieve multiple avatarTaggingAttributes using the Relay connection interface */
  avatarTaggingAttributesConnection: AvatarTaggingAttributeConnection;
  /** Retrieve a single avatarVariantStyle */
  avatarVariantStyle?: Maybe<AvatarVariantStyle>;
  /** Retrieve document version */
  avatarVariantStyleVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple avatarVariantStyles */
  avatarVariantStyles: Array<AvatarVariantStyle>;
  /** Retrieve multiple avatarVariantStyles using the Relay connection interface */
  avatarVariantStylesConnection: AvatarVariantStyleConnection;
  /** Retrieve document version */
  avatarVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple avatars */
  avatars: Array<Avatar>;
  /** Retrieve multiple avatars using the Relay connection interface */
  avatarsConnection: AvatarConnection;
  /** Retrieve a single contentTile */
  contentTile?: Maybe<ContentTile>;
  /** Retrieve document version */
  contentTileVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple contentTiles */
  contentTiles: Array<ContentTile>;
  /** Retrieve multiple contentTiles using the Relay connection interface */
  contentTilesConnection: ContentTileConnection;
  /** Fetches an object given its ID */
  entities?: Maybe<Array<Entity>>;
  /** Fetches an object given its ID */
  node?: Maybe<Node>;
  /** Retrieve a single scheduledOperation */
  scheduledOperation?: Maybe<ScheduledOperation>;
  /** Retrieve multiple scheduledOperations */
  scheduledOperations: Array<ScheduledOperation>;
  /** Retrieve multiple scheduledOperations using the Relay connection interface */
  scheduledOperationsConnection: ScheduledOperationConnection;
  /** Retrieve a single scheduledRelease */
  scheduledRelease?: Maybe<ScheduledRelease>;
  /** Retrieve multiple scheduledReleases */
  scheduledReleases: Array<ScheduledRelease>;
  /** Retrieve multiple scheduledReleases using the Relay connection interface */
  scheduledReleasesConnection: ScheduledReleaseConnection;
  /** Retrieve a single tTSModel */
  tTSModel?: Maybe<TtsModel>;
  /** Retrieve a single tTSModelFeature */
  tTSModelFeature?: Maybe<TtsModelFeature>;
  /** Retrieve document version */
  tTSModelFeatureVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple tTSModelFeatures */
  tTSModelFeatures: Array<TtsModelFeature>;
  /** Retrieve multiple tTSModelFeatures using the Relay connection interface */
  tTSModelFeaturesConnection: TtsModelFeatureConnection;
  /** Retrieve document version */
  tTSModelVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple tTSModels */
  tTSModels: Array<TtsModel>;
  /** Retrieve multiple tTSModels using the Relay connection interface */
  tTSModelsConnection: TtsModelConnection;
  /** Retrieve a single user */
  user?: Maybe<User>;
  /** Retrieve multiple users */
  users: Array<User>;
  /** Retrieve multiple users using the Relay connection interface */
  usersConnection: UserConnection;
  /** Retrieve a single variant */
  variant?: Maybe<Variant>;
  /** Retrieve a single variantRelease */
  variantRelease?: Maybe<VariantRelease>;
  /** Retrieve document version */
  variantReleaseVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple variantReleases */
  variantReleases: Array<VariantRelease>;
  /** Retrieve multiple variantReleases using the Relay connection interface */
  variantReleasesConnection: VariantReleaseConnection;
  /** Retrieve document version */
  variantVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple variants */
  variants: Array<Variant>;
  /** Retrieve multiple variants using the Relay connection interface */
  variantsConnection: VariantConnection;
};

export type QueryActorArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ActorWhereUniqueInput;
};

export type QueryActorVariantArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ActorVariantWhereUniqueInput;
};

export type QueryActorVariantVersionArgs = {
  where: VersionWhereInput;
};

export type QueryActorVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ActorVariantOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ActorVariantWhereInput>;
};

export type QueryActorVariantsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ActorVariantOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ActorVariantWhereInput>;
};

export type QueryActorVersionArgs = {
  where: VersionWhereInput;
};

export type QueryActorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ActorOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ActorWhereInput>;
};

export type QueryActorsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ActorOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ActorWhereInput>;
};

export type QueryAnnouncementArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AnnouncementWhereUniqueInput;
};

export type QueryAnnouncementVersionArgs = {
  where: VersionWhereInput;
};

export type QueryAnnouncementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AnnouncementOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AnnouncementWhereInput>;
};

export type QueryAnnouncementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AnnouncementOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AnnouncementWhereInput>;
};

export type QueryAssetArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AssetWhereUniqueInput;
};

export type QueryAssetVersionArgs = {
  where: VersionWhereInput;
};

export type QueryAssetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AssetWhereInput>;
};

export type QueryAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AssetWhereInput>;
};

export type QueryAuth0RoleArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: Auth0RoleWhereUniqueInput;
};

export type QueryAuth0RoleVersionArgs = {
  where: VersionWhereInput;
};

export type QueryAuth0RolesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<Auth0RoleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<Auth0RoleWhereInput>;
};

export type QueryAuth0RolesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<Auth0RoleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<Auth0RoleWhereInput>;
};

export type QueryAvatarArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AvatarWhereUniqueInput;
};

export type QueryAvatarPoolArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AvatarPoolWhereUniqueInput;
};

export type QueryAvatarPoolVersionArgs = {
  where: VersionWhereInput;
};

export type QueryAvatarPoolsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AvatarPoolOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AvatarPoolWhereInput>;
};

export type QueryAvatarPoolsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AvatarPoolOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AvatarPoolWhereInput>;
};

export type QueryAvatarTaggingAttributeArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AvatarTaggingAttributeWhereUniqueInput;
};

export type QueryAvatarTaggingAttributeVersionArgs = {
  where: VersionWhereInput;
};

export type QueryAvatarTaggingAttributesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AvatarTaggingAttributeOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AvatarTaggingAttributeWhereInput>;
};

export type QueryAvatarTaggingAttributesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AvatarTaggingAttributeOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AvatarTaggingAttributeWhereInput>;
};

export type QueryAvatarVariantStyleArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AvatarVariantStyleWhereUniqueInput;
};

export type QueryAvatarVariantStyleVersionArgs = {
  where: VersionWhereInput;
};

export type QueryAvatarVariantStylesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AvatarVariantStyleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AvatarVariantStyleWhereInput>;
};

export type QueryAvatarVariantStylesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AvatarVariantStyleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AvatarVariantStyleWhereInput>;
};

export type QueryAvatarVersionArgs = {
  where: VersionWhereInput;
};

export type QueryAvatarsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AvatarOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AvatarWhereInput>;
};

export type QueryAvatarsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AvatarOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AvatarWhereInput>;
};

export type QueryContentTileArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ContentTileWhereUniqueInput;
};

export type QueryContentTileVersionArgs = {
  where: VersionWhereInput;
};

export type QueryContentTilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ContentTileOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ContentTileWhereInput>;
};

export type QueryContentTilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ContentTileOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ContentTileWhereInput>;
};

export type QueryEntitiesArgs = {
  locales?: InputMaybe<Array<Locale>>;
  where: Array<EntityWhereInput>;
};

export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
  locales?: Array<Locale>;
  stage?: Stage;
};

export type QueryScheduledOperationArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ScheduledOperationWhereUniqueInput;
};

export type QueryScheduledOperationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type QueryScheduledOperationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type QueryScheduledReleaseArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ScheduledReleaseWhereUniqueInput;
};

export type QueryScheduledReleasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledReleaseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledReleaseWhereInput>;
};

export type QueryScheduledReleasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledReleaseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledReleaseWhereInput>;
};

export type QueryTTsModelArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: TtsModelWhereUniqueInput;
};

export type QueryTTsModelFeatureArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: TtsModelFeatureWhereUniqueInput;
};

export type QueryTTsModelFeatureVersionArgs = {
  where: VersionWhereInput;
};

export type QueryTTsModelFeaturesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TtsModelFeatureOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TtsModelFeatureWhereInput>;
};

export type QueryTTsModelFeaturesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TtsModelFeatureOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TtsModelFeatureWhereInput>;
};

export type QueryTTsModelVersionArgs = {
  where: VersionWhereInput;
};

export type QueryTTsModelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TtsModelOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TtsModelWhereInput>;
};

export type QueryTTsModelsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TtsModelOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TtsModelWhereInput>;
};

export type QueryUserArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: UserWhereUniqueInput;
};

export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<UserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<UserWhereInput>;
};

export type QueryUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<UserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<UserWhereInput>;
};

export type QueryVariantArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: VariantWhereUniqueInput;
};

export type QueryVariantReleaseArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: VariantReleaseWhereUniqueInput;
};

export type QueryVariantReleaseVersionArgs = {
  where: VersionWhereInput;
};

export type QueryVariantReleasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<VariantReleaseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<VariantReleaseWhereInput>;
};

export type QueryVariantReleasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<VariantReleaseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<VariantReleaseWhereInput>;
};

export type QueryVariantVersionArgs = {
  where: VersionWhereInput;
};

export type QueryVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<VariantOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<VariantWhereInput>;
};

export type QueryVariantsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<VariantOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<VariantWhereInput>;
};

/** Representing a RGBA color value: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba() */
export type Rgba = {
  __typename?: 'RGBA';
  a: Scalars['RGBATransparency']['output'];
  b: Scalars['RGBAHue']['output'];
  g: Scalars['RGBAHue']['output'];
  r: Scalars['RGBAHue']['output'];
};

/** Input type representing a RGBA color value: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba() */
export type RgbaInput = {
  a: Scalars['RGBATransparency']['input'];
  b: Scalars['RGBAHue']['input'];
  g: Scalars['RGBAHue']['input'];
  r: Scalars['RGBAHue']['input'];
};

/** Custom type representing a rich text value comprising of raw rich text ast, html, markdown and text values */
export type RichText = {
  __typename?: 'RichText';
  /** Returns HTMl representation */
  html: Scalars['String']['output'];
  /** Returns Markdown representation */
  markdown: Scalars['String']['output'];
  /** Returns AST representation */
  raw: Scalars['RichTextAST']['output'];
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output'];
};

/** Scheduled Operation system model */
export type ScheduledOperation = Entity &
  Node & {
    __typename?: 'ScheduledOperation';
    affectedDocuments: Array<ScheduledOperationAffectedDocument>;
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<User>;
    /** Operation description */
    description?: Maybe<Scalars['String']['output']>;
    /** Get the document in other stages */
    documentInStages: Array<ScheduledOperation>;
    /** Operation error message */
    errorMessage?: Maybe<Scalars['String']['output']>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<User>;
    /** Raw operation payload including all details, this field is subject to change */
    rawPayload: Scalars['Json']['output'];
    /** The release this operation is scheduled for */
    release?: Maybe<ScheduledRelease>;
    /** System stage field */
    stage: Stage;
    /** operation Status */
    status: ScheduledOperationStatus;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<User>;
  };

/** Scheduled Operation system model */
export type ScheduledOperationAffectedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

/** Scheduled Operation system model */
export type ScheduledOperationCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** Scheduled Operation system model */
export type ScheduledOperationDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

/** Scheduled Operation system model */
export type ScheduledOperationPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** Scheduled Operation system model */
export type ScheduledOperationReleaseArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** Scheduled Operation system model */
export type ScheduledOperationUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ScheduledOperationAffectedDocument =
  | Actor
  | ActorVariant
  | Announcement
  | Asset
  | Auth0Role
  | Avatar
  | AvatarPool
  | AvatarTaggingAttribute
  | AvatarVariantStyle
  | ContentTile
  | TtsModel
  | TtsModelFeature
  | Variant
  | VariantRelease;

export type ScheduledOperationConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ScheduledOperationWhereUniqueInput;
};

/** A connection to a list of items. */
export type ScheduledOperationConnection = {
  __typename?: 'ScheduledOperationConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ScheduledOperationEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ScheduledOperationCreateManyInlineInput = {
  /** Connect multiple existing ScheduledOperation documents */
  connect?: InputMaybe<Array<ScheduledOperationWhereUniqueInput>>;
};

export type ScheduledOperationCreateOneInlineInput = {
  /** Connect one existing ScheduledOperation document */
  connect?: InputMaybe<ScheduledOperationWhereUniqueInput>;
};

/** An edge in a connection. */
export type ScheduledOperationEdge = {
  __typename?: 'ScheduledOperationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ScheduledOperation;
};

/** Identifies documents */
export type ScheduledOperationManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** All values containing the given json path. */
  rawPayload_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  rawPayload_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  release?: InputMaybe<ScheduledReleaseWhereInput>;
  status?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ScheduledOperationOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  ErrorMessageAsc = 'errorMessage_ASC',
  ErrorMessageDesc = 'errorMessage_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

/** System Scheduled Operation Status */
export enum ScheduledOperationStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
}

export type ScheduledOperationUpdateManyInlineInput = {
  /** Connect multiple existing ScheduledOperation documents */
  connect?: InputMaybe<Array<ScheduledOperationConnectInput>>;
  /** Disconnect multiple ScheduledOperation documents */
  disconnect?: InputMaybe<Array<ScheduledOperationWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ScheduledOperation documents */
  set?: InputMaybe<Array<ScheduledOperationWhereUniqueInput>>;
};

export type ScheduledOperationUpdateOneInlineInput = {
  /** Connect existing ScheduledOperation document */
  connect?: InputMaybe<ScheduledOperationWhereUniqueInput>;
  /** Disconnect currently connected ScheduledOperation document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ScheduledOperationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** All values containing the given json path. */
  rawPayload_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  rawPayload_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  release?: InputMaybe<ScheduledReleaseWhereInput>;
  status?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** References ScheduledOperation record uniquely */
export type ScheduledOperationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Scheduled Release system model */
export type ScheduledRelease = Entity &
  Node & {
    __typename?: 'ScheduledRelease';
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<User>;
    /** Release description */
    description?: Maybe<Scalars['String']['output']>;
    /** Get the document in other stages */
    documentInStages: Array<ScheduledRelease>;
    /** Release error message */
    errorMessage?: Maybe<Scalars['String']['output']>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** Whether scheduled release should be run */
    isActive: Scalars['Boolean']['output'];
    /** Whether scheduled release is implicit */
    isImplicit: Scalars['Boolean']['output'];
    /** Operations to run with this release */
    operations: Array<ScheduledOperation>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<User>;
    /** Release date and time */
    releaseAt?: Maybe<Scalars['DateTime']['output']>;
    /** System stage field */
    stage: Stage;
    /** Release Status */
    status: ScheduledReleaseStatus;
    /** Release Title */
    title?: Maybe<Scalars['String']['output']>;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<User>;
  };

/** Scheduled Release system model */
export type ScheduledReleaseCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** Scheduled Release system model */
export type ScheduledReleaseDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

/** Scheduled Release system model */
export type ScheduledReleaseOperationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

/** Scheduled Release system model */
export type ScheduledReleasePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** Scheduled Release system model */
export type ScheduledReleaseUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ScheduledReleaseConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ScheduledReleaseWhereUniqueInput;
};

/** A connection to a list of items. */
export type ScheduledReleaseConnection = {
  __typename?: 'ScheduledReleaseConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ScheduledReleaseEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ScheduledReleaseCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ScheduledReleaseCreateManyInlineInput = {
  /** Connect multiple existing ScheduledRelease documents */
  connect?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Create and connect multiple existing ScheduledRelease documents */
  create?: InputMaybe<Array<ScheduledReleaseCreateInput>>;
};

export type ScheduledReleaseCreateOneInlineInput = {
  /** Connect one existing ScheduledRelease document */
  connect?: InputMaybe<ScheduledReleaseWhereUniqueInput>;
  /** Create and connect one ScheduledRelease document */
  create?: InputMaybe<ScheduledReleaseCreateInput>;
};

/** An edge in a connection. */
export type ScheduledReleaseEdge = {
  __typename?: 'ScheduledReleaseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ScheduledRelease;
};

/** Identifies documents */
export type ScheduledReleaseManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  isImplicit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isImplicit_not?: InputMaybe<Scalars['Boolean']['input']>;
  operations_every?: InputMaybe<ScheduledOperationWhereInput>;
  operations_none?: InputMaybe<ScheduledOperationWhereInput>;
  operations_some?: InputMaybe<ScheduledOperationWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  publishedBy?: InputMaybe<UserWhereInput>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  releaseAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  releaseAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  releaseAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  releaseAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  releaseAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  releaseAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  releaseAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  status?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ScheduledReleaseOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  ErrorMessageAsc = 'errorMessage_ASC',
  ErrorMessageDesc = 'errorMessage_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsActiveAsc = 'isActive_ASC',
  IsActiveDesc = 'isActive_DESC',
  IsImplicitAsc = 'isImplicit_ASC',
  IsImplicitDesc = 'isImplicit_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  ReleaseAtAsc = 'releaseAt_ASC',
  ReleaseAtDesc = 'releaseAt_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

/** System Scheduled Release Status */
export enum ScheduledReleaseStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
}

export type ScheduledReleaseUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduledReleaseUpdateManyInlineInput = {
  /** Connect multiple existing ScheduledRelease documents */
  connect?: InputMaybe<Array<ScheduledReleaseConnectInput>>;
  /** Create and connect multiple ScheduledRelease documents */
  create?: InputMaybe<Array<ScheduledReleaseCreateInput>>;
  /** Delete multiple ScheduledRelease documents */
  delete?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Disconnect multiple ScheduledRelease documents */
  disconnect?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ScheduledRelease documents */
  set?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Update multiple ScheduledRelease documents */
  update?: InputMaybe<Array<ScheduledReleaseUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ScheduledRelease documents */
  upsert?: InputMaybe<Array<ScheduledReleaseUpsertWithNestedWhereUniqueInput>>;
};

export type ScheduledReleaseUpdateManyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduledReleaseUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ScheduledReleaseUpdateManyInput;
  /** Document search */
  where: ScheduledReleaseWhereInput;
};

export type ScheduledReleaseUpdateOneInlineInput = {
  /** Connect existing ScheduledRelease document */
  connect?: InputMaybe<ScheduledReleaseWhereUniqueInput>;
  /** Create and connect one ScheduledRelease document */
  create?: InputMaybe<ScheduledReleaseCreateInput>;
  /** Delete currently connected ScheduledRelease document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ScheduledRelease document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ScheduledRelease document */
  update?: InputMaybe<ScheduledReleaseUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ScheduledRelease document */
  upsert?: InputMaybe<ScheduledReleaseUpsertWithNestedWhereUniqueInput>;
};

export type ScheduledReleaseUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ScheduledReleaseUpdateInput;
  /** Unique document search */
  where: ScheduledReleaseWhereUniqueInput;
};

export type ScheduledReleaseUpsertInput = {
  /** Create document if it didn't exist */
  create: ScheduledReleaseCreateInput;
  /** Update document if it exists */
  update: ScheduledReleaseUpdateInput;
};

export type ScheduledReleaseUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ScheduledReleaseUpsertInput;
  /** Unique document search */
  where: ScheduledReleaseWhereUniqueInput;
};

/** Identifies documents */
export type ScheduledReleaseWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  isImplicit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isImplicit_not?: InputMaybe<Scalars['Boolean']['input']>;
  operations_every?: InputMaybe<ScheduledOperationWhereInput>;
  operations_none?: InputMaybe<ScheduledOperationWhereInput>;
  operations_some?: InputMaybe<ScheduledOperationWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  publishedBy?: InputMaybe<UserWhereInput>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  releaseAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  releaseAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  releaseAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  releaseAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  releaseAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  releaseAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  releaseAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  status?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** References ScheduledRelease record uniquely */
export type ScheduledReleaseWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Stage system enumeration */
export enum Stage {
  /** The Draft is the default stage for all your content. */
  Draft = 'DRAFT',
  /** The Published stage is where you can publish your content to. */
  Published = 'PUBLISHED',
}

/** The studio/editor project version */
export enum StudioProjectVersion {
  AzureArabic = 'azure_arabic',
  AzureChinese = 'azure_chinese',
  AzureCzech = 'azure_czech',
  AzureDanish = 'azure_danish',
  AzureDutch = 'azure_dutch',
  AzureFrench = 'azure_french',
  AzureGerman = 'azure_german',
  AzureItalian = 'azure_italian',
  AzureJapanese = 'azure_japanese',
  AzureKorean = 'azure_korean',
  AzurePersian = 'azure_persian',
  AzurePolish = 'azure_polish',
  AzurePortuguese = 'azure_portuguese',
  AzureSpanish = 'azure_spanish',
  AzureSwedish = 'azure_swedish',
  AzureTurkish = 'azure_turkish',
  Legacy = 'legacy',
  Universal = 'universal',
  V2 = 'v2',
}

/** The conversational tone of a voice. */
export enum Style {
  Character = 'Character',
  Conversational = 'Conversational',
  Custom = 'Custom',
  CustomV2 = 'CustomV2',
  Narration = 'Narration',
  Promo = 'Promo',
}

/** The subscription type of users */
export enum SubscriptionType {
  Creative = 'Creative',
  Designer = 'Designer',
  DesignerTrial = 'DesignerTrial',
  Enterprise = 'Enterprise',
  Maker = 'Maker',
  Producer = 'Producer',
  Team = 'Team',
  Trial = 'Trial',
  WslAdmin = 'WSLAdmin',
}

export enum SystemDateTimeFieldVariation {
  Base = 'BASE',
  Combined = 'COMBINED',
  Localization = 'LOCALIZATION',
}

/** An identifier for a text to speech data model tagged with version name and description. */
export type TtsModel = Entity &
  Node & {
    __typename?: 'TTSModel';
    /** allows api customers to select model */
    apiModelSelection?: Maybe<PublicVersion>;
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<User>;
    /** A human readable description of what this model features. */
    description?: Maybe<Scalars['String']['output']>;
    /** Get the document in other stages */
    documentInStages: Array<TtsModel>;
    features: Array<TtsModelFeature>;
    /** List of TTSModel versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** the name of a data model */
    name?: Maybe<Scalars['String']['output']>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<User>;
    scheduledIn: Array<ScheduledOperation>;
    /** System stage field */
    stage: Stage;
    studioProjectVersion?: Maybe<StudioProjectVersion>;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<User>;
  };

/** An identifier for a text to speech data model tagged with version name and description. */
export type TtsModelCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** An identifier for a text to speech data model tagged with version name and description. */
export type TtsModelDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

/** An identifier for a text to speech data model tagged with version name and description. */
export type TtsModelFeaturesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TtsModelFeatureOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TtsModelFeatureWhereInput>;
};

/** An identifier for a text to speech data model tagged with version name and description. */
export type TtsModelHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

/** An identifier for a text to speech data model tagged with version name and description. */
export type TtsModelPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** An identifier for a text to speech data model tagged with version name and description. */
export type TtsModelScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

/** An identifier for a text to speech data model tagged with version name and description. */
export type TtsModelUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type TtsModelConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TtsModelWhereUniqueInput;
};

/** A connection to a list of items. */
export type TtsModelConnection = {
  __typename?: 'TTSModelConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TtsModelEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TtsModelCreateInput = {
  apiModelSelection?: InputMaybe<PublicVersion>;
  cl3d95tya1wuv01zd03rl3wai?: InputMaybe<VariantReleaseCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<TtsModelFeatureCreateManyInlineInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  studioProjectVersion?: InputMaybe<StudioProjectVersion>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TtsModelCreateManyInlineInput = {
  /** Connect multiple existing TTSModel documents */
  connect?: InputMaybe<Array<TtsModelWhereUniqueInput>>;
  /** Create and connect multiple existing TTSModel documents */
  create?: InputMaybe<Array<TtsModelCreateInput>>;
};

export type TtsModelCreateOneInlineInput = {
  /** Connect one existing TTSModel document */
  connect?: InputMaybe<TtsModelWhereUniqueInput>;
  /** Create and connect one TTSModel document */
  create?: InputMaybe<TtsModelCreateInput>;
};

/** An edge in a connection. */
export type TtsModelEdge = {
  __typename?: 'TTSModelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TtsModel;
};

export type TtsModelFeature = Entity &
  Node & {
    __typename?: 'TTSModelFeature';
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<User>;
    /** Get the document in other stages */
    documentInStages: Array<TtsModelFeature>;
    feature: TtsCapability;
    /** List of TTSModelFeature versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<User>;
    scheduledIn: Array<ScheduledOperation>;
    /** System stage field */
    stage: Stage;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<User>;
    version: TtsCapabilityVersion;
  };

export type TtsModelFeatureCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type TtsModelFeatureDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type TtsModelFeatureHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type TtsModelFeaturePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type TtsModelFeatureScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type TtsModelFeatureUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type TtsModelFeatureConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TtsModelFeatureWhereUniqueInput;
};

/** A connection to a list of items. */
export type TtsModelFeatureConnection = {
  __typename?: 'TTSModelFeatureConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TtsModelFeatureEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TtsModelFeatureCreateInput = {
  clbbde1j40vcm01t7euatef3b?: InputMaybe<TtsModelCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  feature: TtsCapability;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  version: TtsCapabilityVersion;
};

export type TtsModelFeatureCreateManyInlineInput = {
  /** Connect multiple existing TTSModelFeature documents */
  connect?: InputMaybe<Array<TtsModelFeatureWhereUniqueInput>>;
  /** Create and connect multiple existing TTSModelFeature documents */
  create?: InputMaybe<Array<TtsModelFeatureCreateInput>>;
};

export type TtsModelFeatureCreateOneInlineInput = {
  /** Connect one existing TTSModelFeature document */
  connect?: InputMaybe<TtsModelFeatureWhereUniqueInput>;
  /** Create and connect one TTSModelFeature document */
  create?: InputMaybe<TtsModelFeatureCreateInput>;
};

/** An edge in a connection. */
export type TtsModelFeatureEdge = {
  __typename?: 'TTSModelFeatureEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TtsModelFeature;
};

/** Identifies documents */
export type TtsModelFeatureManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TtsModelFeatureWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TtsModelFeatureWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TtsModelFeatureWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TtsModelFeatureWhereStageInput>;
  documentInStages_none?: InputMaybe<TtsModelFeatureWhereStageInput>;
  documentInStages_some?: InputMaybe<TtsModelFeatureWhereStageInput>;
  feature?: InputMaybe<TtsCapability>;
  /** All values that are contained in given list. */
  feature_in?: InputMaybe<Array<InputMaybe<TtsCapability>>>;
  /** Any other value that exists and is not equal to the given value. */
  feature_not?: InputMaybe<TtsCapability>;
  /** All values that are not contained in given list. */
  feature_not_in?: InputMaybe<Array<InputMaybe<TtsCapability>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  updatedBy?: InputMaybe<UserWhereInput>;
  version?: InputMaybe<TtsCapabilityVersion>;
  /** All values that are contained in given list. */
  version_in?: InputMaybe<Array<InputMaybe<TtsCapabilityVersion>>>;
  /** Any other value that exists and is not equal to the given value. */
  version_not?: InputMaybe<TtsCapabilityVersion>;
  /** All values that are not contained in given list. */
  version_not_in?: InputMaybe<Array<InputMaybe<TtsCapabilityVersion>>>;
};

export enum TtsModelFeatureOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  FeatureAsc = 'feature_ASC',
  FeatureDesc = 'feature_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  VersionAsc = 'version_ASC',
  VersionDesc = 'version_DESC',
}

export type TtsModelFeatureUpdateInput = {
  clbbde1j40vcm01t7euatef3b?: InputMaybe<TtsModelUpdateManyInlineInput>;
  feature?: InputMaybe<TtsCapability>;
  version?: InputMaybe<TtsCapabilityVersion>;
};

export type TtsModelFeatureUpdateManyInlineInput = {
  /** Connect multiple existing TTSModelFeature documents */
  connect?: InputMaybe<Array<TtsModelFeatureConnectInput>>;
  /** Create and connect multiple TTSModelFeature documents */
  create?: InputMaybe<Array<TtsModelFeatureCreateInput>>;
  /** Delete multiple TTSModelFeature documents */
  delete?: InputMaybe<Array<TtsModelFeatureWhereUniqueInput>>;
  /** Disconnect multiple TTSModelFeature documents */
  disconnect?: InputMaybe<Array<TtsModelFeatureWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing TTSModelFeature documents */
  set?: InputMaybe<Array<TtsModelFeatureWhereUniqueInput>>;
  /** Update multiple TTSModelFeature documents */
  update?: InputMaybe<Array<TtsModelFeatureUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple TTSModelFeature documents */
  upsert?: InputMaybe<Array<TtsModelFeatureUpsertWithNestedWhereUniqueInput>>;
};

export type TtsModelFeatureUpdateManyInput = {
  feature?: InputMaybe<TtsCapability>;
  version?: InputMaybe<TtsCapabilityVersion>;
};

export type TtsModelFeatureUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TtsModelFeatureUpdateManyInput;
  /** Document search */
  where: TtsModelFeatureWhereInput;
};

export type TtsModelFeatureUpdateOneInlineInput = {
  /** Connect existing TTSModelFeature document */
  connect?: InputMaybe<TtsModelFeatureWhereUniqueInput>;
  /** Create and connect one TTSModelFeature document */
  create?: InputMaybe<TtsModelFeatureCreateInput>;
  /** Delete currently connected TTSModelFeature document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected TTSModelFeature document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single TTSModelFeature document */
  update?: InputMaybe<TtsModelFeatureUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TTSModelFeature document */
  upsert?: InputMaybe<TtsModelFeatureUpsertWithNestedWhereUniqueInput>;
};

export type TtsModelFeatureUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TtsModelFeatureUpdateInput;
  /** Unique document search */
  where: TtsModelFeatureWhereUniqueInput;
};

export type TtsModelFeatureUpsertInput = {
  /** Create document if it didn't exist */
  create: TtsModelFeatureCreateInput;
  /** Update document if it exists */
  update: TtsModelFeatureUpdateInput;
};

export type TtsModelFeatureUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TtsModelFeatureUpsertInput;
  /** Unique document search */
  where: TtsModelFeatureWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type TtsModelFeatureWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type TtsModelFeatureWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TtsModelFeatureWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TtsModelFeatureWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TtsModelFeatureWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TtsModelFeatureWhereStageInput>;
  documentInStages_none?: InputMaybe<TtsModelFeatureWhereStageInput>;
  documentInStages_some?: InputMaybe<TtsModelFeatureWhereStageInput>;
  feature?: InputMaybe<TtsCapability>;
  /** All values that are contained in given list. */
  feature_in?: InputMaybe<Array<InputMaybe<TtsCapability>>>;
  /** Any other value that exists and is not equal to the given value. */
  feature_not?: InputMaybe<TtsCapability>;
  /** All values that are not contained in given list. */
  feature_not_in?: InputMaybe<Array<InputMaybe<TtsCapability>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  updatedBy?: InputMaybe<UserWhereInput>;
  version?: InputMaybe<TtsCapabilityVersion>;
  /** All values that are contained in given list. */
  version_in?: InputMaybe<Array<InputMaybe<TtsCapabilityVersion>>>;
  /** Any other value that exists and is not equal to the given value. */
  version_not?: InputMaybe<TtsCapabilityVersion>;
  /** All values that are not contained in given list. */
  version_not_in?: InputMaybe<Array<InputMaybe<TtsCapabilityVersion>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type TtsModelFeatureWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TtsModelFeatureWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TtsModelFeatureWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TtsModelFeatureWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<TtsModelFeatureWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References TTSModelFeature record uniquely */
export type TtsModelFeatureWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Identifies documents */
export type TtsModelManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TtsModelWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TtsModelWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TtsModelWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  apiModelSelection?: InputMaybe<PublicVersion>;
  /** All values that are contained in given list. */
  apiModelSelection_in?: InputMaybe<Array<InputMaybe<PublicVersion>>>;
  /** Any other value that exists and is not equal to the given value. */
  apiModelSelection_not?: InputMaybe<PublicVersion>;
  /** All values that are not contained in given list. */
  apiModelSelection_not_in?: InputMaybe<Array<InputMaybe<PublicVersion>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<TtsModelWhereStageInput>;
  documentInStages_none?: InputMaybe<TtsModelWhereStageInput>;
  documentInStages_some?: InputMaybe<TtsModelWhereStageInput>;
  features_every?: InputMaybe<TtsModelFeatureWhereInput>;
  features_none?: InputMaybe<TtsModelFeatureWhereInput>;
  features_some?: InputMaybe<TtsModelFeatureWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  studioProjectVersion?: InputMaybe<StudioProjectVersion>;
  /** All values that are contained in given list. */
  studioProjectVersion_in?: InputMaybe<Array<InputMaybe<StudioProjectVersion>>>;
  /** Any other value that exists and is not equal to the given value. */
  studioProjectVersion_not?: InputMaybe<StudioProjectVersion>;
  /** All values that are not contained in given list. */
  studioProjectVersion_not_in?: InputMaybe<
    Array<InputMaybe<StudioProjectVersion>>
  >;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum TtsModelOrderByInput {
  ApiModelSelectionAsc = 'apiModelSelection_ASC',
  ApiModelSelectionDesc = 'apiModelSelection_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  StudioProjectVersionAsc = 'studioProjectVersion_ASC',
  StudioProjectVersionDesc = 'studioProjectVersion_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type TtsModelUpdateInput = {
  apiModelSelection?: InputMaybe<PublicVersion>;
  cl3d95tya1wuv01zd03rl3wai?: InputMaybe<VariantReleaseUpdateManyInlineInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<TtsModelFeatureUpdateManyInlineInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  studioProjectVersion?: InputMaybe<StudioProjectVersion>;
};

export type TtsModelUpdateManyInlineInput = {
  /** Connect multiple existing TTSModel documents */
  connect?: InputMaybe<Array<TtsModelConnectInput>>;
  /** Create and connect multiple TTSModel documents */
  create?: InputMaybe<Array<TtsModelCreateInput>>;
  /** Delete multiple TTSModel documents */
  delete?: InputMaybe<Array<TtsModelWhereUniqueInput>>;
  /** Disconnect multiple TTSModel documents */
  disconnect?: InputMaybe<Array<TtsModelWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing TTSModel documents */
  set?: InputMaybe<Array<TtsModelWhereUniqueInput>>;
  /** Update multiple TTSModel documents */
  update?: InputMaybe<Array<TtsModelUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple TTSModel documents */
  upsert?: InputMaybe<Array<TtsModelUpsertWithNestedWhereUniqueInput>>;
};

export type TtsModelUpdateManyInput = {
  apiModelSelection?: InputMaybe<PublicVersion>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  studioProjectVersion?: InputMaybe<StudioProjectVersion>;
};

export type TtsModelUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TtsModelUpdateManyInput;
  /** Document search */
  where: TtsModelWhereInput;
};

export type TtsModelUpdateOneInlineInput = {
  /** Connect existing TTSModel document */
  connect?: InputMaybe<TtsModelWhereUniqueInput>;
  /** Create and connect one TTSModel document */
  create?: InputMaybe<TtsModelCreateInput>;
  /** Delete currently connected TTSModel document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected TTSModel document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single TTSModel document */
  update?: InputMaybe<TtsModelUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TTSModel document */
  upsert?: InputMaybe<TtsModelUpsertWithNestedWhereUniqueInput>;
};

export type TtsModelUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TtsModelUpdateInput;
  /** Unique document search */
  where: TtsModelWhereUniqueInput;
};

export type TtsModelUpsertInput = {
  /** Create document if it didn't exist */
  create: TtsModelCreateInput;
  /** Update document if it exists */
  update: TtsModelUpdateInput;
};

export type TtsModelUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TtsModelUpsertInput;
  /** Unique document search */
  where: TtsModelWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type TtsModelWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type TtsModelWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TtsModelWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TtsModelWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TtsModelWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  apiModelSelection?: InputMaybe<PublicVersion>;
  /** All values that are contained in given list. */
  apiModelSelection_in?: InputMaybe<Array<InputMaybe<PublicVersion>>>;
  /** Any other value that exists and is not equal to the given value. */
  apiModelSelection_not?: InputMaybe<PublicVersion>;
  /** All values that are not contained in given list. */
  apiModelSelection_not_in?: InputMaybe<Array<InputMaybe<PublicVersion>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<TtsModelWhereStageInput>;
  documentInStages_none?: InputMaybe<TtsModelWhereStageInput>;
  documentInStages_some?: InputMaybe<TtsModelWhereStageInput>;
  features_every?: InputMaybe<TtsModelFeatureWhereInput>;
  features_none?: InputMaybe<TtsModelFeatureWhereInput>;
  features_some?: InputMaybe<TtsModelFeatureWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  studioProjectVersion?: InputMaybe<StudioProjectVersion>;
  /** All values that are contained in given list. */
  studioProjectVersion_in?: InputMaybe<Array<InputMaybe<StudioProjectVersion>>>;
  /** Any other value that exists and is not equal to the given value. */
  studioProjectVersion_not?: InputMaybe<StudioProjectVersion>;
  /** All values that are not contained in given list. */
  studioProjectVersion_not_in?: InputMaybe<
    Array<InputMaybe<StudioProjectVersion>>
  >;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type TtsModelWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TtsModelWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TtsModelWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TtsModelWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<TtsModelWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References TTSModel record uniquely */
export type TtsModelWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum TtsCapability {
  Loudness = 'loudness',
  Pitch = 'pitch',
  Respell = 'respell',
  Tempo = 'tempo',
}

export enum TtsCapabilityVersion {
  V1 = 'v1',
}

export type UnpublishLocaleInput = {
  /** Locales to unpublish */
  locale: Locale;
  /** Stages to unpublish selected locales from */
  stages: Array<Stage>;
};

/** User system model */
export type User = Entity &
  Node & {
    __typename?: 'User';
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** Get the document in other stages */
    documentInStages: Array<User>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** Flag to determine if user is active or not */
    isActive: Scalars['Boolean']['output'];
    /** User Kind. Can be either MEMBER, PAT or PUBLIC */
    kind: UserKind;
    /** The username */
    name: Scalars['String']['output'];
    /** Profile Picture url */
    picture?: Maybe<Scalars['String']['output']>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** System stage field */
    stage: Stage;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
  };

/** User system model */
export type UserDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type UserConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: UserWhereUniqueInput;
};

/** A connection to a list of items. */
export type UserConnection = {
  __typename?: 'UserConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<UserEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type UserCreateManyInlineInput = {
  /** Connect multiple existing User documents */
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
};

export type UserCreateOneInlineInput = {
  /** Connect one existing User document */
  connect?: InputMaybe<UserWhereUniqueInput>;
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: User;
};

/** System User Kind */
export enum UserKind {
  Member = 'MEMBER',
  Pat = 'PAT',
  Public = 'PUBLIC',
  Webhook = 'WEBHOOK',
}

/** Identifies documents */
export type UserManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  documentInStages_every?: InputMaybe<UserWhereStageInput>;
  documentInStages_none?: InputMaybe<UserWhereStageInput>;
  documentInStages_some?: InputMaybe<UserWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<UserKind>;
  /** All values that are contained in given list. */
  kind_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  /** Any other value that exists and is not equal to the given value. */
  kind_not?: InputMaybe<UserKind>;
  /** All values that are not contained in given list. */
  kind_not_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  picture_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  picture_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  picture_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  picture_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  picture_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  picture_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  picture_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  picture_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  picture_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
};

export enum UserOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsActiveAsc = 'isActive_ASC',
  IsActiveDesc = 'isActive_DESC',
  KindAsc = 'kind_ASC',
  KindDesc = 'kind_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PictureAsc = 'picture_ASC',
  PictureDesc = 'picture_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type UserUpdateManyInlineInput = {
  /** Connect multiple existing User documents */
  connect?: InputMaybe<Array<UserConnectInput>>;
  /** Disconnect multiple User documents */
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing User documents */
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
};

export type UserUpdateOneInlineInput = {
  /** Connect existing User document */
  connect?: InputMaybe<UserWhereUniqueInput>;
  /** Disconnect currently connected User document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

/** This contains a set of filters that can be used to compare values internally */
export type UserWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type UserWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  documentInStages_every?: InputMaybe<UserWhereStageInput>;
  documentInStages_none?: InputMaybe<UserWhereStageInput>;
  documentInStages_some?: InputMaybe<UserWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<UserKind>;
  /** All values that are contained in given list. */
  kind_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  /** Any other value that exists and is not equal to the given value. */
  kind_not?: InputMaybe<UserKind>;
  /** All values that are not contained in given list. */
  kind_not_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  picture_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  picture_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  picture_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  picture_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  picture_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  picture_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  picture_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  picture_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  picture_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type UserWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<UserWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References User record uniquely */
export type UserWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * The variants of an avatar (IE avatar + locale + style)
 *
 * IE: Ramona J Narration US
 */
export type Variant = Entity &
  Node & {
    __typename?: 'Variant';
    /** A reference to get access to the avatar through the variant */
    avatar?: Maybe<Avatar>;
    /** Variant ID, per the TTS Engine. Permanent, unique. Custom voice variant ids should be 8 digits long. */
    avatarVariantId: Scalars['Int']['output'];
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<User>;
    /** Get the document in other stages */
    documentInStages: Array<Variant>;
    /** List of Variant versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** A true/false value which marks this variant as archived (accessible in the studio or not) */
    isArchived: Scalars['Boolean']['output'];
    /** arbitrary human readable label for variant in studio (specifically used for custom voices) */
    label?: Maybe<Scalars['String']['output']>;
    /** Where the locale of a voice is US, UK, etc. */
    localeEnum?: Maybe<LocaleEnum>;
    /** Locale for voice standardized to include language */
    localeEnum_V2: LocaleEnum_V2;
    preview?: Maybe<Asset>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<User>;
    /**
     * The releases associated with a variant:
     *
     * It is a composite of version, model, and variants associated (v9 beta, v8 latest) etc
     *
     */
    releases: Array<VariantRelease>;
    scheduledIn: Array<ScheduledOperation>;
    /** System stage field */
    stage: Stage;
    style?: Maybe<AvatarVariantStyle>;
    /** Tags associated with the avatar variant */
    tags: Array<AvatarTaggingAttribute>;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<User>;
  };

/**
 * The variants of an avatar (IE avatar + locale + style)
 *
 * IE: Ramona J Narration US
 */
export type VariantAvatarArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/**
 * The variants of an avatar (IE avatar + locale + style)
 *
 * IE: Ramona J Narration US
 */
export type VariantCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/**
 * The variants of an avatar (IE avatar + locale + style)
 *
 * IE: Ramona J Narration US
 */
export type VariantDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

/**
 * The variants of an avatar (IE avatar + locale + style)
 *
 * IE: Ramona J Narration US
 */
export type VariantHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

/**
 * The variants of an avatar (IE avatar + locale + style)
 *
 * IE: Ramona J Narration US
 */
export type VariantPreviewArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

/**
 * The variants of an avatar (IE avatar + locale + style)
 *
 * IE: Ramona J Narration US
 */
export type VariantPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/**
 * The variants of an avatar (IE avatar + locale + style)
 *
 * IE: Ramona J Narration US
 */
export type VariantReleasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<VariantReleaseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VariantReleaseWhereInput>;
};

/**
 * The variants of an avatar (IE avatar + locale + style)
 *
 * IE: Ramona J Narration US
 */
export type VariantScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

/**
 * The variants of an avatar (IE avatar + locale + style)
 *
 * IE: Ramona J Narration US
 */
export type VariantStyleArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/**
 * The variants of an avatar (IE avatar + locale + style)
 *
 * IE: Ramona J Narration US
 */
export type VariantTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AvatarTaggingAttributeOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AvatarTaggingAttributeWhereInput>;
};

/**
 * The variants of an avatar (IE avatar + locale + style)
 *
 * IE: Ramona J Narration US
 */
export type VariantUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type VariantConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: VariantWhereUniqueInput;
};

/** A connection to a list of items. */
export type VariantConnection = {
  __typename?: 'VariantConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<VariantEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type VariantCreateInput = {
  avatar?: InputMaybe<AvatarCreateOneInlineInput>;
  avatarVariantId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  isArchived: Scalars['Boolean']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  localeEnum?: InputMaybe<LocaleEnum>;
  localeEnum_V2: LocaleEnum_V2;
  preview?: InputMaybe<AssetCreateOneInlineInput>;
  releases?: InputMaybe<VariantReleaseCreateManyInlineInput>;
  style?: InputMaybe<AvatarVariantStyleCreateOneInlineInput>;
  tags?: InputMaybe<AvatarTaggingAttributeCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type VariantCreateManyInlineInput = {
  /** Connect multiple existing Variant documents */
  connect?: InputMaybe<Array<VariantWhereUniqueInput>>;
  /** Create and connect multiple existing Variant documents */
  create?: InputMaybe<Array<VariantCreateInput>>;
};

export type VariantCreateOneInlineInput = {
  /** Connect one existing Variant document */
  connect?: InputMaybe<VariantWhereUniqueInput>;
  /** Create and connect one Variant document */
  create?: InputMaybe<VariantCreateInput>;
};

/** An edge in a connection. */
export type VariantEdge = {
  __typename?: 'VariantEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Variant;
};

/** Identifies documents */
export type VariantManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VariantWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VariantWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VariantWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<AvatarWhereInput>;
  avatarVariantId?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  avatarVariantId_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  avatarVariantId_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  avatarVariantId_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  avatarVariantId_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  avatarVariantId_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  avatarVariantId_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  avatarVariantId_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['Int']['input']>>
  >;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<VariantWhereStageInput>;
  documentInStages_none?: InputMaybe<VariantWhereStageInput>;
  documentInStages_some?: InputMaybe<VariantWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isArchived_not?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  localeEnum?: InputMaybe<LocaleEnum>;
  localeEnum_V2?: InputMaybe<LocaleEnum_V2>;
  /** All values that are contained in given list. */
  localeEnum_V2_in?: InputMaybe<Array<InputMaybe<LocaleEnum_V2>>>;
  /** Any other value that exists and is not equal to the given value. */
  localeEnum_V2_not?: InputMaybe<LocaleEnum_V2>;
  /** All values that are not contained in given list. */
  localeEnum_V2_not_in?: InputMaybe<Array<InputMaybe<LocaleEnum_V2>>>;
  /** All values that are contained in given list. */
  localeEnum_in?: InputMaybe<Array<InputMaybe<LocaleEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  localeEnum_not?: InputMaybe<LocaleEnum>;
  /** All values that are not contained in given list. */
  localeEnum_not_in?: InputMaybe<Array<InputMaybe<LocaleEnum>>>;
  preview?: InputMaybe<AssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  publishedBy?: InputMaybe<UserWhereInput>;
  releases_every?: InputMaybe<VariantReleaseWhereInput>;
  releases_none?: InputMaybe<VariantReleaseWhereInput>;
  releases_some?: InputMaybe<VariantReleaseWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  style?: InputMaybe<AvatarVariantStyleWhereInput>;
  tags_every?: InputMaybe<AvatarTaggingAttributeWhereInput>;
  tags_none?: InputMaybe<AvatarTaggingAttributeWhereInput>;
  tags_some?: InputMaybe<AvatarTaggingAttributeWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum VariantOrderByInput {
  AvatarVariantIdAsc = 'avatarVariantId_ASC',
  AvatarVariantIdDesc = 'avatarVariantId_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsArchivedAsc = 'isArchived_ASC',
  IsArchivedDesc = 'isArchived_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LocaleEnumAsc = 'localeEnum_ASC',
  LocaleEnumDesc = 'localeEnum_DESC',
  LocaleEnumV2Asc = 'localeEnum_V2_ASC',
  LocaleEnumV2Desc = 'localeEnum_V2_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

/** The releases associated with a variant: It is a composite of version, model, and variants associated (v9 beta, v8 latest) etc */
export type VariantRelease = Entity &
  Node & {
    __typename?: 'VariantRelease';
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<User>;
    /** Get the document in other stages */
    documentInStages: Array<VariantRelease>;
    /** List of VariantRelease versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** This is the model selected by the customer when interacting with an Avatar ID  */
    publicFacingModel?: Maybe<PublicVersion>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<User>;
    scheduledIn: Array<ScheduledOperation>;
    /** System stage field */
    stage: Stage;
    /** The data model with identifier and description. */
    ttsModel?: Maybe<TtsModel>;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<User>;
    /** The variants associated with a release. */
    variants: Array<Variant>;
    /** version of a release (IE beta) */
    version?: Maybe<AvatarReleaseVersion>;
  };

/** The releases associated with a variant: It is a composite of version, model, and variants associated (v9 beta, v8 latest) etc */
export type VariantReleaseCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** The releases associated with a variant: It is a composite of version, model, and variants associated (v9 beta, v8 latest) etc */
export type VariantReleaseDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

/** The releases associated with a variant: It is a composite of version, model, and variants associated (v9 beta, v8 latest) etc */
export type VariantReleaseHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

/** The releases associated with a variant: It is a composite of version, model, and variants associated (v9 beta, v8 latest) etc */
export type VariantReleasePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** The releases associated with a variant: It is a composite of version, model, and variants associated (v9 beta, v8 latest) etc */
export type VariantReleaseScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

/** The releases associated with a variant: It is a composite of version, model, and variants associated (v9 beta, v8 latest) etc */
export type VariantReleaseTtsModelArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** The releases associated with a variant: It is a composite of version, model, and variants associated (v9 beta, v8 latest) etc */
export type VariantReleaseUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** The releases associated with a variant: It is a composite of version, model, and variants associated (v9 beta, v8 latest) etc */
export type VariantReleaseVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<VariantOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VariantWhereInput>;
};

export type VariantReleaseConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: VariantReleaseWhereUniqueInput;
};

/** A connection to a list of items. */
export type VariantReleaseConnection = {
  __typename?: 'VariantReleaseConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<VariantReleaseEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type VariantReleaseCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  publicFacingModel?: InputMaybe<PublicVersion>;
  ttsModel?: InputMaybe<TtsModelCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  variants?: InputMaybe<VariantCreateManyInlineInput>;
  version?: InputMaybe<AvatarReleaseVersion>;
};

export type VariantReleaseCreateManyInlineInput = {
  /** Connect multiple existing VariantRelease documents */
  connect?: InputMaybe<Array<VariantReleaseWhereUniqueInput>>;
  /** Create and connect multiple existing VariantRelease documents */
  create?: InputMaybe<Array<VariantReleaseCreateInput>>;
};

export type VariantReleaseCreateOneInlineInput = {
  /** Connect one existing VariantRelease document */
  connect?: InputMaybe<VariantReleaseWhereUniqueInput>;
  /** Create and connect one VariantRelease document */
  create?: InputMaybe<VariantReleaseCreateInput>;
};

/** An edge in a connection. */
export type VariantReleaseEdge = {
  __typename?: 'VariantReleaseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: VariantRelease;
};

/** Identifies documents */
export type VariantReleaseManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VariantReleaseWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VariantReleaseWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VariantReleaseWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<VariantReleaseWhereStageInput>;
  documentInStages_none?: InputMaybe<VariantReleaseWhereStageInput>;
  documentInStages_some?: InputMaybe<VariantReleaseWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publicFacingModel?: InputMaybe<PublicVersion>;
  /** All values that are contained in given list. */
  publicFacingModel_in?: InputMaybe<Array<InputMaybe<PublicVersion>>>;
  /** Any other value that exists and is not equal to the given value. */
  publicFacingModel_not?: InputMaybe<PublicVersion>;
  /** All values that are not contained in given list. */
  publicFacingModel_not_in?: InputMaybe<Array<InputMaybe<PublicVersion>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  ttsModel?: InputMaybe<TtsModelWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  updatedBy?: InputMaybe<UserWhereInput>;
  variants_every?: InputMaybe<VariantWhereInput>;
  variants_none?: InputMaybe<VariantWhereInput>;
  variants_some?: InputMaybe<VariantWhereInput>;
  version?: InputMaybe<AvatarReleaseVersion>;
  /** All values that are contained in given list. */
  version_in?: InputMaybe<Array<InputMaybe<AvatarReleaseVersion>>>;
  /** Any other value that exists and is not equal to the given value. */
  version_not?: InputMaybe<AvatarReleaseVersion>;
  /** All values that are not contained in given list. */
  version_not_in?: InputMaybe<Array<InputMaybe<AvatarReleaseVersion>>>;
};

export enum VariantReleaseOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublicFacingModelAsc = 'publicFacingModel_ASC',
  PublicFacingModelDesc = 'publicFacingModel_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  VersionAsc = 'version_ASC',
  VersionDesc = 'version_DESC',
}

export type VariantReleaseUpdateInput = {
  publicFacingModel?: InputMaybe<PublicVersion>;
  ttsModel?: InputMaybe<TtsModelUpdateOneInlineInput>;
  variants?: InputMaybe<VariantUpdateManyInlineInput>;
  version?: InputMaybe<AvatarReleaseVersion>;
};

export type VariantReleaseUpdateManyInlineInput = {
  /** Connect multiple existing VariantRelease documents */
  connect?: InputMaybe<Array<VariantReleaseConnectInput>>;
  /** Create and connect multiple VariantRelease documents */
  create?: InputMaybe<Array<VariantReleaseCreateInput>>;
  /** Delete multiple VariantRelease documents */
  delete?: InputMaybe<Array<VariantReleaseWhereUniqueInput>>;
  /** Disconnect multiple VariantRelease documents */
  disconnect?: InputMaybe<Array<VariantReleaseWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing VariantRelease documents */
  set?: InputMaybe<Array<VariantReleaseWhereUniqueInput>>;
  /** Update multiple VariantRelease documents */
  update?: InputMaybe<Array<VariantReleaseUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple VariantRelease documents */
  upsert?: InputMaybe<Array<VariantReleaseUpsertWithNestedWhereUniqueInput>>;
};

export type VariantReleaseUpdateManyInput = {
  publicFacingModel?: InputMaybe<PublicVersion>;
  version?: InputMaybe<AvatarReleaseVersion>;
};

export type VariantReleaseUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: VariantReleaseUpdateManyInput;
  /** Document search */
  where: VariantReleaseWhereInput;
};

export type VariantReleaseUpdateOneInlineInput = {
  /** Connect existing VariantRelease document */
  connect?: InputMaybe<VariantReleaseWhereUniqueInput>;
  /** Create and connect one VariantRelease document */
  create?: InputMaybe<VariantReleaseCreateInput>;
  /** Delete currently connected VariantRelease document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected VariantRelease document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single VariantRelease document */
  update?: InputMaybe<VariantReleaseUpdateWithNestedWhereUniqueInput>;
  /** Upsert single VariantRelease document */
  upsert?: InputMaybe<VariantReleaseUpsertWithNestedWhereUniqueInput>;
};

export type VariantReleaseUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: VariantReleaseUpdateInput;
  /** Unique document search */
  where: VariantReleaseWhereUniqueInput;
};

export type VariantReleaseUpsertInput = {
  /** Create document if it didn't exist */
  create: VariantReleaseCreateInput;
  /** Update document if it exists */
  update: VariantReleaseUpdateInput;
};

export type VariantReleaseUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: VariantReleaseUpsertInput;
  /** Unique document search */
  where: VariantReleaseWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type VariantReleaseWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type VariantReleaseWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VariantReleaseWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VariantReleaseWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VariantReleaseWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<VariantReleaseWhereStageInput>;
  documentInStages_none?: InputMaybe<VariantReleaseWhereStageInput>;
  documentInStages_some?: InputMaybe<VariantReleaseWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publicFacingModel?: InputMaybe<PublicVersion>;
  /** All values that are contained in given list. */
  publicFacingModel_in?: InputMaybe<Array<InputMaybe<PublicVersion>>>;
  /** Any other value that exists and is not equal to the given value. */
  publicFacingModel_not?: InputMaybe<PublicVersion>;
  /** All values that are not contained in given list. */
  publicFacingModel_not_in?: InputMaybe<Array<InputMaybe<PublicVersion>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  ttsModel?: InputMaybe<TtsModelWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  updatedBy?: InputMaybe<UserWhereInput>;
  variants_every?: InputMaybe<VariantWhereInput>;
  variants_none?: InputMaybe<VariantWhereInput>;
  variants_some?: InputMaybe<VariantWhereInput>;
  version?: InputMaybe<AvatarReleaseVersion>;
  /** All values that are contained in given list. */
  version_in?: InputMaybe<Array<InputMaybe<AvatarReleaseVersion>>>;
  /** Any other value that exists and is not equal to the given value. */
  version_not?: InputMaybe<AvatarReleaseVersion>;
  /** All values that are not contained in given list. */
  version_not_in?: InputMaybe<Array<InputMaybe<AvatarReleaseVersion>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type VariantReleaseWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VariantReleaseWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VariantReleaseWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VariantReleaseWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<VariantReleaseWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References VariantRelease record uniquely */
export type VariantReleaseWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type VariantUpdateInput = {
  avatar?: InputMaybe<AvatarUpdateOneInlineInput>;
  avatarVariantId?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  localeEnum?: InputMaybe<LocaleEnum>;
  localeEnum_V2?: InputMaybe<LocaleEnum_V2>;
  preview?: InputMaybe<AssetUpdateOneInlineInput>;
  releases?: InputMaybe<VariantReleaseUpdateManyInlineInput>;
  style?: InputMaybe<AvatarVariantStyleUpdateOneInlineInput>;
  tags?: InputMaybe<AvatarTaggingAttributeUpdateManyInlineInput>;
};

export type VariantUpdateManyInlineInput = {
  /** Connect multiple existing Variant documents */
  connect?: InputMaybe<Array<VariantConnectInput>>;
  /** Create and connect multiple Variant documents */
  create?: InputMaybe<Array<VariantCreateInput>>;
  /** Delete multiple Variant documents */
  delete?: InputMaybe<Array<VariantWhereUniqueInput>>;
  /** Disconnect multiple Variant documents */
  disconnect?: InputMaybe<Array<VariantWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Variant documents */
  set?: InputMaybe<Array<VariantWhereUniqueInput>>;
  /** Update multiple Variant documents */
  update?: InputMaybe<Array<VariantUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Variant documents */
  upsert?: InputMaybe<Array<VariantUpsertWithNestedWhereUniqueInput>>;
};

export type VariantUpdateManyInput = {
  avatarVariantId?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  localeEnum?: InputMaybe<LocaleEnum>;
  localeEnum_V2?: InputMaybe<LocaleEnum_V2>;
};

export type VariantUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: VariantUpdateManyInput;
  /** Document search */
  where: VariantWhereInput;
};

export type VariantUpdateOneInlineInput = {
  /** Connect existing Variant document */
  connect?: InputMaybe<VariantWhereUniqueInput>;
  /** Create and connect one Variant document */
  create?: InputMaybe<VariantCreateInput>;
  /** Delete currently connected Variant document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Variant document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Variant document */
  update?: InputMaybe<VariantUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Variant document */
  upsert?: InputMaybe<VariantUpsertWithNestedWhereUniqueInput>;
};

export type VariantUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: VariantUpdateInput;
  /** Unique document search */
  where: VariantWhereUniqueInput;
};

export type VariantUpsertInput = {
  /** Create document if it didn't exist */
  create: VariantCreateInput;
  /** Update document if it exists */
  update: VariantUpdateInput;
};

export type VariantUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: VariantUpsertInput;
  /** Unique document search */
  where: VariantWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type VariantWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type VariantWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VariantWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VariantWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VariantWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<AvatarWhereInput>;
  avatarVariantId?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  avatarVariantId_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  avatarVariantId_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  avatarVariantId_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  avatarVariantId_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  avatarVariantId_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  avatarVariantId_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  avatarVariantId_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['Int']['input']>>
  >;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<VariantWhereStageInput>;
  documentInStages_none?: InputMaybe<VariantWhereStageInput>;
  documentInStages_some?: InputMaybe<VariantWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isArchived_not?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  localeEnum?: InputMaybe<LocaleEnum>;
  localeEnum_V2?: InputMaybe<LocaleEnum_V2>;
  /** All values that are contained in given list. */
  localeEnum_V2_in?: InputMaybe<Array<InputMaybe<LocaleEnum_V2>>>;
  /** Any other value that exists and is not equal to the given value. */
  localeEnum_V2_not?: InputMaybe<LocaleEnum_V2>;
  /** All values that are not contained in given list. */
  localeEnum_V2_not_in?: InputMaybe<Array<InputMaybe<LocaleEnum_V2>>>;
  /** All values that are contained in given list. */
  localeEnum_in?: InputMaybe<Array<InputMaybe<LocaleEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  localeEnum_not?: InputMaybe<LocaleEnum>;
  /** All values that are not contained in given list. */
  localeEnum_not_in?: InputMaybe<Array<InputMaybe<LocaleEnum>>>;
  preview?: InputMaybe<AssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  publishedBy?: InputMaybe<UserWhereInput>;
  releases_every?: InputMaybe<VariantReleaseWhereInput>;
  releases_none?: InputMaybe<VariantReleaseWhereInput>;
  releases_some?: InputMaybe<VariantReleaseWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  style?: InputMaybe<AvatarVariantStyleWhereInput>;
  tags_every?: InputMaybe<AvatarTaggingAttributeWhereInput>;
  tags_none?: InputMaybe<AvatarTaggingAttributeWhereInput>;
  tags_some?: InputMaybe<AvatarTaggingAttributeWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type VariantWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VariantWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VariantWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VariantWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<VariantWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Variant record uniquely */
export type VariantWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Version = {
  __typename?: 'Version';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  revision: Scalars['Int']['output'];
  stage: Stage;
};

export type VersionWhereInput = {
  id: Scalars['ID']['input'];
  revision: Scalars['Int']['input'];
  stage: Stage;
};

export enum _FilterKind {
  And = 'AND',
  Not = 'NOT',
  Or = 'OR',
  Contains = 'contains',
  ContainsAll = 'contains_all',
  ContainsNone = 'contains_none',
  ContainsSome = 'contains_some',
  DescendantsOf = 'descendants_of',
  EndsWith = 'ends_with',
  Eq = 'eq',
  EqNot = 'eq_not',
  Gt = 'gt',
  Gte = 'gte',
  In = 'in',
  JsonPathExists = 'json_path_exists',
  JsonValueRecursive = 'json_value_recursive',
  Lt = 'lt',
  Lte = 'lte',
  NotContains = 'not_contains',
  NotEndsWith = 'not_ends_with',
  NotIn = 'not_in',
  NotStartsWith = 'not_starts_with',
  RelationalEvery = 'relational_every',
  RelationalNone = 'relational_none',
  RelationalSingle = 'relational_single',
  RelationalSome = 'relational_some',
  Search = 'search',
  StartsWith = 'starts_with',
  UnionEmpty = 'union_empty',
  UnionEvery = 'union_every',
  UnionNone = 'union_none',
  UnionSingle = 'union_single',
  UnionSome = 'union_some',
}

export enum _MutationInputFieldKind {
  Enum = 'enum',
  Relation = 'relation',
  RichText = 'richText',
  RichTextWithEmbeds = 'richTextWithEmbeds',
  Scalar = 'scalar',
  Union = 'union',
  Virtual = 'virtual',
}

export enum _MutationKind {
  Create = 'create',
  Delete = 'delete',
  DeleteMany = 'deleteMany',
  Publish = 'publish',
  PublishMany = 'publishMany',
  SchedulePublish = 'schedulePublish',
  ScheduleUnpublish = 'scheduleUnpublish',
  Unpublish = 'unpublish',
  UnpublishMany = 'unpublishMany',
  Update = 'update',
  UpdateMany = 'updateMany',
  Upsert = 'upsert',
}

export enum _OrderDirection {
  Asc = 'asc',
  Desc = 'desc',
}

export enum _RelationInputCardinality {
  Many = 'many',
  One = 'one',
}

export enum _RelationInputKind {
  Create = 'create',
  Update = 'update',
}

export enum _RelationKind {
  Regular = 'regular',
  Union = 'union',
}

export enum _SystemDateTimeFieldVariation {
  Base = 'base',
  Combined = 'combined',
  Localization = 'localization',
}
